/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** MindboxOperationType */
  MindboxOperationType: { input: any; output: any; }
};

export type AcneCabinet = {
  __typename?: 'AcneCabinet';
  /** Unique identifier for the cabinet */
  acnecabinet_id: Scalars['Int']['output'];
  /** Street address of the cabinet */
  address?: Maybe<Scalars['String']['output']>;
  /** City where the cabinet is located */
  city?: Maybe<Scalars['String']['output']>;
  /** List of assigned doctors */
  doctors?: Maybe<Array<Maybe<Expert>>>;
  /** Date when the cabinet becomes inactive */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the cabinet is active */
  is_active: Scalars['Boolean']['output'];
  /** Geographic latitude for map positioning */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Geographic longitude for map positioning */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Contact phone number of the cabinet */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** Date when the cabinet becomes active */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Title or name of the cabinet */
  title: Scalars['String']['output'];
};

export type AcneCabinetOutput = {
  __typename?: 'AcneCabinetOutput';
  items?: Maybe<Array<Maybe<AcneCabinet>>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

export type AcneSchool = {
  __typename?: 'AcneSchool';
  /** Unique identifier for the school */
  acneschool_id: Scalars['Int']['output'];
  /** City where the cabinet is located */
  city?: Maybe<Scalars['String']['output']>;
  /** Date when the school becomes inactive */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the school is active */
  is_active: Scalars['Boolean']['output'];
  /** Link of the school calendar */
  link?: Maybe<Scalars['String']['output']>;
  /** Date when the school becomes active */
  start_date?: Maybe<Scalars['String']['output']>;
};

export type AcneSchoolOutput = {
  __typename?: 'AcneSchoolOutput';
  items?: Maybe<Array<Maybe<AcneSchool>>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput';
  /** The cart after products have been added. */
  cart: Cart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<Error>>;
};

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input'];
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToNewCartOutput = {
  __typename?: 'AddProductsToNewCartOutput';
  /** The cart after products have been added. */
  cart?: Maybe<Cart>;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors?: Maybe<Array<Maybe<CartUserInputError>>>;
};

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput';
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput';
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<WishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean']['output'];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

export enum AddressTypeEnum {
  Personal = 'PERSONAL',
  PickupPoint = 'PICKUP_POINT'
}

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Hide in the side filters. */
  hide_in_side_filters?: Maybe<Scalars['Boolean']['output']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
  /** Participates in the selection of care. */
  participates_in_care_selection?: Maybe<Scalars['Boolean']['output']>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>;
};

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Minimum value */
  from?: Maybe<Scalars['Float']['output']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>;
  /** Maximum value */
  to?: Maybe<Scalars['Float']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>;
};

export type ApplePayConfig = PaymentConfigItem & {
  __typename?: 'ApplePayConfig';
  /** The styles for the ApplePay Smart Button configuration */
  button_styles?: Maybe<ButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Apple Pay inputs */
export type ApplePayMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars['String']['input']>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars['String']['input']>;
};

export enum ApplicationFrequencyEnum {
  MoreThanFourTimesADay = 'MORE_THAN_FOUR_TIMES_A_DAY',
  OnceADay = 'ONCE_A_DAY',
  ThreeTimesADay = 'THREE_TIMES_A_DAY',
  TwiceADay = 'TWICE_A_DAY'
}

/** Contains the applied certificate with applied and remaining balance */
export type AppliedCertificate = {
  __typename?: 'AppliedCertificate';
  /** Applied balance to the current cart */
  applied_balance?: Maybe<Money>;
  /** Certificate account code */
  code?: Maybe<Scalars['String']['output']>;
  /** Current balance remaining on certificate */
  current_balance?: Maybe<Money>;
  /** Certificate expiration date */
  expiration_date?: Maybe<Scalars['String']['output']>;
};

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String']['output'];
};

/** Specifies the bonus points amount to apply to the cart. */
export type ApplyBonusPointsToCartInput = {
  /** A bonus points to spent */
  bonus_points: Scalars['Float']['input'];
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains details about the cart after applying a bonus points. */
export type ApplyBonusPointsToCartOutput = {
  __typename?: 'ApplyBonusPointsToCartOutput';
  /** The cart after applying a bonus points. */
  cart: Cart;
};

/** Defines the input required to run the applyCertificateToCart mutation */
export type ApplyCertificateToCartInput = {
  /** The unique ID that identifies the customer's cart */
  cart_id: Scalars['String']['input'];
  /** The certificate code to be applied to the cart */
  certificate: Scalars['String']['input'];
};

/** Defines the possible output for the applyCertificateToCart mutation */
export type ApplyCertificateToCartOutput = {
  __typename?: 'ApplyCertificateToCartOutput';
  /** Describes the contents of the specified shopping cart */
  cart: Cart;
};

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** A valid coupon code. */
  coupon_code: Scalars['String']['input'];
};

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  /** The cart after applying a coupon. */
  cart: Cart;
};

/** AreaInput defines the parameters which will be used for filter by specified location. */
export type AreaInput = {
  /** The radius for the search in KM. */
  radius: Scalars['Int']['input'];
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String']['input'];
};

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  __typename?: 'AssignCompareListToCustomerOutput';
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean']['output'];
};

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']['output']>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>;
};

/** List of all entity types. Populated by the modules introducing EAV entities. */
export enum AttributeEntityTypeEnum {
  CatalogCategory = 'CATALOG_CATEGORY',
  CatalogProduct = 'CATALOG_PRODUCT',
  Customer = 'CUSTOMER',
  CustomerAddress = 'CUSTOMER_ADDRESS'
}

/** An input object that specifies the filters used for attributes. */
export type AttributeFilterInput = {
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** EAV attribute frontend input types. */
export enum AttributeFrontendInputEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  File = 'FILE',
  Gallery = 'GALLERY',
  Hidden = 'HIDDEN',
  Image = 'IMAGE',
  MediaImage = 'MEDIA_IMAGE',
  Multiline = 'MULTILINE',
  Multiselect = 'MULTISELECT',
  Price = 'PRICE',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Undefined = 'UNDEFINED',
  Weight = 'WEIGHT'
}

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']['input']>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies selected option for a select or multiselect attribute value. */
export type AttributeInputSelectedOption = {
  /** The attribute option value. */
  value: Scalars['String']['input'];
};

/** Base EAV implementation of CustomAttributeMetadataInterface. */
export type AttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'AttributeMetadata';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID']['output'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean']['output'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean']['output'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']['output']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
};

/** Attribute metadata retrieval error. */
export type AttributeMetadataError = {
  __typename?: 'AttributeMetadataError';
  /** Attribute metadata retrieval error message. */
  message: Scalars['String']['output'];
  /** Attribute metadata retrieval error type. */
  type: AttributeMetadataErrorType;
};

/** Attribute metadata retrieval error types. */
export enum AttributeMetadataErrorType {
  /** The requested attribute was not found. */
  AttributeNotFound = 'ATTRIBUTE_NOT_FOUND',
  /** The requested entity was not found. */
  EntityNotFound = 'ENTITY_NOT_FOUND',
  /** The filter cannot be applied as it does not belong to the entity */
  FilterNotFound = 'FILTER_NOT_FOUND',
  /** Not categorized error, see the error message. */
  Undefined = 'UNDEFINED'
}

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute option value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Base EAV implementation of CustomAttributeOptionInterface. */
export type AttributeOptionMetadata = CustomAttributeOptionInterface & {
  __typename?: 'AttributeOptionMetadata';
  /** Is the option value default. */
  is_default: Scalars['Boolean']['output'];
  /** The label assigned to the attribute option. */
  label: Scalars['String']['output'];
  /** The attribute option value. */
  value: Scalars['String']['output'];
};

export type AttributeSelectedColorfulOption = AttributeSelectedOptionInterface & {
  __typename?: 'AttributeSelectedColorfulOption';
  /** Option Color */
  color?: Maybe<Scalars['String']['output']>;
  /** The attribute selected option label. */
  label: Scalars['String']['output'];
  /** Option URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The attribute selected option value. */
  value: Scalars['String']['output'];
};

export type AttributeSelectedColorfulOptions = AttributeValueInterface & {
  __typename?: 'AttributeSelectedColorfulOptions';
  /** The attribute code. */
  code: Scalars['ID']['output'];
  selected_options: Array<Maybe<AttributeSelectedColorfulOption>>;
};

export type AttributeSelectedOption = AttributeSelectedOptionInterface & {
  __typename?: 'AttributeSelectedOption';
  /** The attribute selected option label. */
  label: Scalars['String']['output'];
  /** The attribute selected option value. */
  value: Scalars['String']['output'];
};

export type AttributeSelectedOptionInterface = {
  /** The attribute selected option label. */
  label: Scalars['String']['output'];
  /** The attribute selected option value. */
  value: Scalars['String']['output'];
};

export type AttributeSelectedOptions = AttributeValueInterface & {
  __typename?: 'AttributeSelectedOptions';
  /** The attribute code. */
  code: Scalars['ID']['output'];
  selected_options: Array<Maybe<AttributeSelectedOptionInterface>>;
};

export type AttributeValue = AttributeValueInterface & {
  __typename?: 'AttributeValue';
  /** The attribute code. */
  code: Scalars['ID']['output'];
  /** The attribute value. */
  value: Scalars['String']['output'];
};

/** Specifies the value for attribute. */
export type AttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars['String']['input'];
  /** An array containing selected options for a select or multiselect attribute. */
  selected_options?: InputMaybe<Array<InputMaybe<AttributeInputSelectedOption>>>;
  /** The value assigned to the attribute. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeValueInterface = {
  /** The attribute code. */
  code: Scalars['ID']['output'];
};

/** Metadata of EAV attributes associated to form */
export type AttributesFormOutput = {
  __typename?: 'AttributesFormOutput';
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<CustomAttributeMetadataInterface>>;
};

/** Metadata of EAV attributes. */
export type AttributesMetadataOutput = {
  __typename?: 'AttributesMetadataOutput';
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<CustomAttributeMetadataInterface>>;
};

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  /** Liability Shift */
  liability_shift?: Maybe<LiabilityShift>;
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code. */
  code: Scalars['String']['output'];
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean']['output'];
  /** The payment method title. */
  title: Scalars['String']['output'];
};

export type AvailablePromoCode = {
  __typename?: 'AvailablePromoCode';
  /** Promo action avaliavle date */
  available_date?: Maybe<Scalars['String']['output']>;
  /** Coupon code */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** Promo action description */
  description?: Maybe<Scalars['String']['output']>;
  /** Promo action name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean']['output'];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String']['output'];
  day_from?: Maybe<Scalars['String']['output']>;
  day_to?: Maybe<Scalars['String']['output']>;
  delivery_date_from?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']['output']>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']['output']>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

export type BannerData = {
  __typename?: 'BannerData';
  /** Banner Color */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Banner URL (whole banner is clickable) */
  banner_link?: Maybe<Scalars['String']['output']>;
  /** Button Display */
  button_display?: Maybe<ButtonDisplayEnum>;
  /** Button Position */
  button_position?: Maybe<ButtonPositionEnum>;
  /** Button Text */
  button_text?: Maybe<Scalars['String']['output']>;
  /** Banner Counter */
  counter?: Maybe<Scalars['String']['output']>;
  /** Desktop Image URL */
  desktop_image?: Maybe<Scalars['String']['output']>;
  /** Desktop Image Alt */
  desktop_image_alt?: Maybe<Scalars['String']['output']>;
  /** Desktop Video URL */
  desktop_video?: Maybe<Scalars['String']['output']>;
  /** Disclaimer Text */
  disclaimer_text?: Maybe<Scalars['String']['output']>;
  /** Discount Label */
  discount_label?: Maybe<Scalars['String']['output']>;
  /** Slider Display Type */
  display_type?: Maybe<SliderDisplayTypeEnum>;
  /** Erid */
  erid?: Maybe<Scalars['String']['output']>;
  /** First CTA URL */
  first_link?: Maybe<Scalars['String']['output']>;
  /** First CTA Label */
  first_link_label?: Maybe<Scalars['String']['output']>;
  /** Open First CTA Link in New Tab */
  first_link_new_tab: Scalars['Boolean']['output'];
  /** Banner Footnote */
  footnote?: Maybe<Scalars['String']['output']>;
  /** Height */
  height?: Maybe<Scalars['Int']['output']>;
  /** Highlight with color */
  highlight_with_color?: Maybe<Scalars['Boolean']['output']>;
  /** Banner information */
  information?: Maybe<Scalars['String']['output']>;
  /** Banner information second line */
  information_second_line?: Maybe<Scalars['String']['output']>;
  /** Banner Large Text */
  large_text?: Maybe<Scalars['String']['output']>;
  /** Is Lazy Load */
  lazy_load?: Maybe<Scalars['Boolean']['output']>;
  /** Mobile Image URL */
  mobile_image?: Maybe<Scalars['String']['output']>;
  /** Mobile Image Alt */
  mobile_image_alt?: Maybe<Scalars['String']['output']>;
  /** Mobile Video URL */
  mobile_video?: Maybe<Scalars['String']['output']>;
  /** Open in New Tab */
  open_in_new_tab: Scalars['Boolean']['output'];
  /** Position on the Page */
  pdp_position?: Maybe<PagePosition>;
  /** Second CTA URL */
  second_link?: Maybe<Scalars['String']['output']>;
  /** Second CTA Label */
  second_link_label?: Maybe<Scalars['String']['output']>;
  /** Open Second CTA Link in New Tab */
  second_link_new_tab: Scalars['Boolean']['output'];
  /** 'Show All' URL */
  show_all_link?: Maybe<Scalars['String']['output']>;
  /** Banner Size */
  size?: Maybe<BannerSize>;
  /** Slide Speed */
  slide_speed?: Maybe<Scalars['Int']['output']>;
  /** Slides to Display */
  slides_to_display?: Maybe<Scalars['Float']['output']>;
  /** Slides to Display on Mobile */
  slides_to_display_mobile?: Maybe<Scalars['Float']['output']>;
  /** Slides to Display on Tablet */
  slides_to_display_tablet?: Maybe<Scalars['Float']['output']>;
  /** Slides to Scroll */
  slides_to_scroll?: Maybe<Scalars['Int']['output']>;
  /** Slides to Scroll on Mobile */
  slides_to_scroll_mobile?: Maybe<Scalars['Int']['output']>;
  /** Slides to Scroll on Tablet */
  slides_to_scroll_tablet?: Maybe<Scalars['Int']['output']>;
  /** Banner Small Text */
  small_text?: Maybe<Scalars['String']['output']>;
  /** Tablet Image URL */
  tablet_image?: Maybe<Scalars['String']['output']>;
  /** Tablet Image Alt */
  tablet_image_alt?: Maybe<Scalars['String']['output']>;
  /** Tablet Video URL */
  tablet_video?: Maybe<Scalars['String']['output']>;
  /** Banner Text Position */
  text_position?: Maybe<BannerTextPositionEnum>;
  /** Banner Theme */
  theme?: Maybe<BannerThemeEnum>;
  /** Banner Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Width */
  width?: Maybe<Scalars['Int']['output']>;
};

export enum BannerDeviceTypeEnum {
  All = 'ALL',
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

export type BannerEntity = {
  __typename?: 'BannerEntity';
  /** Banner Data */
  banner_data: BannerData;
  /** Banner Type, or null if it is a slider */
  banner_type?: Maybe<BannerTypeEnum>;
  /** Child items, if any */
  children: Array<Maybe<Scalars['ID']['output']>>;
  /** Display on Devices */
  device_type: Array<Maybe<BannerDeviceTypeEnum>>;
  /** Entity Type: Banner or Slider */
  entity_type: BannerEntityTypeEnum;
  /** Banner ID */
  id: Scalars['ID']['output'];
  /** Display Banner From Datetime */
  show_from?: Maybe<Scalars['String']['output']>;
  /** Display Banner To Datetime */
  show_to?: Maybe<Scalars['String']['output']>;
  /** Slug */
  slug: Scalars['String']['output'];
};

export enum BannerEntityTypeEnum {
  Banner = 'BANNER',
  Slider = 'SLIDER'
}

export type BannerInListing = {
  __typename?: 'BannerInListing';
  /** Banner itself */
  entity: BannerEntity;
  /** Position, starting with 1 */
  position: Scalars['Int']['output'];
};

export type BannerInSidebar = {
  __typename?: 'BannerInSidebar';
  /** Banner itself */
  entity: BannerEntity;
};

export type BannerOnTop = {
  __typename?: 'BannerOnTop';
  /** Banner itself */
  entity: BannerEntity;
  /** If banner is a child of a slider, this field is false. Otherwise is true. */
  visible_individually: Scalars['Boolean']['output'];
};

export enum BannerSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export enum BannerTextPositionEnum {
  Center = 'CENTER',
  Down = 'DOWN',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export enum BannerThemeEnum {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum BannerTypeEnum {
  BannerArrow = 'BANNER_ARROW',
  CounterBanner = 'COUNTER_BANNER',
  LargeBanner = 'LARGE_BANNER',
  ListingBanner = 'LISTING_BANNER',
  MainBanner = 'MAIN_BANNER',
  SidebarBanner = 'SIDEBAR_BANNER',
  SliderItem = 'SLIDER_ITEM',
  TileBanner = 'TILE_BANNER',
  VideoBanner = 'VIDEO_BANNER'
}

export enum BatchMutationStatus {
  Failure = 'FAILURE',
  MixedResults = 'MIXED_RESULTS',
  Success = 'SUCCESS'
}

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The billing address information */
export type BillingAddressPaymentSourceInput = {
  /** The first line of the address */
  address_line_1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address */
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country of the address */
  country_code: Scalars['String']['input'];
  /** The postal code of the address */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** The region of the address */
  region?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']['output']>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** Id of the customer address. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

export type BlogComment = {
  __typename?: 'BlogComment';
  /** Comment Id. */
  comment_id?: Maybe<Scalars['ID']['output']>;
  /** Comment text. */
  content?: Maybe<Scalars['String']['output']>;
  /** Created at. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the post. */
  post_id?: Maybe<Scalars['Int']['output']>;
  /** Rating. */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Customer name. */
  user_name?: Maybe<Scalars['String']['output']>;
};

/** An input object for create a blog comment. */
export type BlogCommentCreateInput = {
  /** Comment text. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** An ID that uniquely identifies the post. */
  post_id: Scalars['Int']['input'];
  /** Rating. */
  rating: Scalars['Int']['input'];
  /** Customer name. */
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** Contains an array of blog comments. */
export type BlogComments = {
  __typename?: 'BlogComments';
  /** An array of  blog comment. */
  items: Array<Maybe<BlogComment>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
  /** Comments total count. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum BlogEntityTypeEnum {
  Article = 'ARTICLE',
  ExpertVideo = 'EXPERT_VIDEO',
  News = 'NEWS'
}

export type BlogTextProduct = {
  __typename?: 'BlogTextProduct';
  /** Text index. */
  index: Scalars['Int']['output'];
  /** Product items. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

export enum BrandEnum {
  Bioderma = 'bioderma',
  Esthederm = 'esthederm',
  EtatPur = 'etat_pur'
}

/** Brand filter. */
export type BrandFilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<BrandEnum>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<BrandEnum>>>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']['output']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID']['output'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']['output']>;
};

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem';
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem';
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']['output']>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']['output']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID']['output'];
};

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int']['input'];
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float']['input'];
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem';
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The SKU of parent product. */
  parent_sku?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'BundleProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamic SKU. */
  dynamic_sku?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The price details of the main product */
  price_details?: Maybe<PriceDetails>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem';
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

export enum ButtonDisplayEnum {
  OnTopWithoutBackground = 'ON_TOP_WITHOUT_BACKGROUND',
  OnTopWithBackground = 'ON_TOP_WITH_BACKGROUND',
  Side = 'SIDE'
}

export enum ButtonPositionEnum {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ButtonStyles = {
  __typename?: 'ButtonStyles';
  /** The button color */
  color?: Maybe<Scalars['String']['output']>;
  /** The button height in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** The button label */
  label?: Maybe<Scalars['String']['output']>;
  /** The button layout */
  layout?: Maybe<Scalars['String']['output']>;
  /** The button shape */
  shape?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the tagline is displayed */
  tagline?: Maybe<Scalars['Boolean']['output']>;
  /** Defines if the button uses default height. If the value is false, the value of height is used */
  use_default_height?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelOrderError = {
  __typename?: 'CancelOrderError';
  /** An error code that is specific to cancel order. */
  code: CancelOrderErrorCode;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

export enum CancelOrderErrorCode {
  InvalidOrderStatus = 'INVALID_ORDER_STATUS',
  OrderCancellationDisabled = 'ORDER_CANCELLATION_DISABLED',
  OrderNotFound = 'ORDER_NOT_FOUND',
  PartialOrderItemShipped = 'PARTIAL_ORDER_ITEM_SHIPPED',
  Unauthorised = 'UNAUTHORISED',
  Undefined = 'UNDEFINED'
}

/** Defines the order to cancel. */
export type CancelOrderInput = {
  /** The unique ID of an `Order` type. */
  order_id: Scalars['ID']['input'];
  /** Cancellation reason. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Contains the updated customer order and error message if any. */
export type CancelOrderOutput = {
  __typename?: 'CancelOrderOutput';
  /** Error encountered while cancelling the order. */
  error?: Maybe<Scalars['String']['output']>;
  errorV2?: Maybe<CancelOrderError>;
  /** Updated customer order. */
  order?: Maybe<CustomerOrder>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  description: Scalars['String']['output'];
};

export type Card = {
  __typename?: 'Card';
  /** Authentication result */
  authentication_result?: Maybe<AuthenticationResult>;
  /** Card bin details */
  bin_details?: Maybe<CardBin>;
  /** Expiration month of the card */
  card_expiry_month?: Maybe<Scalars['String']['output']>;
  /** Expiration year of the card */
  card_expiry_year?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the card */
  last_digits?: Maybe<Scalars['String']['output']>;
  /** Name on the card */
  name?: Maybe<Scalars['String']['output']>;
};

export type CardBin = {
  __typename?: 'CardBin';
  /** Card bin number */
  bin?: Maybe<Scalars['String']['output']>;
};

/** The card payment source information */
export type CardPaymentSourceInput = {
  /** The billing address of the card */
  billing_address: BillingAddressPaymentSourceInput;
  /** The name on the cardholder */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The card payment source information */
export type CardPaymentSourceOutput = {
  __typename?: 'CardPaymentSourceOutput';
  /** The brand of the card */
  brand?: Maybe<Scalars['String']['output']>;
  /** The expiry of the card */
  expiry?: Maybe<Scalars['String']['output']>;
  /** The last digits of the card */
  last_digits?: Maybe<Scalars['String']['output']>;
};

export type CareItem = {
  __typename?: 'CareItem';
  actual_frequency?: Maybe<ApplicationFrequencyEnum>;
  actual_weekdays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  name: Scalars['String']['output'];
  type: CareTypeEnum;
};

export type CareItemInput = {
  actual_frequency: ApplicationFrequencyEnum;
  actual_weekdays: Array<InputMaybe<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  type: CareTypeEnum;
};

export enum CareTypeEnum {
  Cleansing = 'CLEANSING',
  Moisturizing = 'MOISTURIZING',
  Repairing = 'REPAIRING'
}

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart';
  /** Contains the code attribute, which specifies the applied certificate codes */
  applied_certificates?: Maybe<Array<Maybe<AppliedCertificate>>>;
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>;
  /** Certificates Amount */
  certificates_amount?: Maybe<Money>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']['output']>;
  free_shipping_by_coupon?: Maybe<Scalars['Boolean']['output']>;
  /** The entered gift message for the cart */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean']['output'];
  /**
   * An array of products that have been added to the cart.
   * @deprecated Use `itemsV2` instead.
   */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  itemsV2?: Maybe<CartItems>;
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>;
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  /** Information about total points, available amount to current cart and spent bonuses for current cart. */
  total_bonus_points_info?: Maybe<TotalBonusPointsInfo>;
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float']['output'];
};


/** Contains the contents and other details about a guest or customer cart. */
export type CartItemsV2Args = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuoteItemsSortInput>;
};

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  /** The country code. */
  code: Scalars['String']['output'];
  /** The display label for the country. */
  label: Scalars['String']['output'];
};

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['input'];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String']['input'];
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['input'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['input'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']['input']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']['input']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']['input']>;
};

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** Id of the customer address. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  /** The state or province code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The display label for the region. */
  label?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount';
  /** The amount of the discount applied to the item. */
  amount: Money;
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']['output']>>;
};

export enum CartDiscountType {
  Item = 'ITEM',
  Shipping = 'SHIPPING'
}

export type CartGiftRule = {
  __typename?: 'CartGiftRule';
  /** Maximum allowed gifts quantity for this rule */
  max_gifts_qty: Scalars['Int']['output'];
  /** Rule ID */
  rule_id: Scalars['Int']['output'];
  /** Quantity of already selected gifts for this rule */
  selected_gifts_qty: Scalars['Int']['output'];
};

export type CartGiftRulesOutput = {
  __typename?: 'CartGiftRulesOutput';
  /** SKUs of all available gift products */
  products_skus: Array<Maybe<Scalars['String']['output']>>;
  /** List of gift rules */
  rules: Array<Maybe<CartGiftRule>>;
};

export type CartItemError = {
  __typename?: 'CartItemError';
  /** An error code that describes the error encountered */
  code: CartItemErrorType;
  /** A localized error message */
  message: Scalars['String']['output'];
};

export enum CartItemErrorType {
  ItemIncrements = 'ITEM_INCREMENTS',
  ItemQty = 'ITEM_QTY',
  Undefined = 'UNDEFINED'
}

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** The amount or number of an item to add. */
  quantity: Scalars['Float']['input'];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The SKU of the product. */
  sku: Scalars['String']['input'];
};

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** The price discount for the unit price of the item represents the difference between its regular price and final price. */
  catalog_discount?: Maybe<ProductDiscount>;
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The value of the original unit price for the item, including discounts. */
  original_item_price: Money;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The price discount multiplied by the item quantity represents the total difference between the regular price and the final price for the entire quote item. */
  row_catalog_discount?: Maybe<ProductDiscount>;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int']['output'];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float']['output'];
};

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars['String']['output'];
  /** A price value. */
  value: Scalars['Float']['output'];
};

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type CartItems = {
  __typename?: 'CartItems';
  /** An array of products that have been added to the cart. */
  items: Array<Maybe<CartItemInterface>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of returned cart items. */
  total_count: Scalars['Int']['output'];
};

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices';
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>;
  /** The total of the cart, including discounts, shipping, and other fees without tax. */
  grand_total_excluding_tax?: Maybe<Money>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The description of the tax. */
  label: Scalars['String']['output'];
};

export type CartUserInputError = Error & {
  __typename?: 'CartUserInputError';
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

export enum CartUserInputErrorType {
  CouldNotFindCartItem = 'COULD_NOT_FIND_CART_ITEM',
  InsufficientStock = 'INSUFFICIENT_STOCK',
  InvalidParameterValue = 'INVALID_PARAMETER_VALUE',
  NotSalable = 'NOT_SALABLE',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  RequiredParameterMissing = 'REQUIRED_PARAMETER_MISSING',
  Undefined = 'UNDEFINED'
}

export enum CatalogAttributeApplyToEnum {
  Bundle = 'BUNDLE',
  Category = 'CATEGORY',
  Configurable = 'CONFIGURABLE',
  Downloadable = 'DOWNLOADABLE',
  Grouped = 'GROUPED',
  Simple = 'SIMPLE',
  Virtual = 'VIRTUAL'
}

/** Swatch attribute metadata. */
export type CatalogAttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'CatalogAttributeMetadata';
  /** To which catalog types an attribute can be applied. */
  apply_to?: Maybe<Array<Maybe<CatalogAttributeApplyToEnum>>>;
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID']['output'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean']['output'];
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean']['output'];
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']['output']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
  /** Input type of the swatch attribute option. */
  swatch_input_type?: Maybe<SwatchInputTypeEnum>;
  /** Whether update product preview image or not. */
  update_product_preview_image?: Maybe<Scalars['Boolean']['output']>;
  /** Whether use product image for swatch or not. */
  use_product_image_for_swatch?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoriesFilterInput = {
  /** The category id. Customers use this name to identify the category. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the category was created */
  created_at?: InputMaybe<FilterTypeInput>;
  /** Enabled */
  enabled?: InputMaybe<FilterTypeInput>;
  /** Import Source */
  import_source?: InputMaybe<FilterTypeInput>;
  /** The Category Level */
  level?: InputMaybe<FilterTypeInput>;
  /** The category name. Customers use this name to identify the category. */
  name?: InputMaybe<FilterTypeInput>;
  /** The parent category id. Customers use this name to identify the category. */
  parent_id?: InputMaybe<FilterTypeInput>;
  /** The Category Position */
  position?: InputMaybe<FilterTypeInput>;
  /** The Store Id */
  store_ids?: InputMaybe<FilterTypeInput>;
  /** The post type */
  type?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the category was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The Category url_key */
  url_key?: InputMaybe<FilterTypeInput>;
};

export type CategoriesOutput = {
  __typename?: 'CategoriesOutput';
  /** An array of categories that match the specified search criteria */
  items?: Maybe<Array<Maybe<Category>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of categories returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CategoriesOutputNoPage = {
  __typename?: 'CategoriesOutputNoPage';
  /** An array of categories that match the specified search criteria */
  items?: Maybe<Array<Maybe<Category>>>;
  /** The number of categories returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Category = {
  __typename?: 'Category';
  /** An ID that uniquely identifies the category. */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** number of children categories. */
  children_count?: Maybe<Scalars['Int']['output']>;
  /** The color of the topic. */
  color?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the category was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a category is enabled. */
  enabled?: Maybe<Scalars['Int']['output']>;
  /** The image of the category. */
  image?: Maybe<Scalars['String']['output']>;
  /** The import source of the category. */
  import_source?: Maybe<Scalars['String']['output']>;
  /** The level of the category. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The meta description of the category. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The meta keywords of the category. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** The meta robot of the category. */
  meta_robots?: Maybe<Scalars['String']['output']>;
  /** The meta title of the category. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** An ID that identifies the parent category. */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** The path of the category. */
  path?: Maybe<Scalars['String']['output']>;
  /** The position of the category. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The post assigned to a category */
  posts?: Maybe<PostsOutputNoPage>;
  /** An ID that identifies the store. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** Post type */
  type?: Maybe<BlogEntityTypeEnum>;
  uid: Scalars['ID']['output'];
  /** Timestamp indicating when the category was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** The url key of the category. */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type CategoryBanners = {
  __typename?: 'CategoryBanners';
  /** Banners in product listing */
  listing_banners: Array<Maybe<BannerInListing>>;
  /** Banners on the sidebar of the page */
  sidebar_banners: Array<Maybe<BannerInSidebar>>;
  /** Banners on top of the page */
  top_banners: Array<Maybe<BannerOnTop>>;
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  benefits?: Maybe<Scalars['String']['output']>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** Category Banners */
  category_banners: CategoryBanners;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  color?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['String']['output']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_brand?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']['output']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  show_care_finder?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
};


/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult';
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface & RoutableInterface & {
  __typename?: 'CategoryTree';
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  benefits?: Maybe<Scalars['String']['output']>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** Category Banners */
  category_banners: CategoryBanners;
  /** A tree of child categories. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  color?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  h1?: Maybe<Scalars['String']['output']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_brand?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']['output']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  show_care_finder?: Maybe<Scalars['Int']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
};


/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about the certificate account */
export type CertificateAccount = {
  __typename?: 'CertificateAccount';
  /** Balance remaining on certificate */
  balance?: Maybe<Money>;
  /** Certificate account code */
  code?: Maybe<Scalars['String']['output']>;
  /** Certificate expiration date */
  expiration_date?: Maybe<Scalars['String']['output']>;
};

export type CertificateAccountInput = {
  /** Defines the input required to identify the certificate account */
  certificate: Scalars['String']['input'];
};

/** CertificateAmounts contains the value of a certificate, the website that generated the card, and related information */
export type CertificateAmounts = {
  __typename?: 'CertificateAmounts';
  /** An internal attribute ID. */
  attribute_id?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `CertificateAmounts` object */
  uid: Scalars['ID']['output'];
  /** The value of the certificate */
  value?: Maybe<Scalars['Float']['output']>;
  /**
   * An ID that is assigned to each unique certificate amount.
   * @deprecated Use `uid` instead
   */
  value_id?: Maybe<Scalars['Int']['output']>;
  /** ID of the website that generated the certificate */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The value of the certificate */
  website_value?: Maybe<Scalars['Float']['output']>;
};

/** Contains details about a certificate */
export type CertificateCartItem = CartItemInterface & {
  __typename?: 'CertificateCartItem';
  /** The amount and currency of the certificate */
  amount: Money;
  /** An array of customizations made to the certificate */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** Design URL */
  design_url?: Maybe<Scalars['String']['output']>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** A message to the recipient */
  message?: Maybe<Scalars['String']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The email of the person receiving the certificate */
  recipient_email?: Maybe<Scalars['String']['output']>;
  /** The name of the person receiving the certificate */
  recipient_name: Scalars['String']['output'];
  /** Send Date */
  send_date?: Maybe<Scalars['String']['output']>;
  /** The email of the sender */
  sender_email?: Maybe<Scalars['String']['output']>;
  /** The name of the sender */
  sender_name: Scalars['String']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

export type CertificateCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CertificateCreditMemoItem';
  /** Selected certificate properties for an credit memo item */
  certificate?: Maybe<CertificateItem>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

export type CertificateInvoiceItem = InvoiceItemInterface & {
  __typename?: 'CertificateInvoiceItem';
  /** Selected certificate properties for an invoice item */
  certificate?: Maybe<CertificateItem>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

export type CertificateItem = {
  __typename?: 'CertificateItem';
  /** Design URL */
  design_url?: Maybe<Scalars['String']['output']>;
  /** Entered certificate message intended for the recipient */
  message?: Maybe<Scalars['String']['output']>;
  /** Entered certificate recipient email for virtual cards */
  recipient_email?: Maybe<Scalars['String']['output']>;
  /** Entered certificate sender namefor physical and virtual cards */
  recipient_name?: Maybe<Scalars['String']['output']>;
  /** Entered certificate send date */
  send_date?: Maybe<Scalars['String']['output']>;
  /** Entered certificate sender email for virtual cards */
  sender_email?: Maybe<Scalars['String']['output']>;
  /** Entered certificate sender name for physical and virtual cards */
  sender_name?: Maybe<Scalars['String']['output']>;
};

export type CertificateOptions = {
  __typename?: 'CertificateOptions';
  /** The amount and currency of the certificate */
  amount?: Maybe<Money>;
  /** The custom amount and currency of the certificate */
  custom_certificate_amount?: Maybe<Money>;
  /** Design URL */
  design_url?: Maybe<Scalars['String']['output']>;
  /** A message to the recipient */
  message?: Maybe<Scalars['String']['output']>;
  /** The email of the person receiving the certificate */
  recipient_email?: Maybe<Scalars['String']['output']>;
  /** The name of the person receiving the certificate */
  recipient_name?: Maybe<Scalars['String']['output']>;
  /** The email of the sender */
  sender_email?: Maybe<Scalars['String']['output']>;
  /** The name of the sender */
  sender_name?: Maybe<Scalars['String']['output']>;
};

export type CertificateOrderItem = OrderItemInterface & {
  __typename?: 'CertificateOrderItem';
  /** Selected certificate properties for an order item */
  certificate?: Maybe<CertificateItem>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** CertificateProduct defines properties of a certificate, including the minimum and maximum values and an array that contains the current and past values on the specific certificate */
export type CertificateProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'CertificateProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the customer can provide a message to accompany the certificate. */
  allow_message?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether customers have the ability to set the value of the certificate. */
  allow_open_amount?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** An array that contains information about the values and ID of a certificate. */
  certificate_amounts?: Maybe<Array<Maybe<CertificateAmounts>>>;
  /** An array of certificate options. */
  certificate_options: Array<Maybe<CustomizableOptionInterface>>;
  /** Either VIRTUAL, PHYSICAL, or COMBINED. */
  certificate_type?: Maybe<CertificateTypeEnum>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the customer can redeem the value on the card for cash. */
  is_redeemable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of days after purchase until the certificate expires. A null value means there is no limit. */
  lifetime?: Maybe<Scalars['Int']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** Indicates whether the customer can provide a message to accompany the certificate. */
  message_max_length?: Maybe<Scalars['Int']['output']>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** The minimum acceptable value of an open amount certificate. */
  open_amount_max?: Maybe<Scalars['Float']['output']>;
  /** The minimum acceptable value of an open amount certificate. */
  open_amount_min?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** CertificateProduct defines properties of a certificate, including the minimum and maximum values and an array that contains the current and past values on the specific certificate */
export type CertificateProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** CertificateProduct defines properties of a certificate, including the minimum and maximum values and an array that contains the current and past values on the specific certificate */
export type CertificateProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** CertificateProduct defines properties of a certificate, including the minimum and maximum values and an array that contains the current and past values on the specific certificate */
export type CertificateProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** CertificateProduct defines properties of a certificate, including the minimum and maximum values and an array that contains the current and past values on the specific certificate */
export type CertificateProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CertificateShipmentItem = ShipmentItemInterface & {
  __typename?: 'CertificateShipmentItem';
  /** Selected certificate properties for an shipment item */
  certificate?: Maybe<CertificateItem>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** This enumeration defines the types of certificates */
export enum CertificateTypeEnum {
  Combined = 'COMBINED',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

/** A certificate product wish list item */
export type CertificateWishlistItem = WishlistItemInterface & {
  __typename?: 'CertificateWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  certificate_options: CertificateOptions;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int']['output'];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String']['output'];
  /** Required. The text of the agreement. */
  content: Scalars['String']['output'];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean']['output'];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars['String']['output'];
};

/** Indicates how agreements are accepted. */
export enum CheckoutAgreementMode {
  /** Conditions are automatically accepted upon checkout. */
  Auto = 'AUTO',
  /** Shoppers must manually accept the conditions to place an order. */
  Manual = 'MANUAL'
}

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError';
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']['output']>>;
};

export enum CheckoutUserInputErrorCodes {
  InsufficientStock = 'INSUFFICIENT_STOCK',
  NotSalable = 'NOT_SALABLE',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  ReorderNotAvailable = 'REORDER_NOT_AVAILABLE',
  Undefined = 'UNDEFINED'
}

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']['output']>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage';
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']['output']>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

export type CombinedMethodsQuestionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CombinedMethodsRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  clinic_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  /** An ID that uniquely identifies the comment. */
  comment_id?: Maybe<Scalars['Int']['output']>;
  /** The content of the comment. */
  content?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the comment was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** An ID that identifies the customer. */
  entity_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether a comment has replied. */
  has_reply?: Maybe<Scalars['Int']['output']>;
  /** The import source of the comment. */
  import_source?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a comment is replied. */
  is_reply?: Maybe<Scalars['Int']['output']>;
  /** An ID that identifies the post. */
  post_id?: Maybe<Scalars['Int']['output']>;
  /** The status of the comment. */
  status?: Maybe<Scalars['Int']['output']>;
  /** An ID that identifies the store. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** The email of the user. */
  user_email?: Maybe<Scalars['String']['output']>;
  /** The name of the user. */
  user_name?: Maybe<Scalars['String']['output']>;
};

export type CommentsFilterInput = {
  /** The comment id. Customers use this name to identify the comment. */
  comment_id?: InputMaybe<FilterTypeInput>;
  /** Customer Id the comment belongs to */
  entity_id?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the comment has reply */
  has_reply?: InputMaybe<FilterTypeInput>;
  /** Import Source */
  import_source?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the comment is reply */
  is_reply?: InputMaybe<FilterTypeInput>;
  /** Post Id the comment belongs to. */
  post_id?: InputMaybe<FilterTypeInput>;
  /** Reply Id */
  reply_id?: InputMaybe<FilterTypeInput>;
  /** Comment Status */
  status?: InputMaybe<FilterTypeInput>;
  /** Store Id */
  store_ids?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the comment was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** User Email */
  user_email?: InputMaybe<FilterTypeInput>;
  /** User Name */
  user_name?: InputMaybe<FilterTypeInput>;
};

export type CommentsOutput = {
  __typename?: 'CommentsOutput';
  /** An array of comments that match the specified search criteria */
  items?: Maybe<Array<Maybe<Comment>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of comments returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  __typename?: 'ComparableAttribute';
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String']['output'];
  /** The label of the attribute code. */
  label: Scalars['String']['output'];
};

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  __typename?: 'ComparableItem';
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>;
  /** Details about a product in a compare list. */
  product: ProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID']['output'];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  __typename?: 'CompareList';
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars['Int']['output'];
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID']['output'];
};

/** Update the quote and complete the order */
export type CompleteOrderInput = {
  /** The customer cart ID */
  cartId: Scalars['String']['input'];
  /** PayPal order ID */
  id: Scalars['String']['input'];
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** Text that can contain HTML tags. */
  html: Scalars['String']['output'];
};

export type ConfigsOutput = {
  __typename?: 'ConfigsOutput';
  /** General config. */
  general?: Maybe<General>;
  /** Seo config. */
  seo?: Maybe<Seo>;
  /** Sidebar config. */
  sidebar?: Maybe<Sidebar>;
};

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']['output']>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID']['output'];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']['output'];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']['output']>>;
};

export type ConfigurableOrderItem = OrderItemInterface & {
  __typename?: 'ConfigurableOrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The SKU of parent product. */
  parent_sku?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'ConfigurableProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** An array of options for the configurable product. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
  configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** An array of simple product variants. */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  variant_sku?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']['output'];
  /** The display name of the option. */
  label: Scalars['String']['output'];
  /** The unique ID of the configurable option. */
  uid: Scalars['ID']['output'];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue';
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean']['output'];
  /** The display name of the value. */
  label: Scalars['String']['output'];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars['ID']['output'];
};

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID']['output'];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']['output']>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID']['output'];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']['output']>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection';
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<ConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']['output']>;
  /** The label of the product. */
  label?: Maybe<Scalars['String']['output']>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']['output']>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>;
};

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String']['output'];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

export type ConfirmCancelOrderInput = {
  /** Confirmation Key to cancel the order. */
  confirmation_key: Scalars['String']['input'];
  /** The unique ID of an `Order` type. */
  order_id: Scalars['ID']['input'];
};

/** Contains details about a customer email address to confirm. */
export type ConfirmEmailInput = {
  /** The key to confirm the email address. */
  confirmation_key: Scalars['String']['input'];
  /** The email address to be confirmed. */
  email: Scalars['String']['input'];
};

/** List of account confirmation statuses. */
export enum ConfirmationStatusEnum {
  /** Account confirmation not required */
  AccountConfirmationNotRequired = 'ACCOUNT_CONFIRMATION_NOT_REQUIRED',
  /** Account confirmed */
  AccountConfirmed = 'ACCOUNT_CONFIRMED'
}

export type ContactUsInput = {
  /** The shopper's comment to the merchant. */
  comment: Scalars['String']['input'];
  /** The email address of the shopper. */
  email: Scalars['String']['input'];
  /** The full name of the shopper. */
  name: Scalars['String']['input'];
  /** The shopper's telephone number. */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

/** Contains the status of the request. */
export type ContactUsOutput = {
  __typename?: 'ContactUsOutput';
  /** Indicates whether the request was successful. */
  status: Scalars['Boolean']['output'];
};

export type Country = {
  __typename?: 'Country';
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']['output']>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']['output']>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']['output']>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']['output']>;
};

/** The list of country codes. */
export enum CountryCodeEnum {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua & Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Netherlands Antilles */
  An = 'AN',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia & Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** St. Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo-Kinshasa */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo-Brazzaville */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d’Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cape Verde */
  Cv = 'CV',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands */
  Fk = 'FK',
  /** Micronesia */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia & South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong SAR China */
  Hk = 'HK',
  /** Heard &amp; McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** St. Kitts & Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** St. Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** St. Martin */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar (Burma) */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macau SAR China */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** St. Pierre & Miquelon */
  Pm = 'PM',
  /** Pitcairn Islands */
  Pn = 'PN',
  /** Palestinian Territories */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russia */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** St. Helena */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard & Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** São Tomé & Príncipe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Syria */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks & Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad & Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** U.S. Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Vatican City */
  Va = 'VA',
  /** St. Vincent & Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** British Virgin Islands */
  Vg = 'VG',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis & Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateDiaryEntryInput = {
  care?: InputMaybe<Array<InputMaybe<CareItemInput>>>;
  doctor_visit_date?: InputMaybe<Scalars['String']['input']>;
  itch_day: Scalars['Int']['input'];
  itch_night: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poem_answers: Array<InputMaybe<PoemAnswerInput>>;
  sleep_maintenance_problems?: InputMaybe<Scalars['Int']['input']>;
  sleep_quality?: InputMaybe<Scalars['Int']['input']>;
  therapy?: InputMaybe<Array<InputMaybe<TherapyItemInput>>>;
};

export type CreateDiaryEntryResult = {
  __typename?: 'CreateDiaryEntryResult';
  entry: DiaryEntry;
  hint?: Maybe<Scalars['String']['output']>;
};

export type CreateExpertClinicInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpertInput = {
  bother?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  clinics?: InputMaybe<Array<InputMaybe<CreateExpertClinicInput>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  full_name: Scalars['String']['input'];
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keywords?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photo_alt?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  qualification?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regalia?: InputMaybe<Scalars['String']['input']>;
  seniority?: InputMaybe<Scalars['String']['input']>;
  taplink?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  url_key?: InputMaybe<Scalars['String']['input']>;
  vk?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpertOutput = {
  __typename?: 'CreateExpertOutput';
  expert?: Maybe<Expert>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateGuestCartInput = {
  /** Optional client-generated ID */
  cart_uid?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateGuestCartOutput = {
  __typename?: 'CreateGuestCartOutput';
  /** The newly created cart. */
  cart?: Maybe<Cart>;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  __typename?: 'CreatePayflowProTokenOutput';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']['output'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']['output'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']['output'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']['output'];
};

/** Contains payment order details that are used while processing the payment order */
export type CreatePaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars['String']['input'];
  /** Defines the origin location for that payment request */
  location: PaymentLocation;
  /** The code for the payment method used in the order */
  methodCode: Scalars['String']['input'];
  /** The identifiable payment source for the payment method */
  paymentSource: Scalars['String']['input'];
  /** Indicates whether the payment information should be vaulted */
  vaultIntent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains payment order details that are used while processing the payment order */
export type CreatePaymentOrderOutput = {
  __typename?: 'CreatePaymentOrderOutput';
  /** The amount of the payment order */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the payment order */
  currency_code?: Maybe<Scalars['String']['output']>;
  /** PayPal order ID */
  id?: Maybe<Scalars['String']['output']>;
  /** The order ID generated by Payment Services */
  mp_order_id?: Maybe<Scalars['String']['output']>;
  /** The status of the payment order */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** Customer Age */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** Product cons. */
  cons?: InputMaybe<Scalars['String']['input']>;
  /** Customer email */
  email: Scalars['String']['input'];
  /** Review image paths */
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is recommended product */
  is_recommended: Scalars['Boolean']['input'];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['input'];
  /** Product pros. */
  pros?: InputMaybe<Scalars['String']['input']>;
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>;
  /** Customer skin problem. */
  skin_problem?: InputMaybe<Scalars['String']['input']>;
  /** Customer skin type. */
  skin_type?: InputMaybe<Scalars['String']['input']>;
  /** The SKU of the reviewed product. */
  sku: Scalars['String']['input'];
  /** The summary (title) of the review. */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** The review text. */
  text: Scalars['String']['input'];
};

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  __typename?: 'CreateProductReviewOutput';
  /** The list of products recommended for evaluate. */
  recommend_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product review details. */
  review: ProductReview;
};


/** Contains the completed product review. */
export type CreateProductReviewOutputRecommend_ProductsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Describe the variables needed to create a vault payment token */
export type CreateVaultCardPaymentTokenInput = {
  /** Description of the vaulted card */
  card_description?: InputMaybe<Scalars['String']['input']>;
  /** The setup token obtained by the createVaultCardSetupToken endpoint */
  setup_token_id: Scalars['String']['input'];
};

/** The vault token id and information about the payment source */
export type CreateVaultCardPaymentTokenOutput = {
  __typename?: 'CreateVaultCardPaymentTokenOutput';
  /** The payment source information */
  payment_source: PaymentSourceOutput;
  /** The vault payment token information */
  vault_token_id: Scalars['String']['output'];
};

/** Describe the variables needed to create a vault card setup token */
export type CreateVaultCardSetupTokenInput = {
  /** The setup token information */
  setup_token: VaultSetupTokenInput;
  /** The 3DS mode */
  three_ds_mode?: InputMaybe<ThreeDsMode>;
};

/** The setup token id information */
export type CreateVaultCardSetupTokenOutput = {
  __typename?: 'CreateVaultCardSetupTokenOutput';
  /** The setup token id */
  setup_token: Scalars['String']['output'];
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int']['input'];
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int']['input'];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int']['input'];
  /** The credit card type. */
  cc_type: Scalars['String']['input'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']['output'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String']['output'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']['output']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes. */
export enum CurrencyEnum {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azm = 'AZM',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Buk = 'BUK',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gek = 'GEK',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gqe = 'GQE',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lsm = 'LSM',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nic = 'NIC',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Rhd = 'RHD',
  Rol = 'ROL',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Skk = 'SKK',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Std = 'STD',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmm = 'TMM',
  Tnd = 'TND',
  Top = 'TOP',
  Trl = 'TRL',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Veb = 'VEB',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Ytl = 'YTL',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zwd = 'ZWD'
}

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

/** An interface containing fields that define the EAV attribute. */
export type CustomAttributeMetadataInterface = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID']['output'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean']['output'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean']['output'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']['output']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
};

export type CustomAttributeOptionInterface = {
  /** Is the option value default. */
  is_default: Scalars['Boolean']['output'];
  /** The label assigned to the attribute option. */
  label: Scalars['String']['output'];
  /** The attribute option value. */
  value: Scalars['String']['output'];
};

export type CustomVariable = {
  __typename?: 'CustomVariable';
  /** Custom Variable Code. */
  code?: Maybe<Scalars['String']['output']>;
  /** Custom Variable Name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Custom Variable Value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** An array containing the customer's shipping and billing addresses. */
  addressesV2?: Maybe<CustomerAddresses>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars['Boolean']['output'];
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** The customer's confirmation status. */
  confirmation_status: ConfirmationStatusEnum;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Customer's custom attributes. */
  custom_attributes?: Maybe<Array<Maybe<AttributeValueInterface>>>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']['output']>;
  /** List of customer diagnostic results */
  diagnostic_results?: Maybe<Array<Maybe<DiagnosticResult>>>;
  diary_profile?: Maybe<DiaryProfile>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']['output']>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Customer loyalty program data. */
  loyalty_program?: Maybe<CustomerLoyaltyProgramOutput>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']['output']>;
  mindbox_subscriptions?: Maybe<Array<Maybe<CustomerMindboxSubscription>>>;
  orders?: Maybe<CustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** A paginated list of unique products purchased by the customer, sorted by the last order date descending. */
  purchased_products?: Maybe<Products>;
  /** The list of products recommended for evaluate. */
  recommend_for_review_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Contains the customer's product reviews. */
  reviews: ProductReviews;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']['output']>;
  /** The customer's telephone. */
  telephone?: Maybe<Scalars['String']['output']>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerAddressesV2Args = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CustomerAddressFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerCustom_AttributesArgs = {
  attributeCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerDiagnostic_ResultsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerPurchased_ProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerRecommend_For_Review_ProductsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerWishlist_V2Args = {
  id: Scalars['ID']['input'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  center_latitude?: Maybe<Scalars['String']['output']>;
  center_longitude?: Maybe<Scalars['String']['output']>;
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom_attributesV2 instead. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<AttributeValueInterface>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']['output']>;
  is_pickup?: Maybe<Scalars['String']['output']>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  nom_code?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
};


/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddressCustom_AttributesV2Args = {
  attributeCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** The value assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String']['input'];
  /** The value assigned to the attribute. */
  value: Scalars['String']['input'];
};

export type CustomerAddressFilterInput = {
  type: AddressTypeEnum;
};

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  center_latitude?: InputMaybe<Scalars['String']['input']>;
  center_longitude?: InputMaybe<Scalars['String']['input']>;
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>;
  country_id?: InputMaybe<CountryCodeEnum>;
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  is_pickup?: InputMaybe<Scalars['String']['input']>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  nom_code?: InputMaybe<Scalars['String']['input']>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The address region code. */
  region_code?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerAddresses = {
  __typename?: 'CustomerAddresses';
  /** An array containing the customer's shipping and billing addresses. */
  items?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer addresses. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Customer attribute metadata. */
export type CustomerAttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'CustomerAttributeMetadata';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID']['output'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter?: Maybe<InputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean']['output'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean']['output'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of lines of the attribute value. */
  multiline_count?: Maybe<Scalars['Int']['output']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The validation rules of the attribute value. */
  validate_rules?: Maybe<Array<Maybe<ValidationRule>>>;
};

export type CustomerBonusHistoryItem = {
  __typename?: 'CustomerBonusHistoryItem';
  /** Operation date as Unix timestamp in milliseconds. */
  activation_date?: Maybe<Scalars['String']['output']>;
  /** Added bonus amount. */
  added?: Maybe<Scalars['Int']['output']>;
  /** History item comment. */
  definition_message: Scalars['String']['output'];
  /** Bonus expiration date as Unix timestamp in milliseconds. */
  expiration_date?: Maybe<Scalars['String']['output']>;
  /** Expired or charged bonus amount. */
  expired?: Maybe<Scalars['Int']['output']>;
};

export type CustomerBonusHistoryOutput = {
  __typename?: 'CustomerBonusHistoryOutput';
  /** Bonus balance history items. */
  bonuses?: Maybe<Array<Maybe<CustomerBonusHistoryItem>>>;
};

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. */
  email: Scalars['String']['input'];
  /** The customer's first name. */
  firstname: Scalars['String']['input'];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct';
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']['output']>;
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars['String']['output']>;
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars['String']['output']>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars['String']['output']>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts';
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** Privacy Policy Agreement. */
  privacy_policy_agreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
  /** The customer's telephone. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** Terms And Conditions Agreement. */
  term_and_conditions_agreement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerLoyaltyBalance = {
  __typename?: 'CustomerLoyaltyBalance';
  available?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type CustomerLoyaltyProgramLevel = {
  __typename?: 'CustomerLoyaltyProgramLevel';
  /** Current loyalty level title. */
  current_level_title?: Maybe<Scalars['String']['output']>;
  /** Loyalty program information link. */
  loyalty_program_info_link?: Maybe<Scalars['String']['output']>;
  /** Next loyalty level description. */
  next_level_description?: Maybe<Scalars['String']['output']>;
  /** Current loyalty level profit description. */
  profit_description?: Maybe<Scalars['String']['output']>;
};

export type CustomerLoyaltyProgramOutput = {
  __typename?: 'CustomerLoyaltyProgramOutput';
  balances?: Maybe<Array<Maybe<CustomerLoyaltyBalance>>>;
  /** Available customer bonus amount. */
  bonuses?: Maybe<Scalars['Float']['output']>;
  /** Expiring bonus amount. */
  express_bonuses?: Maybe<Scalars['Float']['output']>;
  /** Expiring bonus message. */
  express_bonuses_title?: Maybe<Scalars['String']['output']>;
  /** Current loyalty program level data. */
  level?: Maybe<CustomerLoyaltyProgramLevel>;
  /** Bonus units title. */
  units?: Maybe<Scalars['String']['output']>;
};

export type CustomerMindboxSubscription = {
  __typename?: 'CustomerMindboxSubscription';
  brand?: Maybe<Scalars['String']['output']>;
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  pointOfContact?: Maybe<CustomerMindboxSubscriptionPointOfContactEnum>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type CustomerMindboxSubscriptionInput = {
  isSubscribed: Scalars['Boolean']['input'];
  pointOfContact: CustomerMindboxSubscriptionPointOfContactEnum;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerMindboxSubscriptionPointOfContactEnum {
  Email = 'EMAIL',
  MobilePush = 'MOBILE_PUSH',
  Sms = 'SMS'
}

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** Coupons applied to the order. */
  applied_coupons: Array<Maybe<AppliedCoupon>>;
  /** List of available order actions. */
  available_actions: Array<Maybe<OrderActionType>>;
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  bonus_earned_amount?: Maybe<Scalars['Float']['output']>;
  can_be_canceled?: Maybe<Scalars['Boolean']['output']>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  coupon_discount_amount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  /** Customer comment for order. */
  customer_comment?: Maybe<Scalars['String']['output']>;
  /** Returns customer information from order. */
  customer_info: OrderCustomerInfo;
  delivery_date_actual?: Maybe<Scalars['String']['output']>;
  delivery_date_from?: Maybe<Scalars['String']['output']>;
  delivery_time?: Maybe<Scalars['String']['output']>;
  /** Order customer email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The Gateway URL for payment */
  gateway_url?: Maybe<Scalars['String']['output']>;
  /** The entered gift message for the order */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']['output'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']['output']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** Is Payment Link Available */
  is_payment_link_available?: Maybe<Scalars['Boolean']['output']>;
  /** `TRUE` if the order is virtual */
  is_virtual: Scalars['Boolean']['output'];
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String']['output'];
  /** The date the order was placed. */
  order_date: Scalars['String']['output'];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String']['output'];
  /** The date the order status was last updated. */
  order_status_change_date: Scalars['String']['output'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** Payment timeout in minutes */
  payment_timeout?: Maybe<Scalars['Int']['output']>;
  pickup_address?: Maybe<DeliveryAddress>;
  /** The Gateway QR for payment */
  qr_code?: Maybe<Scalars['String']['output']>;
  /** Receipt URL */
  receipt_url?: Maybe<Scalars['String']['output']>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** The current status of the order. */
  status: Scalars['String']['output'];
  /** Order status code */
  status_code: Scalars['String']['output'];
  /** The token that can be used to retrieve the order using order query. */
  token: Scalars['String']['output'];
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum CustomerOrderSortableField {
  /** Sorts customer orders by created_at field */
  CreatedAt = 'CREATED_AT',
  /** Sorts customer orders by number */
  Number = 'NUMBER'
}

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** Date of the first order placed in the store */
  date_of_first_order?: Maybe<Scalars['String']['output']>;
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order base grand total value. */
  grand_total?: InputMaybe<FilterRangeTypeInput>;
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
  /** Filters by order created_at time. */
  order_date?: InputMaybe<FilterRangeTypeInput>;
  /** Filters by order status. */
  status?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  /** Customer details after creating or updating a customer. */
  customer: Customer;
};

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>;
};

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']['output']>;
};

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>;
};

/** Defines the customizable date type. */
export enum CustomizableDateTypeEnum {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Time = 'TIME'
}

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue';
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']['output']>;
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue';
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']['output']>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']['output']>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID']['output'];
};

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid?: InputMaybe<Scalars['ID']['input']>;
  /** The string value of the option. */
  value_string: Scalars['String']['input'];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  __typename?: 'DeleteCompareListOutput';
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean']['output'];
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean']['output'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  day_from?: Maybe<Scalars['String']['output']>;
  day_to?: Maybe<Scalars['String']['output']>;
  delivery_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nom_code?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  point_type?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  work_time?: Maybe<Scalars['String']['output']>;
};

export type Diagnostic = {
  __typename?: 'Diagnostic';
  /** Diagnostic Id */
  entity_id?: Maybe<Scalars['ID']['output']>;
  /** Diagnostic Graph */
  graph?: Maybe<Scalars['String']['output']>;
  /** Diagnostic Slug */
  slug?: Maybe<Scalars['String']['output']>;
};

export type DiagnosticResult = {
  __typename?: 'DiagnosticResult';
  /** Created at. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Customer email. */
  customer_email?: Maybe<Scalars['String']['output']>;
  /** Customer id */
  customer_id?: Maybe<Scalars['String']['output']>;
  /** Customer name. */
  customer_name?: Maybe<Scalars['String']['output']>;
  /** Customer skin type. */
  customer_skin_type?: Maybe<Scalars['String']['output']>;
  /**
   * Diagnostic Id
   * @deprecated Deprecated and no longer supported. Use `uid` instead.
   */
  entity_id?: Maybe<Scalars['ID']['output']>;
  /** List of products. */
  product_list?: Maybe<Scalars['String']['output']>;
  /**
   * The diagnostic result.
   * @deprecated Deprecated and no longer supported. Always returns null.
   */
  result?: Maybe<Scalars['String']['output']>;
  /** Diagnostic result Id */
  uid?: Maybe<Scalars['ID']['output']>;
};

/** An input object for create a diagnostic result. */
export type DiagnosticResultCreateInput = {
  /** Customer skin type. */
  customer_skin_type?: InputMaybe<Scalars['String']['input']>;
  /** List of products. */
  product_list?: InputMaybe<Scalars['String']['input']>;
  /** The diagnostic result. */
  result?: InputMaybe<Scalars['String']['input']>;
};

export type DiaryEntry = {
  __typename?: 'DiaryEntry';
  care?: Maybe<Array<Maybe<CareItem>>>;
  created_at: Scalars['String']['output'];
  doctor_visit_date?: Maybe<Scalars['String']['output']>;
  entry_id: Scalars['Int']['output'];
  itch_day?: Maybe<Scalars['Int']['output']>;
  itch_night?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  poem_answers: Array<Maybe<PoemAnswer>>;
  poem_score?: Maybe<Scalars['Int']['output']>;
  sleep_maintenance_problems?: Maybe<Scalars['Int']['output']>;
  sleep_quality?: Maybe<Scalars['Int']['output']>;
  therapy?: Maybe<Array<Maybe<TherapyItem>>>;
  updated_at: Scalars['String']['output'];
};

export type DiaryEntryFilterInput = {
  created_at?: InputMaybe<FilterRangeTypeInput>;
  entry_id?: InputMaybe<FilterEqualTypeInput>;
};

export type DiaryEntryList = {
  __typename?: 'DiaryEntryList';
  items: Array<Maybe<DiaryEntry>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

export type DiaryEntryLoyaltyInfo = {
  __typename?: 'DiaryEntryLoyaltyInfo';
  actions_count?: Maybe<Scalars['Int']['output']>;
  balance_changes?: Maybe<Array<Maybe<DiaryEntryLoyaltyInfoBalanceChange>>>;
  total_earn_points?: Maybe<Scalars['Int']['output']>;
};

export type DiaryEntryLoyaltyInfoBalanceChange = {
  __typename?: 'DiaryEntryLoyaltyInfoBalanceChange';
  amount?: Maybe<Scalars['Int']['output']>;
  date_time_utc?: Maybe<Scalars['String']['output']>;
};

export type DiaryEntrySortInput = {
  created_at?: InputMaybe<SortEnum>;
};

export type DiaryProfile = {
  __typename?: 'DiaryProfile';
  created_at?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated and no longer supported. Use `last_entry_created_at` instead. */
  has_entries: Scalars['Boolean']['output'];
  last_entry_created_at?: Maybe<Scalars['String']['output']>;
  loyalty_info?: Maybe<DiaryEntryLoyaltyInfo>;
  profile_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type DiaryReport = {
  __typename?: 'DiaryReport';
  care: Array<Maybe<DiaryReportCareGroup>>;
  chart_data: Array<Maybe<DiaryReportChartGroup>>;
  date_from: Scalars['String']['output'];
  date_to: Scalars['String']['output'];
  entries_count: Scalars['Int']['output'];
  itch_day: DiaryReportMetric;
  itch_night: DiaryReportMetric;
  photos: Array<Maybe<DiaryReportPhoto>>;
  poem: DiaryReportMetric;
  therapy: Array<Maybe<DiaryReportTherapyGroup>>;
};

export type DiaryReportCareGroup = {
  __typename?: 'DiaryReportCareGroup';
  products: Array<Maybe<DiaryReportCareProduct>>;
  type: CareTypeEnum;
};

export type DiaryReportCareProduct = {
  __typename?: 'DiaryReportCareProduct';
  frequency_per_day: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  regularity: DiaryReportRegularityEnum;
};

export type DiaryReportChartGroup = {
  __typename?: 'DiaryReportChartGroup';
  points: Array<Maybe<DiaryReportChartPoint>>;
};

export type DiaryReportChartPoint = {
  __typename?: 'DiaryReportChartPoint';
  date: Scalars['String']['output'];
  itch_day?: Maybe<Scalars['Int']['output']>;
  itch_night?: Maybe<Scalars['Int']['output']>;
  poem_score?: Maybe<Scalars['Int']['output']>;
};

export type DiaryReportMedication = {
  __typename?: 'DiaryReportMedication';
  name: Scalars['String']['output'];
  prescriptions: Array<Maybe<DiaryReportPrescription>>;
  usage_percent?: Maybe<Scalars['Int']['output']>;
};

export type DiaryReportMetric = {
  __typename?: 'DiaryReportMetric';
  average?: Maybe<Scalars['Int']['output']>;
  delta?: Maybe<Scalars['Int']['output']>;
  first_value?: Maybe<Scalars['Int']['output']>;
  last_value?: Maybe<Scalars['Int']['output']>;
};

export type DiaryReportPhoto = {
  __typename?: 'DiaryReportPhoto';
  date: Scalars['String']['output'];
  photo: Scalars['String']['output'];
};

export type DiaryReportPrescription = {
  __typename?: 'DiaryReportPrescription';
  actual_days_count?: Maybe<Scalars['Int']['output']>;
  actual_frequency?: Maybe<Array<Maybe<ApplicationFrequencyEnum>>>;
  prescribed_days_count?: Maybe<Scalars['Int']['output']>;
  prescribed_frequency?: Maybe<ApplicationFrequencyEnum>;
};

export enum DiaryReportRegularityEnum {
  Daily = 'DAILY',
  Irregular = 'IRREGULAR'
}

export type DiaryReportTherapyGroup = {
  __typename?: 'DiaryReportTherapyGroup';
  medications: Array<Maybe<DiaryReportMedication>>;
  type: TherapyTypeEnum;
};

/** Dictionary option */
export type DictionaryOption = {
  __typename?: 'DictionaryOption';
  /** Option code */
  code: Scalars['String']['output'];
  /** Option label */
  label: Scalars['String']['output'];
  /** Option position */
  position: Scalars['Int']['output'];
};

export type DigineticaAutocompleteResponse = {
  __typename?: 'DigineticaAutocompleteResponse';
  categories?: Maybe<Array<Maybe<DigineticaCategory>>>;
  contents?: Maybe<Array<Maybe<DigineticaContent>>>;
  correction?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<DigineticaProduct>>>;
  query?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  sts?: Maybe<Array<Maybe<DigineticaSuggestion>>>;
};

export type DigineticaCategory = {
  __typename?: 'DigineticaCategory';
  name?: Maybe<Scalars['String']['output']>;
};

export type DigineticaContent = {
  __typename?: 'DigineticaContent';
  id?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DigineticaProduct = {
  __typename?: 'DigineticaProduct';
  id?: Maybe<Scalars['String']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DigineticaSuggestion = {
  __typename?: 'DigineticaSuggestion';
  redirectMobileUrl?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  st?: Maybe<Scalars['String']['output']>;
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item, shipping. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount. */
  amount: Money;
  /** The type of the entity the discount is applied to. */
  applied_to: CartDiscountType;
  /** The coupon related to the discount. */
  coupon?: Maybe<AppliedCoupon>;
  /** A description of the discount. */
  label: Scalars['String']['output'];
};

/** An implementation for downloadable product cart items. */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem';
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'DownloadableCreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = 'URL'
}

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  __typename?: 'DownloadableInvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  __typename?: 'DownloadableItemsLinks';
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID']['output'];
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  __typename?: 'DownloadableOrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'DownloadableProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** An array containing information about the links for this downloadable product. */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /** A value of 1 indicates that each link in the array must be purchased separately. */
  links_purchased_separately?: Maybe<Scalars['Int']['output']>;
  /** The heading above the list of downloadable products. */
  links_title?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars['Int']['output']>;
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID']['output'];
};

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int']['input'];
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples';
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  __typename?: 'DownloadableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID']['input'];
  /** Text the customer entered. */
  value: Scalars['String']['input'];
};

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']['output']>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']['output']>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** An error encountered while adding an item to the the cart. */
export type Error = {
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String']['output'];
};

/** Contains details about an address. */
export type EstimateAddressInput = {
  /** The two-letter code representing the customer's country. */
  country_code: CountryCodeEnum;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
};

export type EstimateTotalsInput = {
  /** Customer's address to estimate totals. */
  address: EstimateAddressInput;
  /** The unique ID of the cart to query. */
  cart_id: Scalars['String']['input'];
  /** Selected shipping method to estimate totals. */
  shipping_method?: InputMaybe<ShippingMethodInput>;
};

/** Estimate totals output. */
export type EstimateTotalsOutput = {
  __typename?: 'EstimateTotalsOutput';
  /** Cart after totals estimation */
  cart?: Maybe<Cart>;
};

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']['output']>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']['output']>;
};

export type Expert = RoutableInterface & {
  __typename?: 'Expert';
  /** Меня беспокоит */
  bother?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  clinics?: Maybe<Array<Maybe<ExpertClinic>>>;
  /** Биография */
  content?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['ID']['output']>;
  /** Полное имя */
  full_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  is_doctor: Scalars['Boolean']['output'];
  /** Is participant treating acne together */
  is_participant_treating_acne_together: Scalars['Boolean']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Профессия */
  occupation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Фотография */
  photo?: Maybe<Scalars['String']['output']>;
  photo_alt?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  /** Ученая степень/звание */
  qualification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redirect_code: Scalars['Int']['output'];
  /** Регалии */
  regalia?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
  /** Дата начала стажа */
  seniority?: Maybe<Scalars['String']['output']>;
  /** Ссылка на taplink */
  taplink?: Maybe<Scalars['String']['output']>;
  /** Ссылка на telegram */
  telegram?: Maybe<Scalars['String']['output']>;
  /** Treating acne together description */
  treating_acne_together_description?: Maybe<Scalars['String']['output']>;
  /** Treating acne together photo */
  treating_acne_together_photo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  url_key?: Maybe<Scalars['String']['output']>;
  /** Ссылка на VK */
  vk?: Maybe<Scalars['String']['output']>;
};

export type ExpertCity = {
  __typename?: 'ExpertCity';
  city?: Maybe<Scalars['String']['output']>;
};

export type ExpertCityFilterInput = {
  is_display_in_find_doctor?: InputMaybe<Scalars['Boolean']['input']>;
  is_participant_treating_acne_together?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpertClinic = {
  __typename?: 'ExpertClinic';
  address?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type ExpertFilterInput = {
  bother?: InputMaybe<FilterInTypeInput>;
  city?: InputMaybe<FilterEqualTypeInput>;
  is_display_in_find_doctor?: InputMaybe<Scalars['Boolean']['input']>;
  is_doctor?: InputMaybe<Scalars['Boolean']['input']>;
  is_participant_treating_acne_together?: InputMaybe<Scalars['Boolean']['input']>;
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

export type ExpertOutput = {
  __typename?: 'ExpertOutput';
  items: Array<Maybe<Expert>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

export type FastlaneConfig = PaymentConfigItem & {
  __typename?: 'FastlaneConfig';
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** 3DS mode */
  three_ds_mode?: Maybe<ThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Fastlane Payment inputs */
export type FastlaneMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The single use token from Fastlane */
  paypal_fastlane_token?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterInTypeInput = {
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum FilterMatchTypeEnum {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to fuzzy match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']['input']>;
  /** Filter match type for fine-tuned results. Possible values FULL or PARTIAL. If match_type is not provided, returned results will default to FULL match. */
  match_type?: InputMaybe<FilterMatchTypeEnum>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']['input']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']['input']>;
  /** Is null. */
  null?: InputMaybe<Scalars['String']['input']>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Lists display settings for the Fixed Product Tax. */
export enum FixedProductTaxDisplaySettings {
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  FptDisabled = 'FPT_DISABLED',
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

export type FreeGiftsRequestAddressDetailedData = {
  block?: InputMaybe<Scalars['String']['input']>;
  /** Тип корпус или строение */
  block_type?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Тип квартира или офис */
  flat_type?: InputMaybe<Scalars['String']['input']>;
  house?: InputMaybe<Scalars['String']['input']>;
  region_with_type: Scalars['String']['input'];
  settlement?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_type?: InputMaybe<Scalars['String']['input']>;
};

export type FreeGiftsRequestInput = {
  /** Full delivery address */
  address: Scalars['String']['input'];
  /** Данные адреса, полученные из dadata */
  address_data: FreeGiftsRequestAddressDetailedData;
  /** Customer email */
  email: Scalars['String']['input'];
  /** Customer full name */
  full_name: Scalars['String']['input'];
  /** Customer phone number */
  phone: Scalars['String']['input'];
  /** Promo code for free gift */
  promocode: Scalars['String']['input'];
};

export type FreeGiftsRequestOutput = {
  __typename?: 'FreeGiftsRequestOutput';
  error_message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type General = {
  __typename?: 'General';
  /** Display author. */
  display_author?: Maybe<Scalars['Int']['output']>;
  /** Display Blogs Mode. */
  display_style?: Maybe<Scalars['Int']['output']>;
  /** Choose blog's color. */
  font_color?: Maybe<Scalars['String']['output']>;
  /** Blog Name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Show Blog Link in Top Menu. */
  toplinks?: Maybe<Scalars['Int']['output']>;
};

/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars['String']['input'];
};

/** Contains the generated customer token. */
export type GenerateCustomerTokenAsAdminOutput = {
  __typename?: 'GenerateCustomerTokenAsAdminOutput';
  /** The generated customer token. */
  customer_token: Scalars['String']['output'];
};

/** Gets the payment SDK URLs and values */
export type GetPaymentSdkOutput = {
  __typename?: 'GetPaymentSDKOutput';
  /** The payment SDK parameters */
  sdkParams?: Maybe<Array<Maybe<PaymentSdkParamsItem>>>;
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  __typename?: 'GiftMessage';
  /** Sender name */
  from: Scalars['String']['output'];
  /** Gift message text */
  message: Scalars['String']['output'];
  /** Recipient name */
  to: Scalars['String']['output'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessageInput = {
  /** Sender name */
  from: Scalars['String']['input'];
  /** Gift message text */
  message: Scalars['String']['input'];
  /** Recipient name */
  to: Scalars['String']['input'];
};

export type GooglePayButtonStyles = {
  __typename?: 'GooglePayButtonStyles';
  /** The button color */
  color?: Maybe<Scalars['String']['output']>;
  /** The button height in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** The button type */
  type?: Maybe<Scalars['String']['output']>;
};

export type GooglePayConfig = PaymentConfigItem & {
  __typename?: 'GooglePayConfig';
  /** The styles for the GooglePay Button configuration */
  button_styles?: Maybe<GooglePayButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Google Pay mode */
  google_pay_mode?: Maybe<GooglePayMode>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** 3DS mode */
  three_ds_mode?: Maybe<ThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Google Pay inputs */
export type GooglePayMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars['String']['input']>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars['String']['input']>;
};

/** Google Pay mode. */
export enum GooglePayMode {
  Production = 'PRODUCTION',
  Test = 'TEST'
}

/** An implementation for grouped product cart items. */
export type GroupedCartItem = CartItemInterface & {
  __typename?: 'GroupedCartItem';
  child_items?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'GroupedProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** An array containing grouped product items. */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem';
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Details about this product option. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  __typename?: 'GroupedProductWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Input to retrieve a guest order based on token. */
export type GuestOrderCancelInput = {
  /** Cancellation reason. */
  reason: Scalars['String']['input'];
  /** Order token. */
  token: Scalars['String']['input'];
};

export type HostedFieldsConfig = PaymentConfigItem & {
  __typename?: 'HostedFieldsConfig';
  /** Vault payment method code */
  cc_vault_code?: Maybe<Scalars['String']['output']>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Card vault enabled */
  is_vault_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The payment source for the payment method */
  payment_source?: Maybe<Scalars['String']['output']>;
  /** Card and bin details required */
  requires_card_details?: Maybe<Scalars['Boolean']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /**
   * Whether 3DS is activated; true if 3DS mode is not OFF.
   * @deprecated Use 'three_ds_mode' instead.
   */
  three_ds?: Maybe<Scalars['Boolean']['output']>;
  /** 3DS mode */
  three_ds_mode?: Maybe<ThreeDsMode>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Hosted Fields payment inputs */
export type HostedFieldsInput = {
  /** Card bin number */
  cardBin?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month of the card */
  cardExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  /** Expiration year of the card */
  cardExpiryYear?: InputMaybe<Scalars['String']['input']>;
  /** Last four digits of the card */
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  /** Name on the card */
  holderName?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the Payment Services payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']['input']>;
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars['String']['input']>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars['String']['input']>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  __typename?: 'HostedProUrl';
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars['String']['output']>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
};

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** A parameter name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A parameter value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

/** List of templates/filters applied to customer attribute input. */
export enum InputFilterEnum {
  /** Forces attribute input to follow the date format. */
  Date = 'DATE',
  /** Escape HTML Entities. */
  Escapehtml = 'ESCAPEHTML',
  /** There are no templates or filters to be applied. */
  None = 'NONE',
  /** Strip HTML Tags. */
  Striptags = 'STRIPTAGS',
  /** Strip whitespace (or other characters) from the beginning and end of the input. */
  Trim = 'TRIM'
}

export type InsufficientStockError = Error & {
  __typename?: 'InsufficientStockError';
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError';
  /** The returned error message. */
  message: Scalars['String']['output'];
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']['output'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String']['output'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']['output']>;
};

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption';
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output'];
  /** The label of the option. */
  label: Scalars['String']['output'];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID']['output'];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue';
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output'];
  /** The price of the child bundle product. */
  price: Money;
  /** The name of the child bundle product. */
  product_name: Scalars['String']['output'];
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String']['output'];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']['output']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

/** Defines the possible values of liability shift */
export enum LiabilityShift {
  No = 'NO',
  Possible = 'POSSIBLE',
  Unknown = 'UNKNOWN'
}

export type LikeInput = {
  story_id: Scalars['Int']['input'];
};

export type LikesOutput = {
  __typename?: 'LikesOutput';
  /** The total like */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']['output']>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']['output']>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID']['output'];
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

export type MediaGalleryType = {
  __typename?: 'MediaGalleryType';
  alt: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MessageStyleLogo = {
  __typename?: 'MessageStyleLogo';
  /** The type of logo for the PayPal Pay Later messaging */
  type?: Maybe<Scalars['String']['output']>;
};

export type MessageStyles = {
  __typename?: 'MessageStyles';
  /** The message layout */
  layout?: Maybe<Scalars['String']['output']>;
  /** The message logo */
  logo?: Maybe<MessageStyleLogo>;
};

export type MindboxAppliedPromotion = {
  __typename?: 'MindboxAppliedPromotion';
  amount?: Maybe<Scalars['Float']['output']>;
  balanceType?: Maybe<MindboxBalanceType>;
  promotion?: Maybe<MindboxPromotion>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MindboxBalanceType = {
  __typename?: 'MindboxBalanceType';
  ids?: Maybe<MindboxBalanceTypeIds>;
};

export type MindboxBalanceTypeIds = {
  __typename?: 'MindboxBalanceTypeIds';
  systemName?: Maybe<Scalars['String']['output']>;
};

export type MindboxProductListInput = {
  /** The main problems with the client's skin */
  client_main_problem?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Email address used for contact or identification. */
  email: Scalars['String']['input'];
  /** Product list id */
  identifier: Scalars['String']['input'];
  /** Newsletter subscription. */
  is_subscribed: Scalars['Boolean']['input'];
  /** Product information */
  product_list: Array<InputMaybe<MindboxProductListProductInfo>>;
};

export type MindboxProductListProductInfo = {
  mindbox_id: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type MindboxProductPriceData = {
  __typename?: 'MindboxProductPriceData';
  appliedPromotions?: Maybe<Array<Maybe<MindboxAppliedPromotion>>>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  mindboxId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promoLabels?: Maybe<Array<Maybe<MindboxPromoLabel>>>;
};

export type MindboxPromoLabel = {
  __typename?: 'MindboxPromoLabel';
  label?: Maybe<Scalars['String']['output']>;
  promotionExternalId?: Maybe<Scalars['String']['output']>;
};

export type MindboxPromotion = {
  __typename?: 'MindboxPromotion';
  ids?: Maybe<MindboxPromotionIds>;
};

export type MindboxPromotionIds = {
  __typename?: 'MindboxPromotionIds';
  externalId?: Maybe<Scalars['String']['output']>;
};

/** Contains the results of a `mobileAppInfo` query. */
export type MobileAppInfo = {
  __typename?: 'MobileAppInfo';
  /** The current version in the store. */
  current_store_version?: Maybe<Scalars['String']['output']>;
  /** Whether the maintenance screen should be shown in the mobile application. */
  maintenance_mode?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum supported version of the application. */
  min_version?: Maybe<Scalars['String']['output']>;
  /** Link to the app in the store. */
  store_url?: Maybe<Scalars['String']['output']>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type MonthlyArchive = {
  __typename?: 'MonthlyArchive';
  /** An array of post that match the specified search criteria. */
  items?: Maybe<Array<Maybe<Post>>>;
  /** The label of Monthly Archive */
  label?: Maybe<Scalars['String']['output']>;
  /** The quantity of Monthly Archive */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyArchiveOutput = {
  __typename?: 'MonthlyArchiveOutput';
  /** An array of post that match the specified search criteria. */
  items?: Maybe<Array<Maybe<MonthlyArchive>>>;
  /** The number of monthly archive returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  addLike?: Maybe<StoryLikes>;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>;
  /** Creates a new cart and add any type of product to it */
  addProductsToNewCart?: Maybe<AddProductsToNewCartOutput>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>;
  /** Apply bonus points to the specified cart. */
  applyBonusPointsToCart?: Maybe<ApplyBonusPointsToCartOutput>;
  /** Apply a pre-defined certificate code to the specified cart. */
  applyCertificateToCart?: Maybe<ApplyCertificateToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart;
  /** Authorize customer by phone. */
  authorizeByPhone?: Maybe<CustomerToken>;
  /** Cancel the specified customer order. */
  cancelOrder?: Maybe<CancelOrderOutput>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>;
  /** Synchronizes order details and place the order */
  completeOrder?: Maybe<PlaceOrderOutput>;
  /** Cancel the specified guest customer order. */
  confirmCancelOrder?: Maybe<CancelOrderOutput>;
  /** Confirms the email address for a customer. */
  confirmEmail?: Maybe<CustomerOutput>;
  /** Send a 'Contact Us' email to the merchant. */
  contactUs?: Maybe<ContactUsOutput>;
  createAcneRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Create the blog comment */
  createBlogComment?: Maybe<Scalars['Boolean']['output']>;
  createCombinedMethodsQuestion?: Maybe<Scalars['Boolean']['output']>;
  createCombinedMethodsRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>;
  /** @deprecated Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>;
  /** Create the diagnostic result */
  createDiagnosticResult?: Maybe<DiagnosticResult>;
  createDiaryEntry?: Maybe<CreateDiaryEntryResult>;
  createDiaryProfile?: Maybe<DiaryProfile>;
  createDoctor?: Maybe<CreateExpertOutput>;
  /**
   * Create an empty shopping cart for a guest or logged in user
   * @deprecated Use `Mutation.createGuestCart` or `Query.customerCart` for logged in customer
   */
  createEmptyCart?: Maybe<Scalars['String']['output']>;
  /** Create a new shopping cart */
  createGuestCart?: Maybe<CreateGuestCartOutput>;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>;
  /** Creates a payment order for further payment processing */
  createPaymentOrder?: Maybe<CreatePaymentOrderOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput;
  /** Create the question */
  createQuestion?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a vault payment token */
  createVaultCardPaymentToken?: Maybe<CreateVaultCardPaymentTokenOutput>;
  /** Creates a vault card setup token */
  createVaultCardSetupToken?: Maybe<CreateVaultCardSetupTokenOutput>;
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  editMindboxSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  /** Estimate shipping method(s) for cart based on address */
  estimateShippingMethods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** Estimate totals for cart based on the address */
  estimateTotals: EstimateTotalsOutput;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<GenerateCustomerTokenAsAdminOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart;
  /** Place a new free gifts request */
  placeFreeGiftsRequest?: Maybe<FreeGiftsRequestOutput>;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>;
  /** Remove a bonus points from the cart. */
  removeBonusPointsFromCart?: Maybe<RemoveBonusPointsFromCartOutput>;
  removeCertificateFromCart?: Maybe<RemoveCertificateFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCoupon?: Maybe<RemoveCouponFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  removeLike?: Maybe<StoryLikes>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>;
  /** Request to cancel specified guest order. */
  requestGuestOrderCancel?: Maybe<CancelOrderOutput>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Resends the confirmation email to a customer. */
  resendConfirmationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Restore quote after order rejection. Only if customer does not have new active one. */
  restoreQuoteByOrderId?: Maybe<Cart>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  savePickupPointToAddress?: Maybe<DeliveryAddress>;
  /** Send to customer auth code. */
  sendAuthorizationCode?: Maybe<Scalars['Boolean']['output']>;
  /** Send the diagnostic checklist */
  sendDiagnosticChecklist?: Maybe<Scalars['Boolean']['output']>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<SendEmailToFriendOutput>;
  sendMindboxOperation?: Maybe<Scalars['MindboxOperationType']['output']>;
  /** Send to customer registration code. */
  sendRegistrationCode?: Maybe<Scalars['Boolean']['output']>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  /** Sets the cart as inactive */
  setCartAsInactive?: Maybe<SetCartAsInactiveOutput>;
  setCity?: Maybe<SetCityOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  setMindboxProductList?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>;
  /** Synchronizes the payment order details for further payment processing */
  syncPaymentOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** @deprecated Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>;
  updateDiaryEntry?: Maybe<DiaryEntry>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>;
  uploadDiaryEntryPhoto?: Maybe<UploadDiaryEntryPhoto>;
  uploadExpertPhoto?: Maybe<UploadExpertPhotoOutput>;
  uploadReviewImage?: Maybe<UploadReviewImage>;
  /** Verify customer registration code. */
  verifyRegistrationCode?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


export type MutationAddLikeArgs = {
  input: LikeInput;
};


export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String']['input'];
  cartItems: Array<CartItemInput>;
};


export type MutationAddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>;
};


export type MutationAddProductsToNewCartArgs = {
  cartItems: Array<CartItemInput>;
};


export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItems: Array<WishlistItemInput>;
};


export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationApplyBonusPointsToCartArgs = {
  input?: InputMaybe<ApplyBonusPointsToCartInput>;
};


export type MutationApplyCertificateToCartArgs = {
  input?: InputMaybe<ApplyCertificateToCartInput>;
};


export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


export type MutationAssignCompareListToCustomerArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']['input'];
};


export type MutationAuthorizeByPhoneArgs = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationCompleteOrderArgs = {
  input?: InputMaybe<CompleteOrderInput>;
};


export type MutationConfirmCancelOrderArgs = {
  input: ConfirmCancelOrderInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationContactUsArgs = {
  input: ContactUsInput;
};


export type MutationCreateAcneRequestArgs = {
  input: TreatingAcneTogetherRequestCreateInput;
};


export type MutationCreateBlogCommentArgs = {
  input: BlogCommentCreateInput;
};


export type MutationCreateCombinedMethodsQuestionArgs = {
  input: CombinedMethodsQuestionInput;
};


export type MutationCreateCombinedMethodsRequestArgs = {
  input: CombinedMethodsRequestInput;
};


export type MutationCreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>;
};


export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};


export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput;
};


export type MutationCreateDiagnosticResultArgs = {
  input: DiagnosticResultCreateInput;
};


export type MutationCreateDiaryEntryArgs = {
  input: CreateDiaryEntryInput;
};


export type MutationCreateDoctorArgs = {
  input: CreateExpertInput;
};


export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};


export type MutationCreateGuestCartArgs = {
  input?: InputMaybe<CreateGuestCartInput>;
};


export type MutationCreatePayflowProTokenArgs = {
  input: PayflowProTokenInput;
};


export type MutationCreatePaymentOrderArgs = {
  input: CreatePaymentOrderInput;
};


export type MutationCreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput;
};


export type MutationCreateProductReviewArgs = {
  input: CreateProductReviewInput;
};


export type MutationCreateQuestionArgs = {
  input: QuestionCreateInput;
};


export type MutationCreateVaultCardPaymentTokenArgs = {
  input: CreateVaultCardPaymentTokenInput;
};


export type MutationCreateVaultCardSetupTokenArgs = {
  input: CreateVaultCardSetupTokenInput;
};


export type MutationDeleteCompareListArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String']['input'];
};


export type MutationEditMindboxSubscriptionsArgs = {
  input: Array<InputMaybe<CustomerMindboxSubscriptionInput>>;
};


export type MutationEstimateShippingMethodsArgs = {
  input: EstimateTotalsInput;
};


export type MutationEstimateTotalsArgs = {
  input: EstimateTotalsInput;
};


export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationGenerateCustomerTokenAsAdminArgs = {
  input: GenerateCustomerTokenAsAdminInput;
};


export type MutationHandlePayflowProResponseArgs = {
  input: PayflowProResponseInput;
};


export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']['input']>;
  source_cart_id: Scalars['String']['input'];
};


export type MutationPlaceFreeGiftsRequestArgs = {
  input: FreeGiftsRequestInput;
};


export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


export type MutationRemoveBonusPointsFromCartArgs = {
  input?: InputMaybe<RemoveBonusPointsFromCartInput>;
};


export type MutationRemoveCertificateFromCartArgs = {
  input?: InputMaybe<RemoveCertificateFromCartInput>;
};


export type MutationRemoveCouponArgs = {
  input?: InputMaybe<RemoveCouponInput>;
};


export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


export type MutationRemoveLikeArgs = {
  input: LikeInput;
};


export type MutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>;
};


export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItemsIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationRequestGuestOrderCancelArgs = {
  input: GuestOrderCancelInput;
};


export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendConfirmationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationRestoreQuoteByOrderIdArgs = {
  number: Scalars['String']['input'];
};


export type MutationSavePickupPointToAddressArgs = {
  cart_id: Scalars['String']['input'];
  nom_code: Scalars['String']['input'];
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendAuthorizationCodeArgs = {
  phone: Scalars['String']['input'];
};


export type MutationSendDiagnosticChecklistArgs = {
  input: SendDiagnosticChecklistInput;
};


export type MutationSendEmailToFriendArgs = {
  input?: InputMaybe<SendEmailToFriendInput>;
};


export type MutationSendMindboxOperationArgs = {
  operationType: Scalars['String']['input'];
  requestContent?: InputMaybe<Scalars['MindboxOperationType']['input']>;
  syncType: Scalars['String']['input'];
};


export type MutationSendRegistrationCodeArgs = {
  phone: Scalars['String']['input'];
};


export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


export type MutationSetCartAsInactiveArgs = {
  cartId: Scalars['String']['input'];
};


export type MutationSetCityArgs = {
  input: SetCityInput;
};


export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


export type MutationSetMindboxProductListArgs = {
  input: MindboxProductListInput;
};


export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String']['input'];
};


export type MutationSyncPaymentOrderArgs = {
  input?: InputMaybe<SyncPaymentOrderInput>;
};


export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CustomerAddressInput>;
};


export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput;
};


export type MutationUpdateDiaryEntryArgs = {
  entry_id: Scalars['Int']['input'];
  input: UpdateDiaryEntryInput;
};


export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItems: Array<WishlistItemUpdateInput>;
};


export type MutationUploadDiaryEntryPhotoArgs = {
  input: UploadDiaryEntryPhotoInput;
};


export type MutationUploadExpertPhotoArgs = {
  input: UploadExpertPhotoInput;
};


export type MutationUploadReviewImageArgs = {
  input: UploadReviewImageInput;
};


export type MutationVerifyRegistrationCodeArgs = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError';
  /** The returned error message. */
  message: Scalars['String']['output'];
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID']['output'];
};

export type OfflineStore = {
  __typename?: 'OfflineStore';
  /** Brand. */
  brand?: Maybe<BrandEnum>;
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Latitude. */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude. */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Store ID. */
  store_id?: Maybe<Scalars['Int']['output']>;
  /** Street. */
  street?: Maybe<Scalars['String']['output']>;
};

export type OfflineStoreCity = {
  __typename?: 'OfflineStoreCity';
  /** Query by city. */
  city?: Maybe<Scalars['String']['output']>;
};

/** Contains the order ID. */
export type Order = {
  __typename?: 'Order';
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String']['output'];
};

/** The list of available order actions. */
export enum OrderActionType {
  Cancel = 'CANCEL',
  Reorder = 'REORDER'
}

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** The city or town. */
  city: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']['output'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']['output']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
};

export type OrderCustomerInfo = {
  __typename?: 'OrderCustomerInfo';
  /** First name of the customer */
  firstname: Scalars['String']['output'];
  /** Last name of the customer */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Middle name of the customer */
  middlename?: Maybe<Scalars['String']['output']>;
  /** Prefix of the customer */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Suffix of the customer */
  suffix?: Maybe<Scalars['String']['output']>;
};

/** Input to retrieve an order based on details. */
export type OrderInformationInput = {
  /** Order billing address email. */
  email: Scalars['String']['input'];
  /** Order billing address lastname. */
  lastname: Scalars['String']['input'];
  /** Order number. */
  number: Scalars['String']['input'];
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<OrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String']['output'];
  /** The value of the option. */
  value: Scalars['String']['output'];
};

export type OrderItemPrices = {
  __typename?: 'OrderItemPrices';
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  fixed_product_taxes: Array<Maybe<FixedProductTax>>;
  /** The original price of the item. */
  original_price?: Maybe<Money>;
  /** The original price of the item including tax. */
  original_price_including_tax?: Maybe<Money>;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: Money;
  /** The value of the original price multiplied by the quantity of the item including tax. */
  original_row_total_including_tax: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount: Money;
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String']['output'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']['output'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']['output'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String']['output'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Input to retrieve an order based on token. */
export type OrderTokenInput = {
  /** Order token. */
  token: Scalars['String']['input'];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /**
   * The subtotal of the order, excluding shipping, discounts, and taxes.
   * @deprecated Use subtotal_excl_tax field instead
   */
  subtotal: Money;
  /** The subtotal of the order, excluding taxes. */
  subtotal_excl_tax: Money;
  /** The subtotal of the order, including taxes. */
  subtotal_incl_tax: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The certificate balance applied to the order */
  total_certificate?: Maybe<Money>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Allows to using paging it start with 1. */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** End page */
  endPage?: Maybe<Scalars['Int']['output']>;
  /** Is next page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Is previous page */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** How many items should show on the page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** Start page */
  startPage?: Maybe<Scalars['Int']['output']>;
};

export enum PagePosition {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP',
  UnderProductImage = 'UNDER_PRODUCT_IMAGE'
}

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input'];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String']['input'];
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export enum PayflowLinkMode {
  Live = 'LIVE',
  Test = 'TEST'
}

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  __typename?: 'PayflowLinkToken';
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars['String']['output']>;
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars['String']['output']>;
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars['String']['output']>;
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input'];
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String']['input'];
};

export type PayflowProResponseOutput = {
  __typename?: 'PayflowProResponseOutput';
  /** The cart with the updated selected payment method. */
  cart: Cart;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  __typename?: 'PayflowProToken';
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']['output'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']['output'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']['output'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']['output'];
};

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

export type PaymentCommonConfig = PaymentConfigItem & {
  __typename?: 'PaymentCommonConfig';
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Contains payment fields that are common to all types of payment methods. */
export type PaymentConfigItem = {
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** Retrieves the payment configuration for a given location */
export type PaymentConfigOutput = {
  __typename?: 'PaymentConfigOutput';
  /** ApplePay payment method configuration */
  apple_pay?: Maybe<ApplePayConfig>;
  /** Fastlane payment method configuration */
  fastlane?: Maybe<FastlaneConfig>;
  /** GooglePay payment method configuration */
  google_pay?: Maybe<GooglePayConfig>;
  /** Hosted fields payment method configuration */
  hosted_fields?: Maybe<HostedFieldsConfig>;
  /** Smart Buttons payment method configuration */
  smart_buttons?: Maybe<SmartButtonsConfig>;
};

/** Defines the origin location for that payment request */
export enum PaymentLocation {
  Admin = 'ADMIN',
  Cart = 'CART',
  Checkout = 'CHECKOUT',
  Minicart = 'MINICART',
  ProductDetail = 'PRODUCT_DETAIL',
  StartOfCheckout = 'START_OF_CHECKOUT'
}

/** Defines the payment method. */
export type PaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars['String']['input'];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>;
  /** Required input for Apple Pay button */
  payment_services_paypal_apple_pay?: InputMaybe<ApplePayMethodInput>;
  /** Required input for fastlane */
  payment_services_paypal_fastlane?: InputMaybe<FastlaneMethodInput>;
  /** Required input for Google Pay button */
  payment_services_paypal_google_pay?: InputMaybe<GooglePayMethodInput>;
  /** Required input for Hosted Fields */
  payment_services_paypal_hosted_fields?: InputMaybe<HostedFieldsInput>;
  /** Required input for Smart buttons */
  payment_services_paypal_smart_buttons?: InputMaybe<SmartButtonMethodInput>;
  /** Required input for vault */
  payment_services_paypal_vault?: InputMaybe<VaultMethodInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Contains the payment order details */
export type PaymentOrderOutput = {
  __typename?: 'PaymentOrderOutput';
  /** PayPal order ID */
  id?: Maybe<Scalars['String']['output']>;
  /** The order ID generated by Payment Services */
  mp_order_id?: Maybe<Scalars['String']['output']>;
  /** Details about the card used on the order */
  payment_source_details?: Maybe<PaymentSourceDetails>;
  /** The status of the payment order */
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentSdkParamsItem = {
  __typename?: 'PaymentSDKParamsItem';
  /** The payment method code used in the order */
  code?: Maybe<Scalars['String']['output']>;
  /** The payment SDK parameters */
  params?: Maybe<Array<Maybe<SdkParams>>>;
};

export type PaymentSourceDetails = {
  __typename?: 'PaymentSourceDetails';
  /** Details about the card used on the order */
  card?: Maybe<Card>;
};

/** The payment source information */
export type PaymentSourceInput = {
  /** The card payment source information */
  card: CardPaymentSourceInput;
};

/** The payment source information */
export type PaymentSourceOutput = {
  __typename?: 'PaymentSourceOutput';
  /** The card payment source information */
  card: CardPaymentSourceOutput;
};

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']['output']>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String']['output'];
  /** The public hash of the token. */
  public_hash: Scalars['String']['output'];
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export enum PaymentTokenTypeEnum {
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Account = 'account',
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Card = 'card'
}

/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input'];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String']['input'];
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  __typename?: 'PaypalExpressToken';
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']['output']>;
};

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input'];
  /** The payment method code. */
  code: Scalars['String']['input'];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']['input']>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  __typename?: 'PaypalExpressTokenOutput';
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']['output']>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  __typename?: 'PaypalExpressUrlList';
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']['output']>;
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']['output']>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']['input']>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']['input']>;
};

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Defines Pickup Location information. */
export type PickupLocation = {
  __typename?: 'PickupLocation';
  city?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pickup_location_code?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export type PickupLocationFilterInput = {
  /** Filter by city. */
  city?: InputMaybe<FilterTypeInput>;
  /** Filter by country. */
  country_id?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location name. */
  name?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location code. */
  pickup_location_code?: InputMaybe<FilterTypeInput>;
  /** Filter by postcode. */
  postcode?: InputMaybe<FilterTypeInput>;
  /** Filter by region. */
  region?: InputMaybe<FilterTypeInput>;
  /** Filter by region id. */
  region_id?: InputMaybe<FilterTypeInput>;
  /** Filter by street. */
  street?: InputMaybe<FilterTypeInput>;
};

/** PickupLocationSortInput specifies attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type PickupLocationSortInput = {
  /** City where pickup location is placed. */
  city?: InputMaybe<SortEnum>;
  /** Name of the contact person. */
  contact_name?: InputMaybe<SortEnum>;
  /** Id of the country in two letters. */
  country_id?: InputMaybe<SortEnum>;
  /** Description of the pickup location. */
  description?: InputMaybe<SortEnum>;
  /** Distance to the address, requested by distance filter. Applicable only with distance filter. If distance sort order is present, all other sort orders will be ignored. */
  distance?: InputMaybe<SortEnum>;
  /** Contact email of the pickup location. */
  email?: InputMaybe<SortEnum>;
  /** Contact fax of the pickup location. */
  fax?: InputMaybe<SortEnum>;
  /** Geographic latitude where pickup location is placed. */
  latitude?: InputMaybe<SortEnum>;
  /** Geographic longitude where pickup location is placed. */
  longitude?: InputMaybe<SortEnum>;
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: InputMaybe<SortEnum>;
  /** Contact phone number of the pickup location. */
  phone?: InputMaybe<SortEnum>;
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: InputMaybe<SortEnum>;
  /** Postcode where pickup location is placed. */
  postcode?: InputMaybe<SortEnum>;
  /** Name of the region. */
  region?: InputMaybe<SortEnum>;
  /** Id of the region. */
  region_id?: InputMaybe<SortEnum>;
  /** Street where pickup location is placed. */
  street?: InputMaybe<SortEnum>;
};

/** Top level object returned in a pickup locations search. */
export type PickupLocations = {
  __typename?: 'PickupLocations';
  /** An array of pickup locations that match the specific search request. */
  items?: Maybe<Array<Maybe<PickupLocation>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An error encountered while placing an order. */
export type PlaceOrderError = {
  __typename?: 'PlaceOrderError';
  /** An error code that is specific to place order. */
  code: PlaceOrderErrorCodes;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

export enum PlaceOrderErrorCodes {
  CartNotActive = 'CART_NOT_ACTIVE',
  CartNotFound = 'CART_NOT_FOUND',
  GuestEmailMissing = 'GUEST_EMAIL_MISSING',
  UnableToPlaceOrder = 'UNABLE_TO_PLACE_ORDER',
  Undefined = 'UNDEFINED'
}

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  /** An array of place order errors. */
  errors: Array<Maybe<PlaceOrderError>>;
  /**
   * The ID of the order.
   * @deprecated Use `orderV2` instead.
   */
  order?: Maybe<Order>;
  /** Full order information. */
  orderV2?: Maybe<CustomerOrder>;
};

export type PoemAnswer = {
  __typename?: 'PoemAnswer';
  question_id: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type PoemAnswerInput = {
  question_id: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

export type Post = {
  __typename?: 'Post';
  /** Indicates whether users can write a comment. */
  allow_comment?: Maybe<Scalars['Int']['output']>;
  /** The author ids */
  author_id?: Maybe<Scalars['String']['output']>;
  /** The authors assigned to a post */
  authors?: Maybe<Array<Maybe<Expert>>>;
  /** Best rating */
  best_rating?: Maybe<Scalars['Int']['output']>;
  /** The categories assigned to a post */
  categories?: Maybe<CategoriesOutputNoPage>;
  /** The list of products questions. */
  comments: BlogComments;
  /** Timestamp indicating when the post was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a post is enabled. */
  enabled?: Maybe<Scalars['Int']['output']>;
  /** Header text */
  header_text?: Maybe<Scalars['String']['output']>;
  /** The image of the post. */
  image?: Maybe<Scalars['String']['output']>;
  /** The import source of the post. */
  import_source?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a post in rss. */
  in_rss?: Maybe<Scalars['Int']['output']>;
  /** The layout of the post */
  layout?: Maybe<Scalars['String']['output']>;
  /** Main article */
  main_article?: Maybe<Scalars['Boolean']['output']>;
  /** The meta description of the post. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The meta keywords of the post. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** The meta robot of the post. */
  meta_robots?: Maybe<Scalars['String']['output']>;
  /** The meta title of the post. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The name of the post. */
  name?: Maybe<Scalars['String']['output']>;
  /** Podcast html */
  podcast_html?: Maybe<Scalars['String']['output']>;
  /** The content of the post. */
  post_content?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the post. */
  post_id?: Maybe<Scalars['Int']['output']>;
  /** The related post assigned to a post */
  posts?: Maybe<PostsOutputNoPage>;
  /** The products assigned to a post */
  products?: Maybe<ProductsOutputNoPage>;
  /** Timestamp indicating when the post was publish. */
  publish_date?: Maybe<Scalars['String']['output']>;
  /** The QAPage markup of the post. */
  qa_page?: Maybe<Scalars['String']['output']>;
  /** Rating summary */
  rating_summary?: Maybe<Scalars['Float']['output']>;
  /** The short description of the post. */
  short_description?: Maybe<Scalars['String']['output']>;
  /** Simplecast code */
  simplecast_code?: Maybe<Scalars['String']['output']>;
  /** The small image of the post. */
  small_image?: Maybe<Scalars['String']['output']>;
  /** An ID that identifies the store. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** The tags assigned to a post */
  tags?: Maybe<TagsOutputNoPage>;
  /** Text 1 */
  text_1?: Maybe<Scalars['String']['output']>;
  /** Text 2 */
  text_2?: Maybe<Scalars['String']['output']>;
  /** Text 3 */
  text_3?: Maybe<Scalars['String']['output']>;
  /** Text 4 */
  text_4?: Maybe<Scalars['String']['output']>;
  /** Text 5 */
  text_5?: Maybe<Scalars['String']['output']>;
  /** Text 6 */
  text_6?: Maybe<Scalars['String']['output']>;
  /** Text 7 */
  text_7?: Maybe<Scalars['String']['output']>;
  /** Text 8 */
  text_8?: Maybe<Scalars['String']['output']>;
  /** Text 9 */
  text_9?: Maybe<Scalars['String']['output']>;
  /** Text 10 */
  text_10?: Maybe<Scalars['String']['output']>;
  /** Text image 1 */
  text_image_1?: Maybe<Scalars['String']['output']>;
  /** Text image 2 */
  text_image_2?: Maybe<Scalars['String']['output']>;
  /** Text image 3 */
  text_image_3?: Maybe<Scalars['String']['output']>;
  /** Text image 4 */
  text_image_4?: Maybe<Scalars['String']['output']>;
  /** Text image 5 */
  text_image_5?: Maybe<Scalars['String']['output']>;
  /** Text image 6 */
  text_image_6?: Maybe<Scalars['String']['output']>;
  /** Text image 7 */
  text_image_7?: Maybe<Scalars['String']['output']>;
  /** Text image 8 */
  text_image_8?: Maybe<Scalars['String']['output']>;
  /** Text image 9 */
  text_image_9?: Maybe<Scalars['String']['output']>;
  /** Text image 10 */
  text_image_10?: Maybe<Scalars['String']['output']>;
  /** Text image alt 1 */
  text_image_alt_1?: Maybe<Scalars['String']['output']>;
  /** Text image alt 2 */
  text_image_alt_2?: Maybe<Scalars['String']['output']>;
  /** Text image alt 3 */
  text_image_alt_3?: Maybe<Scalars['String']['output']>;
  /** Text image alt 4 */
  text_image_alt_4?: Maybe<Scalars['String']['output']>;
  /** Text image alt 5 */
  text_image_alt_5?: Maybe<Scalars['String']['output']>;
  /** Text image alt 6 */
  text_image_alt_6?: Maybe<Scalars['String']['output']>;
  /** Text image alt 7 */
  text_image_alt_7?: Maybe<Scalars['String']['output']>;
  /** Text image alt 8 */
  text_image_alt_8?: Maybe<Scalars['String']['output']>;
  /** Text image alt 9 */
  text_image_alt_9?: Maybe<Scalars['String']['output']>;
  /** Text image alt 10 */
  text_image_alt_10?: Maybe<Scalars['String']['output']>;
  /** Text image link 1 */
  text_image_link_1?: Maybe<Scalars['String']['output']>;
  /** Text image link 2 */
  text_image_link_2?: Maybe<Scalars['String']['output']>;
  /** Text image link 3 */
  text_image_link_3?: Maybe<Scalars['String']['output']>;
  /** Text image link 4 */
  text_image_link_4?: Maybe<Scalars['String']['output']>;
  /** Text image link 5 */
  text_image_link_5?: Maybe<Scalars['String']['output']>;
  /** Text image link 6 */
  text_image_link_6?: Maybe<Scalars['String']['output']>;
  /** Text image link 7 */
  text_image_link_7?: Maybe<Scalars['String']['output']>;
  /** Text image link 8 */
  text_image_link_8?: Maybe<Scalars['String']['output']>;
  /** Text image link 9 */
  text_image_link_9?: Maybe<Scalars['String']['output']>;
  /** Text image link 10 */
  text_image_link_10?: Maybe<Scalars['String']['output']>;
  /** Text image position 1 */
  text_image_position_1?: Maybe<Scalars['String']['output']>;
  /** Text image position 2 */
  text_image_position_2?: Maybe<Scalars['String']['output']>;
  /** Text image position 3 */
  text_image_position_3?: Maybe<Scalars['String']['output']>;
  /** Text image position 4 */
  text_image_position_4?: Maybe<Scalars['String']['output']>;
  /** Text image position 5 */
  text_image_position_5?: Maybe<Scalars['String']['output']>;
  /** Text image position 6 */
  text_image_position_6?: Maybe<Scalars['String']['output']>;
  /** Text image position 7 */
  text_image_position_7?: Maybe<Scalars['String']['output']>;
  /** Text image position 8 */
  text_image_position_8?: Maybe<Scalars['String']['output']>;
  /** Text image position 9 */
  text_image_position_9?: Maybe<Scalars['String']['output']>;
  /** Text image position 10 */
  text_image_position_10?: Maybe<Scalars['String']['output']>;
  /** Text products. */
  text_products?: Maybe<Array<Maybe<BlogTextProduct>>>;
  /** Text product skus 1 */
  text_products_skus_1?: Maybe<Scalars['String']['output']>;
  /** Text product skus 2 */
  text_products_skus_2?: Maybe<Scalars['String']['output']>;
  /** Text product skus 3 */
  text_products_skus_3?: Maybe<Scalars['String']['output']>;
  /** Text product skus 4 */
  text_products_skus_4?: Maybe<Scalars['String']['output']>;
  /** Text product skus 5 */
  text_products_skus_5?: Maybe<Scalars['String']['output']>;
  /** Text product skus 6 */
  text_products_skus_6?: Maybe<Scalars['String']['output']>;
  /** Text product skus 7 */
  text_products_skus_7?: Maybe<Scalars['String']['output']>;
  /** Text product skus 8 */
  text_products_skus_8?: Maybe<Scalars['String']['output']>;
  /** Text product skus 9 */
  text_products_skus_9?: Maybe<Scalars['String']['output']>;
  /** Text product skus 10 */
  text_products_skus_10?: Maybe<Scalars['String']['output']>;
  /** Time to read */
  time_to_read?: Maybe<Scalars['String']['output']>;
  /** The topics assigned to a post */
  topics?: Maybe<TopicsOutputNoPage>;
  /** Post type */
  type?: Maybe<BlogEntityTypeEnum>;
  /** Timestamp indicating when the post was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key of the post. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** Video 1 */
  video_1?: Maybe<Scalars['String']['output']>;
  /** Video 2 */
  video_2?: Maybe<Scalars['String']['output']>;
  /** Video 3 */
  video_3?: Maybe<Scalars['String']['output']>;
  /** Video 4 */
  video_4?: Maybe<Scalars['String']['output']>;
  /** Video 5 */
  video_5?: Maybe<Scalars['String']['output']>;
  /** Video image 1 */
  video_image_1?: Maybe<Scalars['String']['output']>;
  /** Video image 2 */
  video_image_2?: Maybe<Scalars['String']['output']>;
  /** Video image 3 */
  video_image_3?: Maybe<Scalars['String']['output']>;
  /** Video image 4 */
  video_image_4?: Maybe<Scalars['String']['output']>;
  /** Video image 5 */
  video_image_5?: Maybe<Scalars['String']['output']>;
  /** The view count of the post. */
  view_traffic?: Maybe<Scalars['Int']['output']>;
  /** Prepared with doctor */
  with_doctor?: Maybe<Scalars['Boolean']['output']>;
};


export type PostCommentsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type PostPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export enum PostSortTypeEnum {
  Latest = 'LATEST',
  Popular = 'POPULAR',
  WithDoctor = 'WITH_DOCTOR'
}

export type PostsFilterInput = {
  /** Indicates whether the post allow comment */
  allow_comment?: InputMaybe<FilterTypeInput>;
  /** Author Id the post belongs to. */
  author_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the post was created */
  created_at?: InputMaybe<FilterTypeInput>;
  /** Enabled */
  enabled?: InputMaybe<FilterTypeInput>;
  /** Import Source */
  import_source?: InputMaybe<FilterTypeInput>;
  /** Is main article */
  main_article?: InputMaybe<FilterTypeInput>;
  /** The post name. Customers use this name to identify the post. */
  name?: InputMaybe<FilterTypeInput>;
  /** The post id. Customers use this name to identify the post. */
  post_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the post was publish */
  publish_date?: InputMaybe<FilterTypeInput>;
  /** The store id */
  store_ids?: InputMaybe<FilterTypeInput>;
  /** The post type */
  type?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the post was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The post url_key */
  url_key?: InputMaybe<FilterTypeInput>;
};

export type PostsOutput = {
  __typename?: 'PostsOutput';
  /** An array of post that match the specified search criteria */
  items?: Maybe<Array<Maybe<Post>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of posts returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PostsOutputNoPage = {
  __typename?: 'PostsOutputNoPage';
  /** An array of post that match the specified search criteria */
  items?: Maybe<Array<Maybe<Post>>>;
  /** The number of posts returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated `PriceAdjustmentCodesEnum` is deprecated. Tax is included or excluded in the price. Tax is not shown separately in Catalog. */
  Tax = 'TAX',
  /** @deprecated WEEE code is deprecated. Use `fixed_product_taxes.label` instead. */
  Weee = 'WEEE',
  /** @deprecated Use `fixed_product_taxes` instead.  Tax is included or excluded in price. The tax is not shown separtely in Catalog. */
  WeeeTax = 'WEEE_TAX'
}

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

/** Can be used to retrieve the main price details in case of bundle product */
export type PriceDetails = {
  __typename?: 'PriceDetails';
  /** The percentage of discount applied to the main product price */
  discount_percentage?: Maybe<Scalars['Float']['output']>;
  /** The final price after applying the discount to the main product */
  main_final_price?: Maybe<Scalars['Float']['output']>;
  /** The regular price of the main product */
  main_price?: Maybe<Scalars['Float']['output']>;
};

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** Defines the price type. */
export enum PriceTypeEnum {
  Dynamic = 'DYNAMIC',
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  AsLowAs = 'AS_LOW_AS',
  PriceRange = 'PRICE_RANGE'
}

export type Product = {
  __typename?: 'Product';
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the product. */
  entity_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether a product option is available. */
  has_options?: Maybe<Scalars['Int']['output']>;
  /** The images of the product. */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Indicates whether a product option is required. */
  required_options?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** One of simple, virtual, bundle, downloadable, grouped, or configurable. */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key of the product. */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** Contains a product attribute code and value. */
export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  /** The unique identifier for a product attribute code. */
  code: Scalars['String']['output'];
  /** The display value of the attribute. */
  value: Scalars['String']['output'];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Возраст */
  age?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Область применения */
  application_area?: InputMaybe<FilterEqualTypeInput>;
  /** Brand attribute filter. */
  brand?: InputMaybe<BrandFilterEqualTypeInput>;
  /** Care Finder Product filter */
  care_finder_age?: InputMaybe<FilterTypeInput>;
  /** Care Finder Product filter */
  care_finder_category?: InputMaybe<FilterTypeInput>;
  /** Care Finder Product filter */
  care_finder_problems?: InputMaybe<FilterTypeInput>;
  /** Care Finder Product filter */
  care_finder_skin?: InputMaybe<FilterTypeInput>;
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by category URL path. */
  category_url_path?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Действие */
  effect?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Гамма бренда */
  gamma?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Лейбл */
  label?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Discount filter. */
  only_with_discount?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Отдушка */
  otdushka?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Проблематика */
  problems?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Оттенок */
  shade?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Skin type */
  skin_type?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Солнцезащитный фактор (SPF) */
  sun_protection_factor?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Тип средства */
  type_of_cosmetic?: InputMaybe<FilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Время использования */
  vremya_ispolzovaniya?: InputMaybe<FilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Products with discount first. */
  discount?: InputMaybe<SortEnum>;
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>;
  /** New products first. */
  new?: InputMaybe<SortEnum>;
  /** Top products first. */
  popularity?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
};

export type ProductBanner = {
  __typename?: 'ProductBanner';
  /** Banner itself */
  entity: BannerEntity;
  /** Position on the Page */
  position: PagePosition;
};

export type ProductCertificateItem = {
  __typename?: 'ProductCertificateItem';
  brand?: Maybe<Scalars['String']['output']>;
  certificate?: Maybe<Scalars['String']['output']>;
  gamma?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductCertificatesOutput = {
  __typename?: 'ProductCertificatesOutput';
  items?: Maybe<Array<Maybe<ProductCertificateItem>>>;
};

/** Product custom attributes */
export type ProductCustomAttributes = {
  __typename?: 'ProductCustomAttributes';
  /** Errors when retrieving custom attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested custom attributes */
  items: Array<Maybe<AttributeValueInterface>>;
};

/** Detailed product rating */
export type ProductDetailedRating = {
  __typename?: 'ProductDetailedRating';
  /** Rating percent */
  percent: Scalars['Int']['output'];
  /** Rating value */
  rating: Scalars['Int']['output'];
};

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']['output']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']['output']>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>;
  url_path?: InputMaybe<FilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ProductImageThumbnail {
  /** Use thumbnail of product as image. */
  Itself = 'ITSELF',
  /** Use thumbnail of product's parent as image. */
  Parent = 'PARENT'
}

/** Product Information used for Pickup Locations search. */
export type ProductInfoInput = {
  /** Product SKU. */
  sku: Scalars['String']['input'];
};

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfaceCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfacePostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfaceQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks';
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']['output']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']['output']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']['output']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']['output']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']['output']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']['output']>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: Money;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>;
};

/** Contains details of a product review. */
export type ProductQuestion = {
  __typename?: 'ProductQuestion';
  /** Customer age. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Answer text. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Product in answer. */
  answer_product?: Maybe<ProductInterface>;
  /** Question created at. */
  created_at: Scalars['String']['output'];
  /** Customer name. */
  customer_name: Scalars['String']['output'];
  /** Customer email. */
  email?: Maybe<Scalars['String']['output']>;
  /** Product SKU. */
  product_sku: Scalars['String']['output'];
  /** Question text. */
  question: Scalars['String']['output'];
  /** Customer skin problem. */
  skin_problem?: Maybe<Scalars['String']['output']>;
  /** Customer skin type. */
  skin_type?: Maybe<Scalars['String']['output']>;
};

/** Contains an array of product questions. */
export type ProductQuestions = {
  __typename?: 'ProductQuestions';
  /** An array of product question. */
  items: Array<Maybe<ProductQuestion>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
};

/** Contains details of a product review. */
export type ProductReview = {
  __typename?: 'ProductReview';
  /** Customer Age */
  age?: Maybe<Scalars['Int']['output']>;
  /** Answer text. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Product in answer. */
  answer_product?: Maybe<ProductInterface>;
  /** The average of all ratings for this product. */
  average_rating: Scalars['Float']['output'];
  /** Product cons. */
  cons?: Maybe<Scalars['String']['output']>;
  /** The date the review was created. */
  created_at: Scalars['String']['output'];
  /** The review id. */
  id: Scalars['ID']['output'];
  /** Review images. */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Is external review */
  is_external?: Maybe<Scalars['Boolean']['output']>;
  /** Is influencer review */
  is_influencer?: Maybe<Scalars['Boolean']['output']>;
  /** Is recommended product */
  is_recommended?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['output'];
  /** The reviewed product. */
  product: ProductInterface;
  /** Product pros. */
  pros?: Maybe<Scalars['String']['output']>;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<ProductReviewRating>>;
  /** Customer skin problem. */
  skin_problem?: Maybe<Scalars['String']['output']>;
  /** Customer skin type. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** Review source. */
  source?: Maybe<Scalars['String']['output']>;
  /** Review source logo. */
  source_logo?: Maybe<Scalars['String']['output']>;
  /** Review source url. */
  source_url?: Maybe<Scalars['String']['output']>;
  /** The summary (title) of the review. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The review text. */
  text: Scalars['String']['output'];
};

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  __typename?: 'ProductReviewRating';
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output'];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String']['output'];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String']['input'];
  /** An encoded rating value ID. */
  value_id: Scalars['String']['input'];
};

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  __typename?: 'ProductReviewRatingMetadata';
  /** An encoded rating ID. */
  id: Scalars['String']['output'];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output'];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  __typename?: 'ProductReviewRatingValueMetadata';
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String']['output'];
  /** An encoded rating value ID. */
  value_id: Scalars['String']['output'];
};

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  __typename?: 'ProductReviewRatingsMetadata';
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>;
};

/** Contains an array of product reviews. */
export type ProductReviews = {
  __typename?: 'ProductReviews';
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>;
  /** The price of the item. */
  price?: InputMaybe<SortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>;
  url_path?: InputMaybe<SortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>;
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK'
}

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']['output']>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']['output']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products';
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the search results meta. */
  search_result_meta?: Maybe<ProductsSearchResultMeta>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Anyquery zeroQueries field.
   * @deprecated Use `search_result_meta` instead.
   */
  zero_queries?: Maybe<Scalars['Boolean']['output']>;
};


/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>;
};

export type ProductsFilterInput = {
  /** Product Attribute Set Id the product belongs to */
  attribute_set_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the product was created */
  created_at?: InputMaybe<FilterTypeInput>;
  /** Product Id */
  entity_id?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product */
  has_options?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer */
  sku?: InputMaybe<FilterTypeInput>;
  /** Product Type the product belongs to */
  type_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the product was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
};

export type ProductsOutput = {
  __typename?: 'ProductsOutput';
  /** An array of products that match the specified search criteria */
  items?: Maybe<Array<Maybe<Product>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of products returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductsOutputNoPage = {
  __typename?: 'ProductsOutputNoPage';
  /** An array of products that match the specified search criteria */
  items?: Maybe<Array<Maybe<Product>>>;
  /** The number of products returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductsSearchResultMeta = {
  __typename?: 'ProductsSearchResultMeta';
  /** Anyquery redirect mobile url field. */
  redirect_mobile_url?: Maybe<Scalars['String']['output']>;
  /** Anyquery redirect url field. */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Anyquery zeroQueries field. */
  zero_queries?: Maybe<Scalars['Boolean']['output']>;
};

export type Promotion = RoutableInterface & {
  __typename?: 'Promotion';
  brand_name: Scalars['String']['output'];
  category?: Maybe<Category>;
  created_at: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Описание после списка товаров */
  description_after?: Maybe<Scalars['String']['output']>;
  /** Картинка для описания после списка товаров */
  description_after_image?: Maybe<Scalars['String']['output']>;
  /** Текст сноски внизу страницы */
  disclaimer?: Maybe<Scalars['String']['output']>;
  display_enhanced_cashback_widget?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['String']['output'];
  entity_id: Scalars['Int']['output'];
  erid?: Maybe<Scalars['String']['output']>;
  image_desktop?: Maybe<Scalars['String']['output']>;
  image_mobile?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  /** Изображение для списка акций */
  list_image?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  promo_type?: Maybe<Array<Maybe<PromotionType>>>;
  redirect_code: Scalars['Int']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
  store_id: Scalars['Int']['output'];
  theme?: Maybe<PromotionThemeEnum>;
  title: Scalars['String']['output'];
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

export type PromotionFilterInput = {
  brand_name?: InputMaybe<BrandFilterEqualTypeInput>;
  category_id?: InputMaybe<FilterEqualTypeInput>;
  entity_id?: InputMaybe<FilterEqualTypeInput>;
  link?: InputMaybe<FilterEqualTypeInput>;
  promo_type?: InputMaybe<FilterEqualTypeInput>;
};

export type PromotionOutput = {
  __typename?: 'PromotionOutput';
  items?: Maybe<Array<Maybe<Promotion>>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

export enum PromotionThemeEnum {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type PromotionType = {
  __typename?: 'PromotionType';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  acneCabinets?: Maybe<AcneCabinetOutput>;
  acneSchools?: Maybe<AcneSchoolOutput>;
  /** Retrieve EAV attributes associated to a frontend form. Use countries query provided by DirectoryGraphQl module to retrieve region_id and country_id attribute options. */
  attributesForm: AttributesFormOutput;
  /** Returns a list of attributes metadata for a given entity type. */
  attributesList?: Maybe<AttributesMetadataOutput>;
  availablePromoCodes?: Maybe<Array<Maybe<AvailablePromoCode>>>;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>;
  bannerEntities: Array<Maybe<BannerEntity>>;
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Get information for certificate account by code */
  certificateAccount?: Maybe<CertificateAccount>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>;
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>;
  /**
   * Return the attribute type, given an attribute code and entity type.
   * @deprecated Use `customAttributeMetadataV2` query instead.
   */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** Retrieve EAV attributes metadata. */
  customAttributeMetadataV2: AttributesMetadataOutput;
  /** Custom Variable Values Array. */
  customVariables: Array<Maybe<CustomVariable>>;
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>;
  /** Customer bonus balance history. */
  customerBonusHistory?: Maybe<CustomerBonusHistoryOutput>;
  /** Return information about the customer's shopping cart. */
  customerCart: Cart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  diagnostic?: Maybe<Diagnostic>;
  diagnosticResult?: Maybe<DiagnosticResult>;
  diaryEntries?: Maybe<DiaryEntryList>;
  diaryReport?: Maybe<DiaryReport>;
  dictionary?: Maybe<Array<Maybe<DictionaryOption>>>;
  expertCities?: Maybe<Array<Maybe<ExpertCity>>>;
  experts?: Maybe<ExpertOutput>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>;
  /** Retrieves the payment configuration for a given location */
  getPaymentConfig?: Maybe<PaymentConfigOutput>;
  /** Retrieves the payment details for the order */
  getPaymentOrder?: Maybe<PaymentOrderOutput>;
  /** Gets the payment SDK urls and values */
  getPaymentSDK?: Maybe<GetPaymentSdkOutput>;
  getPickupPointsByCity?: Maybe<Array<Maybe<DeliveryAddress>>>;
  /** Get shipping methods by city and region. */
  getShippingMethods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  getThresholdedRules?: Maybe<ThresholdedRulesOutput>;
  /** Get user choice gift rules for specified cart */
  getUserChoiceRules?: Maybe<CartGiftRulesOutput>;
  /** Retrieves the vault configuration */
  getVaultConfig?: Maybe<VaultConfigOutput>;
  /** Retrieve guest order details based on number, email and billing last name. */
  guestOrder: CustomerOrder;
  /** Retrieve guest order details based on token. */
  guestOrderByToken: CustomerOrder;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  /** Validates if a quote is valid for the current customer. */
  isValidQuote?: Maybe<QuoteValidationResult>;
  /** Information about the mobile application. */
  mobileAppInfo?: Maybe<MobileAppInfo>;
  /** The mpBlogCategories query searches for Category that match the criteria specified in the filter. */
  mpBlogCategories?: Maybe<CategoriesOutput>;
  /** The mpBlogComments query searches for Category that match the criteria specified in the filter. */
  mpBlogComments?: Maybe<CommentsOutput>;
  /** The mpBlogConfigs query gets the config of Blog extension. */
  mpBlogConfigs?: Maybe<ConfigsOutput>;
  /** The mpBlogMonthlyArchive query gets posts follow monthly archive. */
  mpBlogMonthlyArchive?: Maybe<MonthlyArchiveOutput>;
  /** Returns the total number of likes for the post */
  mpBlogPostLikes?: Maybe<LikesOutput>;
  /** The mpBlogPosts query searches for post that match the criteria specified in the filter. */
  mpBlogPosts?: Maybe<PostsOutput>;
  /** The mpBlogProducts query searches for Category that match the criteria specified in the filter. */
  mpBlogProducts?: Maybe<ProductsOutput>;
  /** The mpBlogTags query searches for tag that match the criteria specified in the filter. */
  mpBlogTags?: Maybe<TagsOutput>;
  /** The mpBlogTopics query searches for topic that match the criteria specified in the filter. */
  mpBlogTopics?: Maybe<TopicsOutput>;
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations?: Maybe<PickupLocations>;
  productCertificates?: Maybe<ProductCertificatesOutput>;
  /** Fast product listing backed by denormalized OpenSearch index. */
  productListing?: Maybe<Products>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata;
  /** Search for products set the specified product belongs to */
  productSet?: Maybe<Products>;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>;
  promotions?: Maybe<PromotionOutput>;
  recaptchaFormConfig?: Maybe<ReCaptchaConfigOutput>;
  /** Returns details about Google reCAPTCHA V3-Invisible configuration. */
  recaptchaV3Config?: Maybe<ReCaptchaConfigurationV3>;
  /** Get review information by id. */
  review?: Maybe<ProductReview>;
  /** Get all product review images. */
  reviewImages?: Maybe<Array<Maybe<ReviewImage>>>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>;
  searchSuggestion?: Maybe<DigineticaAutocompleteResponse>;
  /** Retrieve guest or customer order details based on token. */
  secureOrder: CustomerOrder;
  seoParams?: Maybe<SeoParams>;
  /** The snowdogMenuNodes query returns information about active nodes of a menu */
  snowdogMenuNodes?: Maybe<SnowdogMenuNodes>;
  /** The snowdogMenus query returns information about active menus */
  snowdogMenus?: Maybe<SnowdogMenus>;
  /** Query by Offline Store and Pharmacy Cities. */
  storeCities?: Maybe<Array<Maybe<OfflineStoreCity>>>;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>;
  /** Query by Offline Stores and Pharmacies. */
  stores?: Maybe<Array<Maybe<OfflineStore>>>;
  stories?: Maybe<StoryOutput>;
  story_groups?: Maybe<Array<Maybe<StoryGroup>>>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>;
  /** Returns active vacancies sorted by position. */
  vacancies: VacancySearchResult;
  /** Returns active vacancy groups sorted by position. */
  vacancyGroups: Array<Maybe<VacancyGroup>>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>;
};


export type QueryAcneCabinetsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TreatingAcneTogetherFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TreatingAcneTogetherSortInput>;
};


export type QueryAcneSchoolsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TreatingAcneTogetherFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TreatingAcneTogetherSortInput>;
};


export type QueryAttributesFormArgs = {
  formCode: Scalars['String']['input'];
};


export type QueryAttributesListArgs = {
  entityType: AttributeEntityTypeEnum;
  filters?: InputMaybe<AttributeFilterInput>;
};


export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBannerEntitiesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartArgs = {
  cart_id: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCertificateAccountArgs = {
  input: CertificateAccountInput;
};


export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompareListArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


export type QueryCustomAttributeMetadataV2Args = {
  attributes?: InputMaybe<Array<AttributeInput>>;
};


export type QueryCustomVariablesArgs = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDiagnosticArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDiagnosticResultArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryDiaryEntriesArgs = {
  filter?: InputMaybe<DiaryEntryFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<DiaryEntrySortInput>;
};


export type QueryDictionaryArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryExpertCitiesArgs = {
  filter?: InputMaybe<ExpertCityFilterInput>;
};


export type QueryExpertsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ExpertFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHostedProUrlArgs = {
  input: HostedProUrlInput;
};


export type QueryGetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput;
};


export type QueryGetPaymentConfigArgs = {
  location: PaymentLocation;
};


export type QueryGetPaymentOrderArgs = {
  cartId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetPaymentSdkArgs = {
  location: PaymentLocation;
};


export type QueryGetPickupPointsByCityArgs = {
  city: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetShippingMethodsArgs = {
  city: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetThresholdedRulesArgs = {
  cart_id: Scalars['String']['input'];
};


export type QueryGetUserChoiceRulesArgs = {
  cart_id: Scalars['String']['input'];
};


export type QueryGuestOrderArgs = {
  input: OrderInformationInput;
};


export type QueryGuestOrderByTokenArgs = {
  input: OrderTokenInput;
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsValidQuoteArgs = {
  cart_id: Scalars['String']['input'];
};


export type QueryMpBlogCategoriesArgs = {
  action: Scalars['String']['input'];
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CategoriesFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogCommentsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CommentsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogConfigsArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogMonthlyArchiveArgs = {
  monthly?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogPostLikesArgs = {
  postId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogPostsArgs = {
  action: Scalars['String']['input'];
  authorName?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PostsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PostSortTypeEnum>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  topicKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMpBlogProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogTagsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TagsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMpBlogTopicsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TopicsFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPickupLocationsArgs = {
  area?: InputMaybe<AreaInput>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PickupLocationFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productsInfo?: InputMaybe<Array<InputMaybe<ProductInfoInput>>>;
  sort?: InputMaybe<PickupLocationSortInput>;
};


export type QueryProductListingArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryProductSetArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryPromotionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PromotionFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecaptchaFormConfigArgs = {
  formType: ReCaptchaFormEnum;
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewImagesArgs = {
  sku: Scalars['String']['input'];
};


export type QueryRouteArgs = {
  url: Scalars['String']['input'];
};


export type QuerySearchSuggestionArgs = {
  productsSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
};


export type QuerySecureOrderArgs = {
  orderNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QuerySeoParamsArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySnowdogMenuNodesArgs = {
  identifier: Scalars['String']['input'];
};


export type QuerySnowdogMenusArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryStoreCitiesArgs = {
  brand?: InputMaybe<BrandFilterEqualTypeInput>;
};


export type QueryStoresArgs = {
  brand?: InputMaybe<BrandFilterEqualTypeInput>;
  city?: InputMaybe<FilterEqualTypeInput>;
};


export type QueryStoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<StoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUrlResolverArgs = {
  url: Scalars['String']['input'];
};


export type QueryVacanciesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<VacancyFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** An input object for create a question. */
export type QuestionCreateInput = {
  /** Customer age. */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** Customer name. */
  customer_name: Scalars['String']['input'];
  /** Customer email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Product SKU. */
  product_sku: Scalars['String']['input'];
  /** Question text. */
  question: Scalars['String']['input'];
  /** Customer skin problem. */
  skin_problem?: InputMaybe<Scalars['String']['input']>;
  /** Customer skin type. */
  skin_type?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies the field to use for sorting quote items */
export type QuoteItemsSortInput = {
  /** Specifies the quote items field to sort by */
  field: SortQuoteItemsEnum;
  /** Specifies the order of quote items' sorting */
  order: SortEnum;
};

/** Contains the validation result for a quote. */
export type QuoteValidationResult = {
  __typename?: 'QuoteValidationResult';
  /** Whether the quote is valid. */
  is_valid: Scalars['Boolean']['output'];
  /** Validation message if the quote is invalid. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ReCaptchaConfigOutput = {
  __typename?: 'ReCaptchaConfigOutput';
  /** Configuration details for reCaptcha type */
  configurations?: Maybe<ReCaptchaConfiguration>;
  /** Indicates whether reCaptcha type is enabled */
  is_enabled: Scalars['Boolean']['output'];
};

/** Contains reCAPTCHA form configuration details. */
export type ReCaptchaConfiguration = {
  __typename?: 'ReCaptchaConfiguration';
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position?: Maybe<Scalars['String']['output']>;
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code?: Maybe<Scalars['String']['output']>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score?: Maybe<Scalars['Float']['output']>;
  re_captcha_type: ReCaptchaTypeEmum;
  /** The message that appears when reCaptcha fails. */
  technical_failure_message: Scalars['String']['output'];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars['String']['output'];
  /** The message that appears to the user if validation fails. */
  validation_failure_message: Scalars['String']['output'];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars['String']['output'];
};

/** Contains reCAPTCHA V3-Invisible configuration details. */
export type ReCaptchaConfigurationV3 = {
  __typename?: 'ReCaptchaConfigurationV3';
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position: Scalars['String']['output'];
  /** The message that appears to the user if validation fails. */
  failure_message: Scalars['String']['output'];
  /** A list of forms on the storefront that have been configured to use reCAPTCHA V3. */
  forms: Array<Maybe<ReCaptchaFormEnum>>;
  /** Return whether recaptcha is enabled or not */
  is_enabled: Scalars['Boolean']['output'];
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code?: Maybe<Scalars['String']['output']>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score: Scalars['Float']['output'];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars['String']['output'];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars['String']['output'];
};

export enum ReCaptchaFormEnum {
  Braintree = 'BRAINTREE',
  Contact = 'CONTACT',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerEdit = 'CUSTOMER_EDIT',
  CustomerForgotPassword = 'CUSTOMER_FORGOT_PASSWORD',
  CustomerLogin = 'CUSTOMER_LOGIN',
  Newsletter = 'NEWSLETTER',
  PlaceOrder = 'PLACE_ORDER',
  ProductReview = 'PRODUCT_REVIEW',
  ResendConfirmationEmail = 'RESEND_CONFIRMATION_EMAIL',
  Sendfriend = 'SENDFRIEND'
}

export enum ReCaptchaTypeEmum {
  Invisible = 'INVISIBLE',
  Recaptcha = 'RECAPTCHA',
  RecaptchaV3 = 'RECAPTCHA_V3'
}

export type Region = {
  __typename?: 'Region';
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Specifies the cart from which to remove a bonus points. */
export type RemoveBonusPointsFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains details about the cart after removing a bonus points. */
export type RemoveBonusPointsFromCartOutput = {
  __typename?: 'RemoveBonusPointsFromCartOutput';
  /** The cart after removing a coupon. */
  cart: Cart;
};

/** Defines the input required to run the removeCertificateFromCart mutation */
export type RemoveCertificateFromCartInput = {
  /** The unique ID that identifies the customer's cart */
  cart_id: Scalars['String']['input'];
  /** The certificate code to be removed to the cart */
  certificate: Scalars['String']['input'];
};

/** Defines the possible output for the removeCertificateFromCart mutation */
export type RemoveCertificateFromCartOutput = {
  __typename?: 'RemoveCertificateFromCartOutput';
  /** Describes the contents of the specified shopping cart */
  cart: Cart;
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>;
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** A valid coupon code. */
  coupon_code: Scalars['String']['input'];
};

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>;
};

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  /** The cart after removing an item. */
  cart: Cart;
};

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input'];
};

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput';
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist;
};

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput';
  /** Detailed information about the customer's cart. */
  cart: Cart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>;
};

/** Review image */
export type ReviewImage = {
  __typename?: 'ReviewImage';
  /** Image path */
  file: Scalars['String']['output'];
  /** The review id */
  review_id: Scalars['ID']['output'];
};

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean']['output'];
};

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Default implementation of RoutableInterface. This type is returned when the URL is not linked to an entity. */
export type RoutableUrl = RoutableInterface & {
  __typename?: 'RoutableUrl';
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Defines the name and value of a SDK parameter */
export type SdkParams = {
  __typename?: 'SDKParams';
  /** The name of the SDK parameter */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the SDK parameter */
  value?: Maybe<Scalars['String']['output']>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String']['output'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String']['output'];
};

export type SalesItemInterface = {
  __typename?: 'SalesItemInterface';
  /** The entered gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
};

/** This enumeration defines the scope type for customer orders. */
export enum ScopeTypeEnum {
  Global = 'GLOBAL',
  Store = 'STORE',
  Website = 'WEBSITE'
}

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** The search suggestion of existing product. */
  search: Scalars['String']['output'];
};

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  /** @deprecated Use `uid` instead */
  id: Scalars['Int']['output'];
  /** The display name of the selected bundle product option. */
  label: Scalars['String']['output'];
  /** The type of selected bundle product option. */
  type: Scalars['String']['output'];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID']['output'];
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  /** Use `uid` instead */
  id: Scalars['Int']['output'];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String']['output'];
  /** The original price of the value for the selected bundle product option. */
  original_price: Money;
  /**
   * The price of the value for the selected bundle product option.
   * @deprecated Use priceV2 instead.
   */
  price: Scalars['Float']['output'];
  /** The price of the value for the selected bundle product option. */
  priceV2: Money;
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID']['output'];
};

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID']['output'];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int']['output'];
  /** The display text for the option. */
  option_label: Scalars['String']['output'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int']['output'];
  /** The display name of the selected configurable option. */
  value_label: Scalars['String']['output'];
};

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int']['output'];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean']['output'];
  /** The display name of the selected customizable option. */
  label: Scalars['String']['output'];
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int']['output'];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String']['output'];
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int']['output'];
  /** The display name of the selected value. */
  label: Scalars['String']['output'];
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars['String']['output'];
};

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code. */
  code: Scalars['String']['output'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  /** The payment method title. */
  title: Scalars['String']['output'];
};

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String']['output'];
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String']['output'];
  /** The label for the method code. */
  method_title: Scalars['String']['output'];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

/** An input object for send diagnostic checklist. */
export type SendDiagnosticChecklistInput = {
  /** The diagnostic result ID. */
  diagnostic_result_id?: InputMaybe<Scalars['ID']['input']>;
  /** Customer email. */
  email: Scalars['String']['input'];
  /** Customer name. */
  name: Scalars['String']['input'];
  /** The diagnostic result ID. */
  result_uid?: InputMaybe<Scalars['ID']['input']>;
};

/** Defines the referenced product and the email sender and recipients. */
export type SendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars['Int']['input'];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<SendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: SendEmailToFriendSenderInput;
};

/** Contains information about the sender and recipients. */
export type SendEmailToFriendOutput = {
  __typename?: 'SendEmailToFriendOutput';
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender?: Maybe<SendEmailToFriendSender>;
};

/** An output object that contains information about the recipient. */
export type SendEmailToFriendRecipient = {
  __typename?: 'SendEmailToFriendRecipient';
  /** The email address of the recipient. */
  email: Scalars['String']['output'];
  /** The name of the recipient. */
  name: Scalars['String']['output'];
};

/** Contains details about a recipient. */
export type SendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars['String']['input'];
  /** The name of the recipient. */
  name: Scalars['String']['input'];
};

/** An output object that contains information about the sender. */
export type SendEmailToFriendSender = {
  __typename?: 'SendEmailToFriendSender';
  /** The email address of the sender. */
  email: Scalars['String']['output'];
  /** The text of the message to be sent. */
  message: Scalars['String']['output'];
  /** The name of the sender. */
  name: Scalars['String']['output'];
};

/** Contains details about the sender. */
export type SendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars['String']['input'];
  /** The text of the message to be sent. */
  message: Scalars['String']['input'];
  /** The name of the sender. */
  name: Scalars['String']['input'];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type SendFriendConfiguration = {
  __typename?: 'SendFriendConfiguration';
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars['Boolean']['output'];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars['Boolean']['output'];
};

export type Seo = {
  __typename?: 'Seo';
  /** Meta description. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Meta title. */
  meta_title?: Maybe<Scalars['String']['output']>;
};

export type SeoParams = {
  __typename?: 'SeoParams';
  canonical?: Maybe<Scalars['String']['output']>;
  h1?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  robots?: Maybe<Scalars['String']['output']>;
};

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  /** The cart after setting the billing address. */
  cart: Cart;
};

/** Sets the cart as inactive */
export type SetCartAsInactiveOutput = {
  __typename?: 'SetCartAsInactiveOutput';
  /** The error message returned after failing to set the cart as inactive */
  error?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the cart was set as inactive */
  success: Scalars['Boolean']['output'];
};

export type SetCityInput = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type SetCityOutput = {
  __typename?: 'SetCityOutput';
  success: Scalars['Boolean']['output'];
};

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The email address of the guest. */
  email: Scalars['String']['input'];
};

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  /** The cart after setting the guest email. */
  cart: Cart;
};

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  /** The cart after setting the payment method. */
  cart: Cart;
};

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  /** The cart after setting the shipping addresses. */
  cart: Cart;
};

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  /** The cart after setting the shipping methods. */
  cart: Cart;
};

/** Defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  Separately = 'SEPARATELY',
  Together = 'TOGETHER'
}

export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem';
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']['output'];
  delivery_date_actual?: Maybe<Scalars['String']['output']>;
  delivery_date_from?: Maybe<Scalars['String']['output']>;
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The shipment tracking title. */
  title: Scalars['String']['output'];
  tracking_url?: Maybe<Scalars['String']['output']>;
};

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']['input']>;
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']['input']>;
};

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']['output']>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** Id of the customer address. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Is pickup address */
  is_pickup?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']['output']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** Код ПВЗ */
  nom_code?: Maybe<Scalars['String']['output']>;
  pickup_location_code?: Maybe<Scalars['String']['output']>;
  /** Информация о ПВЗ */
  pickup_point?: Maybe<DeliveryAddress>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** Indicates whether the shipping address is same as billing address. */
  same_as_billing: Scalars['Boolean']['output'];
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String']['input'];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String']['input'];
};

export type Sidebar = {
  __typename?: 'Sidebar';
  /** Number of most view posts. */
  number_mostview_posts?: Maybe<Scalars['Int']['output']>;
  /** Number of recent posts. */
  number_recent_posts?: Maybe<Scalars['Int']['output']>;
};

/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'SimpleProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

export enum SliderDisplayTypeEnum {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

/** Smart button payment inputs */
export type SmartButtonMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars['String']['input']>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars['String']['input']>;
};

export type SmartButtonsConfig = PaymentConfigItem & {
  __typename?: 'SmartButtonsConfig';
  /** Indicated whether to use App Switch on enabled mobile devices */
  app_switch_when_available?: Maybe<Scalars['Boolean']['output']>;
  /** The styles for the PayPal Smart Button configuration */
  button_styles?: Maybe<ButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether to display the PayPal Pay Later message */
  display_message?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether to display Venmo */
  display_venmo?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the payment method is displayed */
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** Contains details about the styles for the PayPal Pay Later message */
  message_styles?: Maybe<MessageStyles>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent?: Maybe<Scalars['String']['output']>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order?: Maybe<Scalars['String']['output']>;
  /** The name displayed for the payment method */
  title?: Maybe<Scalars['String']['output']>;
};

/** SnowdogMenu defines all menu information */
export type SnowdogMenu = {
  __typename?: 'SnowdogMenu';
  /** Menu creation time */
  creation_time: Scalars['String']['output'];
  /** Menu CSS class */
  css_class?: Maybe<Scalars['String']['output']>;
  /** Menu identifier */
  identifier: Scalars['String']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Menu nodes */
  nodes?: Maybe<SnowdogMenuNodes>;
  /** Menu title */
  title: Scalars['String']['output'];
  /** Menu update time */
  update_time: Scalars['String']['output'];
};

/** Snowdog menu CMS page node type */
export type SnowdogMenuCmsPageNode = SnowdogMenuNodeContentFieldInterface & SnowdogMenuNodeInterface & {
  __typename?: 'SnowdogMenuCmsPageNode';
  /** Node additional data */
  additional_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Node classes */
  classes?: Maybe<Scalars['String']['output']>;
  /** Node content */
  content?: Maybe<Scalars['String']['output']>;
  /** Node creation time */
  creation_time: Scalars['String']['output'];
  /** Node level */
  level: Scalars['Int']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Node ID */
  node_id: Scalars['Int']['output'];
  /** Node template */
  node_template?: Maybe<Scalars['String']['output']>;
  /** Node parent ID */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Node position */
  position: Scalars['Int']['output'];
  /** Node submenu template */
  submenu_template?: Maybe<Scalars['String']['output']>;
  /** Node title */
  title?: Maybe<Scalars['String']['output']>;
  /** Node type */
  type: Scalars['String']['output'];
  /** Node update time */
  update_time: Scalars['String']['output'];
  /** Returns the url key when available */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** Snowdog menu custom URL node type */
export type SnowdogMenuCustomUrlNode = SnowdogMenuCustomUrlNodeInterface & SnowdogMenuNodeContentFieldInterface & SnowdogMenuNodeImageFieldInterface & SnowdogMenuNodeInterface & {
  __typename?: 'SnowdogMenuCustomUrlNode';
  /** Node additional data */
  additional_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Node classes */
  classes?: Maybe<Scalars['String']['output']>;
  /** Node content */
  content?: Maybe<Scalars['String']['output']>;
  /** Node creation time */
  creation_time: Scalars['String']['output'];
  /** Node image */
  image?: Maybe<Scalars['String']['output']>;
  /** Node image alt text */
  image_alt_text?: Maybe<Scalars['String']['output']>;
  /** Node level */
  level: Scalars['Int']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Node ID */
  node_id: Scalars['Int']['output'];
  /** Node template */
  node_template?: Maybe<Scalars['String']['output']>;
  /** Node parent ID */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Node position */
  position: Scalars['Int']['output'];
  /** Node submenu template */
  submenu_template?: Maybe<Scalars['String']['output']>;
  /** Node target (false for '_self', true for '_blank') */
  target: Scalars['Boolean']['output'];
  /** Node title */
  title?: Maybe<Scalars['String']['output']>;
  /** Node type */
  type: Scalars['String']['output'];
  /** Node update time */
  update_time: Scalars['String']['output'];
  /** Returns the url key when available */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** SnowdogMenuCustomUrlNodeInterface contains custom URL nodes specific fields */
export type SnowdogMenuCustomUrlNodeInterface = {
  /** Node target (false for '_self', true for '_blank') */
  target: Scalars['Boolean']['output'];
};

/** Snowdog menu default node type */
export type SnowdogMenuNode = SnowdogMenuNodeContentFieldInterface & SnowdogMenuNodeImageFieldInterface & SnowdogMenuNodeInterface & {
  __typename?: 'SnowdogMenuNode';
  /** Node additional data */
  additional_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Node classes */
  classes?: Maybe<Scalars['String']['output']>;
  /** Node content */
  content?: Maybe<Scalars['String']['output']>;
  /** Node creation time */
  creation_time: Scalars['String']['output'];
  /** Node image */
  image?: Maybe<Scalars['String']['output']>;
  /** Node image alt text */
  image_alt_text?: Maybe<Scalars['String']['output']>;
  /** Node level */
  level: Scalars['Int']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Node ID */
  node_id: Scalars['Int']['output'];
  /** Node template */
  node_template?: Maybe<Scalars['String']['output']>;
  /** Node parent ID */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Node position */
  position: Scalars['Int']['output'];
  /** Node submenu template */
  submenu_template?: Maybe<Scalars['String']['output']>;
  /** Node title */
  title?: Maybe<Scalars['String']['output']>;
  /** Node type */
  type: Scalars['String']['output'];
  /** Node update time */
  update_time: Scalars['String']['output'];
  /** Returns the url key when available */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** SnowdogMenuNodeContentFieldsInterface defines node content field */
export type SnowdogMenuNodeContentFieldInterface = {
  /** Node content */
  content?: Maybe<Scalars['String']['output']>;
};

/** SnowdogMenuNodeContentFieldsInterface defines node image fields */
export type SnowdogMenuNodeImageFieldInterface = {
  /** Node image */
  image?: Maybe<Scalars['String']['output']>;
  /** Node image alt text */
  image_alt_text?: Maybe<Scalars['String']['output']>;
};

/** SnowdogMenuNodeInterface contains the fields that are common to all types of nodes */
export type SnowdogMenuNodeInterface = {
  /** Node additional data */
  additional_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Node classes */
  classes?: Maybe<Scalars['String']['output']>;
  /** Node creation time */
  creation_time: Scalars['String']['output'];
  /** Node level */
  level: Scalars['Int']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Node ID */
  node_id: Scalars['Int']['output'];
  /** Node template */
  node_template?: Maybe<Scalars['String']['output']>;
  /** Node parent ID */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Node position */
  position: Scalars['Int']['output'];
  /** Node submenu template */
  submenu_template?: Maybe<Scalars['String']['output']>;
  /** Node title */
  title?: Maybe<Scalars['String']['output']>;
  /** Node type */
  type: Scalars['String']['output'];
  /** Node update time */
  update_time: Scalars['String']['output'];
  /** Returns the url key when available */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** Menu nodes information */
export type SnowdogMenuNodes = {
  __typename?: 'SnowdogMenuNodes';
  /** An array of menu nodes */
  items?: Maybe<Array<Maybe<SnowdogMenuNodeInterface>>>;
};

/** Snowdog menu wrapper node type */
export type SnowdogMenuWrapperNode = SnowdogMenuNodeInterface & {
  __typename?: 'SnowdogMenuWrapperNode';
  /** Node additional data */
  additional_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Node classes */
  classes?: Maybe<Scalars['String']['output']>;
  /** Node creation time */
  creation_time: Scalars['String']['output'];
  /** Node level */
  level: Scalars['Int']['output'];
  /** Menu ID */
  menu_id: Scalars['Int']['output'];
  /** Node ID */
  node_id: Scalars['Int']['output'];
  /** Node template */
  node_template?: Maybe<Scalars['String']['output']>;
  /** Node parent ID */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** Node position */
  position: Scalars['Int']['output'];
  /** Node submenu template */
  submenu_template?: Maybe<Scalars['String']['output']>;
  /** Node title */
  title?: Maybe<Scalars['String']['output']>;
  /** Node type */
  type: Scalars['String']['output'];
  /** Node update time */
  update_time: Scalars['String']['output'];
  /** Returns the url key when available */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** Menus information */
export type SnowdogMenus = {
  __typename?: 'SnowdogMenus';
  /** An array of menus */
  items: Array<Maybe<SnowdogMenu>>;
};

/** Indicates whether to return results in ascending or descending order. */
export enum SortEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField';
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** The default sort field value. */
  default?: Maybe<Scalars['String']['output']>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

/** Specifies the field to use for sorting quote items */
export enum SortQuoteItemsEnum {
  BaseDiscountAmount = 'BASE_DISCOUNT_AMOUNT',
  BaseDiscountTaxCompensationAmount = 'BASE_DISCOUNT_TAX_COMPENSATION_AMOUNT',
  BasePrice = 'BASE_PRICE',
  BasePriceIncTax = 'BASE_PRICE_INC_TAX',
  BaseRowTotal = 'BASE_ROW_TOTAL',
  BaseRowTotalIncTax = 'BASE_ROW_TOTAL_INC_TAX',
  BaseTaxAmount = 'BASE_TAX_AMOUNT',
  BaseTaxBeforeDiscount = 'BASE_TAX_BEFORE_DISCOUNT',
  CreatedAt = 'CREATED_AT',
  CustomPrice = 'CUSTOM_PRICE',
  Description = 'DESCRIPTION',
  DiscountAmount = 'DISCOUNT_AMOUNT',
  DiscountPercent = 'DISCOUNT_PERCENT',
  DiscountTaxCompensationAmount = 'DISCOUNT_TAX_COMPENSATION_AMOUNT',
  FreeShipping = 'FREE_SHIPPING',
  ItemId = 'ITEM_ID',
  Name = 'NAME',
  OriginalCustomPrice = 'ORIGINAL_CUSTOM_PRICE',
  Price = 'PRICE',
  PriceIncTax = 'PRICE_INC_TAX',
  ProductId = 'PRODUCT_ID',
  ProductType = 'PRODUCT_TYPE',
  Qty = 'QTY',
  RowTotal = 'ROW_TOTAL',
  RowTotalIncTax = 'ROW_TOTAL_INC_TAX',
  RowTotalWithDiscount = 'ROW_TOTAL_WITH_DISCOUNT',
  RowWeight = 'ROW_WEIGHT',
  Sku = 'SKU',
  TaxAmount = 'TAX_AMOUNT',
  TaxBeforeDiscount = 'TAX_BEFORE_DISCOUNT',
  TaxPercent = 'TAX_PERCENT',
  UpdatedAt = 'UPDATED_AT',
  Weight = 'WEIGHT'
}

/** Contains information about a store's configuration. */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Advertising warning text. */
  advertising_warning_text?: Maybe<Scalars['String']['output']>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars['String']['output']>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars['String']['output']>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars['String']['output']>;
  /** Minimum number of days between two atopic diary entries. */
  atopic_diary_create_interval_days?: Maybe<Scalars['String']['output']>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']['output']>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Call center working hours. */
  call_center_hours?: Maybe<Scalars['String']['output']>;
  /** checkout/cart/delete_quote_after: quote lifetime in days. */
  cart_expires_in_days?: Maybe<Scalars['Int']['output']>;
  /** checkout/cart_link/use_qty: what to show in the display cart summary, number of items or item quantities. */
  cart_summary_display_quantity?: Maybe<Scalars['Int']['output']>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']['output']>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']['output']>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']['output']>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']['output']>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']['output']>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']['output']>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']['output']>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']['output']>;
  /** checkout/cart/configurable_product_image: which image to use for configurable products. */
  configurable_product_image: ProductImageThumbnail;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the Contact Us form in enabled. */
  contact_enabled: Scalars['Boolean']['output'];
  /** Cookie restriction enabled. */
  cookie_restriction_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Extended Config Data - general/region/state_required */
  countries_with_required_region?: Maybe<Scalars['String']['output']>;
  /** Indicates if the new accounts need confirmation. */
  create_account_confirmation?: Maybe<Scalars['Boolean']['output']>;
  /** Customer access token lifetime. */
  customer_access_token_lifetime?: Maybe<Scalars['Float']['output']>;
  /** Extended Config Data - general/country/default */
  default_country?: Maybe<Scalars['String']['output']>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']['output']>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** Configuration data from tax/display/type */
  display_product_prices_in_catalog: Scalars['Int']['output'];
  /** Configuration data from tax/display/shipping */
  display_shipping_prices: Scalars['Int']['output'];
  /** Extended Config Data - general/region/display_all */
  display_state_if_optional?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration data from tax/weee/apply_vat */
  fixed_product_taxes_apply_tax_to_fpt: Scalars['Boolean']['output'];
  /** Configuration data from tax/weee/display_email */
  fixed_product_taxes_display_prices_in_emails: Scalars['Int']['output'];
  /** Configuration data from tax/weee/display_list */
  fixed_product_taxes_display_prices_in_product_lists: Scalars['Int']['output'];
  /** Configuration data from tax/weee/display_sales */
  fixed_product_taxes_display_prices_in_sales_modules: Scalars['Int']['output'];
  /** Configuration data from tax/weee/display */
  fixed_product_taxes_display_prices_on_product_view_page: Scalars['Int']['output'];
  /** Configuration data from tax/weee/enable */
  fixed_product_taxes_enable: Scalars['Boolean']['output'];
  /** Configuration data from tax/weee/include_in_subtotal */
  fixed_product_taxes_include_fpt_in_subtotal: Scalars['Boolean']['output'];
  /** Free shipping sum. */
  free_shipping_sum?: Maybe<Scalars['String']['output']>;
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']['output']>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** checkout/cart/grouped_product_image: which image to use for grouped products. */
  grouped_product_image: ProductImageThumbnail;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Configuration data from checkout/options/enable_agreements */
  is_checkout_agreements_enabled: Scalars['Boolean']['output'];
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']['output']>;
  /** checkout/options/guest_checkout: whether the guest checkout is enabled or not. */
  is_guest_checkout_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** checkout/options/onepage_checkout_enabled: whether the one page checkout is enabled or not */
  is_one_page_checkout_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** The store locale. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']['output']>;
  /** checkout/options/max_items_display_count: maximum number of items to display in order summary. */
  max_items_in_order_summary?: Maybe<Scalars['Int']['output']>;
  /** Mindbox Customer ID prefix. */
  mindbox_customer_id_prefix?: Maybe<Scalars['String']['output']>;
  /** checkout/sidebar/display: whether to display the minicart or not. */
  minicart_display?: Maybe<Scalars['Boolean']['output']>;
  /** checkout/sidebar/count: maximum number of items to show in minicart. */
  minicart_max_items?: Maybe<Scalars['Int']['output']>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']['output']>;
  /** Indicates whether newsletters are enabled. */
  newsletter_enabled: Scalars['Boolean']['output'];
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Extended Config Data - general/country/optional_zip_countries */
  optional_zip_countries?: Maybe<Scalars['String']['output']>;
  /** Indicates whether orders can be cancelled by customers or not. */
  order_cancellation_enabled: Scalars['Boolean']['output'];
  /** An array containing available cancellation reasons. */
  order_cancellation_reasons: Array<Maybe<CancellationReason>>;
  /** Configuration data from tax/sales_display/full_summary */
  orders_invoices_credit_memos_display_full_summary: Scalars['Boolean']['output'];
  /** Configuration data from tax/sales_display/grandtotal */
  orders_invoices_credit_memos_display_grandtotal: Scalars['Boolean']['output'];
  /** Configuration data from tax/sales_display/price */
  orders_invoices_credit_memos_display_price: Scalars['Int']['output'];
  /** Configuration data from tax/sales_display/shipping */
  orders_invoices_credit_memos_display_shipping_amount: Scalars['Int']['output'];
  /** Configuration data from tax/sales_display/subtotal */
  orders_invoices_credit_memos_display_subtotal: Scalars['Int']['output'];
  /** Configuration data from tax/sales_display/zero_tax */
  orders_invoices_credit_memos_display_zero_tax: Scalars['Boolean']['output'];
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company city. */
  payments_company_city?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company country. */
  payments_company_country?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company name. */
  payments_company_name?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company OGRN. */
  payments_company_ogrn?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company region. */
  payments_company_region?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company schedule. */
  payments_company_schedule?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company street. */
  payments_company_street?: Maybe<Scalars['String']['output']>;
  /** Additional accepting payments company street. */
  payments_company_street_2?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company telephone. */
  payments_company_telephone?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company vat number. */
  payments_company_vat_number?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company zip code. */
  payments_company_zip_code?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars['String']['output']>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** Send emails to recipients. */
  recipient_email?: Maybe<Scalars['String']['output']>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Search suggestion limit. */
  search_suggestion_limit?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company city. */
  second_payments_company_city?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company country. */
  second_payments_company_country?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company name. */
  second_payments_company_name?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company OGRN. */
  second_payments_company_ogrn?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company region. */
  second_payments_company_region?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company schedule. */
  second_payments_company_schedule?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company street. */
  second_payments_company_street?: Maybe<Scalars['String']['output']>;
  /** Additional accepting payments company street. */
  second_payments_company_street_2?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company telephone. */
  second_payments_company_telephone?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company vat number. */
  second_payments_company_vat_number?: Maybe<Scalars['String']['output']>;
  /** Accepting payments company zip code. */
  second_payments_company_zip_code?: Maybe<Scalars['String']['output']>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Email to a Friend configuration. */
  send_friend?: Maybe<SendFriendConfiguration>;
  /** Extended Config Data - tax/cart_display/full_summary */
  shopping_cart_display_full_summary?: Maybe<Scalars['Boolean']['output']>;
  /** Extended Config Data - tax/cart_display/grandtotal */
  shopping_cart_display_grand_total?: Maybe<Scalars['Boolean']['output']>;
  /** Extended Config Data - tax/cart_display/price */
  shopping_cart_display_price?: Maybe<Scalars['Int']['output']>;
  /** Extended Config Data - tax/cart_display/shipping */
  shopping_cart_display_shipping?: Maybe<Scalars['Int']['output']>;
  /** Extended Config Data - tax/cart_display/subtotal */
  shopping_cart_display_subtotal?: Maybe<Scalars['Int']['output']>;
  /** Extended Config Data - tax/cart_display/gift_wrapping */
  shopping_cart_display_tax_gift_wrapping?: Maybe<TaxWrappingEnum>;
  /** Extended Config Data - tax/cart_display/zero_tax */
  shopping_cart_display_zero_tax?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** Store city. */
  store_city?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']['output']>;
  /** Store country. */
  store_country?: Maybe<Scalars['String']['output']>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']['output']>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']['output']>;
  /** Store name. */
  store_name?: Maybe<Scalars['String']['output']>;
  /** Store OGRN. */
  store_ogrn?: Maybe<Scalars['String']['output']>;
  /** Store region. */
  store_region?: Maybe<Scalars['String']['output']>;
  /** Store schedule. */
  store_schedule?: Maybe<Scalars['String']['output']>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']['output']>;
  /** Store street. */
  store_street?: Maybe<Scalars['String']['output']>;
  /** Additional store street. */
  store_street_2?: Maybe<Scalars['String']['output']>;
  /** Store telephone. */
  store_telephone?: Maybe<Scalars['String']['output']>;
  /** Store vat number. */
  store_vat_number?: Maybe<Scalars['String']['output']>;
  /** Store zip code. */
  store_zip_code?: Maybe<Scalars['String']['output']>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']['output']>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']['output']>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']['output']>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']['output']>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']['output']>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']['output']>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']['output']>;
};

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties';
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']['output']>;
};

export type Story = {
  __typename?: 'Story';
  group_id: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  likes: Scalars['Int']['output'];
  media_gallery?: Maybe<Array<Maybe<MediaGalleryType>>>;
  title: Scalars['String']['output'];
};

export type StoryFilterInput = {
  group_id?: InputMaybe<FilterEqualTypeInput>;
};

export type StoryGroup = {
  __typename?: 'StoryGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StoryLikes = {
  __typename?: 'StoryLikes';
  likes: Scalars['Int']['output'];
};

export type StoryOutput = {
  __typename?: 'StoryOutput';
  items?: Maybe<Array<Maybe<Story>>>;
  page_info: SearchResultPageInfo;
  total_count: Scalars['Int']['output'];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput';
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export enum SubscriptionStatusesEnum {
  NotActive = 'NOT_ACTIVE',
  Subscribed = 'SUBSCRIBED',
  Unconfirmed = 'UNCONFIRMED',
  Unsubscribed = 'UNSUBSCRIBED'
}

/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData';
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']['output']>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Swatch attribute metadata input types. */
export enum SwatchInputTypeEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Dropdown = 'DROPDOWN',
  File = 'FILE',
  Gallery = 'GALLERY',
  Hidden = 'HIDDEN',
  Image = 'IMAGE',
  MediaImage = 'MEDIA_IMAGE',
  Multiline = 'MULTILINE',
  Multiselect = 'MULTISELECT',
  Price = 'PRICE',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Undefined = 'UNDEFINED',
  Visual = 'VISUAL',
  Weight = 'WEIGHT'
}

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  __typename?: 'SwatchLayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
};

/** Synchronizes the payment order details */
export type SyncPaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars['String']['input'];
  /** PayPal order ID */
  id: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  /** Timestamp indicating when the tag was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The description of the tag. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a tag is enabled. */
  enabled?: Maybe<Scalars['Int']['output']>;
  /** The import source of the tag. */
  import_source?: Maybe<Scalars['String']['output']>;
  /** The meta description of the tag. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The meta keywords of the tag. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** The meta robot of the tag. */
  meta_robots?: Maybe<Scalars['String']['output']>;
  /** The meta title of the tag. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The name of the tag. */
  name?: Maybe<Scalars['String']['output']>;
  /** The posts assigned to a tag */
  posts?: Maybe<PostsOutputNoPage>;
  /** An ID that identifies the store. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the tag. */
  tag_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp indicating when the tag was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key of the tag. */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type TagsFilterInput = {
  /** Timestamp indicating when the tag was created */
  created_at?: InputMaybe<FilterTypeInput>;
  /** Enabled */
  enabled?: InputMaybe<FilterTypeInput>;
  /** Import Source */
  import_source?: InputMaybe<FilterTypeInput>;
  /** The tag name. Customers use this name to identify the tag. */
  name?: InputMaybe<FilterTypeInput>;
  /** The store id */
  store_ids?: InputMaybe<FilterTypeInput>;
  /** The tag id. Customers use this name to identify the tag. */
  tag_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the tag was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The tag url_key */
  url_key?: InputMaybe<FilterTypeInput>;
};

export type TagsOutput = {
  __typename?: 'TagsOutput';
  /** An array of tags that match the specified search criteria */
  items?: Maybe<Array<Maybe<Tag>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of tags returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TagsOutputNoPage = {
  __typename?: 'TagsOutputNoPage';
  /** An array of tags that match the specified search criteria */
  items?: Maybe<Array<Maybe<Tag>>>;
  /** The number of tags returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']['output'];
  /** A title that describes the tax. */
  title: Scalars['String']['output'];
};

export enum TaxWrappingEnum {
  DisplayExcludingTax = 'DISPLAY_EXCLUDING_TAX',
  DisplayIncludingTax = 'DISPLAY_INCLUDING_TAX',
  DisplayTypeBoth = 'DISPLAY_TYPE_BOTH'
}

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

export type TherapyItem = {
  __typename?: 'TherapyItem';
  actual_days_count?: Maybe<Scalars['Int']['output']>;
  actual_frequency?: Maybe<ApplicationFrequencyEnum>;
  actual_weekdays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  date_end?: Maybe<Scalars['String']['output']>;
  date_start?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prescribed_days_count?: Maybe<Scalars['Int']['output']>;
  prescribed_frequency?: Maybe<ApplicationFrequencyEnum>;
  prescribed_weekdays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  type: TherapyTypeEnum;
};

export type TherapyItemInput = {
  actual_days_count?: InputMaybe<Scalars['Int']['input']>;
  actual_frequency?: InputMaybe<ApplicationFrequencyEnum>;
  actual_weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  date_end?: InputMaybe<Scalars['String']['input']>;
  date_start?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prescribed_days_count?: InputMaybe<Scalars['Int']['input']>;
  prescribed_frequency?: InputMaybe<ApplicationFrequencyEnum>;
  prescribed_weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type: TherapyTypeEnum;
};

export enum TherapyTypeEnum {
  Oral = 'ORAL',
  Topical = 'TOPICAL'
}

/** 3D Secure mode. */
export enum ThreeDsMode {
  Off = 'OFF',
  ScaAlways = 'SCA_ALWAYS',
  ScaWhenRequired = 'SCA_WHEN_REQUIRED'
}

export type ThresholdedRule = {
  __typename?: 'ThresholdedRule';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  is_reached: Scalars['Boolean']['output'];
  minimal_total: Scalars['Float']['output'];
  rule_id: Scalars['Int']['output'];
};

export type ThresholdedRulesOutput = {
  __typename?: 'ThresholdedRulesOutput';
  rules?: Maybe<Array<Maybe<ThresholdedRule>>>;
};

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Topic = {
  __typename?: 'Topic';
  /** The color of the topic. */
  color?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the topic was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The description of the topic. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a topic is enabled. */
  enabled?: Maybe<Scalars['Int']['output']>;
  /** The import source of the topic. */
  import_source?: Maybe<Scalars['String']['output']>;
  /** The meta description of the topic. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The meta keywords of the topic. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** The meta robot of the topic. */
  meta_robots?: Maybe<Scalars['String']['output']>;
  /** The meta title of the topic. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The name of the topic. */
  name?: Maybe<Scalars['String']['output']>;
  /** The post assigned to a topic */
  posts?: Maybe<PostsOutputNoPage>;
  /** An ID that identifies the store. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the topic. */
  topic_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp indicating when the topic was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key of the topic. */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type TopicsFilterInput = {
  /** Timestamp indicating when the topic was created */
  created_at?: InputMaybe<FilterTypeInput>;
  /** Enabled */
  enabled?: InputMaybe<FilterTypeInput>;
  /** Import Source */
  import_source?: InputMaybe<FilterTypeInput>;
  /** The topic name. Customers use this name to identify the topic. */
  name?: InputMaybe<FilterTypeInput>;
  /** The store id */
  store_ids?: InputMaybe<FilterTypeInput>;
  /** The topic id. Customers use this name to identify the topic. */
  topic_id?: InputMaybe<FilterTypeInput>;
  /** Timestamp indicating when the topic was updated */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The topic url_key */
  url_key?: InputMaybe<FilterTypeInput>;
};

export type TopicsOutput = {
  __typename?: 'TopicsOutput';
  /** An array of topics that match the specified search criteria */
  items?: Maybe<Array<Maybe<Topic>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  pageInfo?: Maybe<PageInfo>;
  /** The number of topics returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TopicsOutputNoPage = {
  __typename?: 'TopicsOutputNoPage';
  /** An array of topics that match the specified search criteria */
  items?: Maybe<Array<Maybe<Topic>>>;
  /** The number of topics returned */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Information about total points, available amount to current cart and spent bonuses for current cart. */
export type TotalBonusPointsInfo = {
  __typename?: 'TotalBonusPointsInfo';
  /** Maximum amount available for current cart. */
  available_amount_for_current_cart: Scalars['Float']['output'];
  /** Customer total bonus amount. */
  available_amount_total: Scalars['Float']['output'];
  /** Bonus amount to get for this order. */
  earned_amount: Scalars['Float']['output'];
  /** Applied amount bonuses to current cart. */
  spent_amount_for_current_cart: Scalars['Float']['output'];
};

export type TreatingAcneTogetherFilterInput = {
  city?: InputMaybe<FilterTypeInput>;
};

export type TreatingAcneTogetherRequestCreateInput = {
  /** Action to be taken. */
  action: Array<InputMaybe<Scalars['String']['input']>>;
  /** City of residence or operation. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment or additional information. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Email address used for contact or identification. */
  email: Scalars['String']['input'];
  /** Newsletter subscription. */
  is_subscribed: Scalars['Boolean']['input'];
  /** Full name of the user. */
  name: Scalars['String']['input'];
  /** Phone number including country code. */
  phone_number: Scalars['String']['input'];
  /** Role assigned to the user. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source request */
  source?: InputMaybe<TreatingAcneTogetherRequestSourceEnum>;
};

export enum TreatingAcneTogetherRequestSourceEnum {
  Clinic = 'CLINIC',
  Feedback = 'FEEDBACK',
  School = 'SCHOOL'
}

export type TreatingAcneTogetherSortInput = {
  end_date?: InputMaybe<SortEnum>;
  start_date?: InputMaybe<SortEnum>;
};

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  /** The cart after updating products. */
  cart: Cart;
  /** Contains errors encountered while updating an item to the cart. */
  errors: Array<Maybe<CartUserInputError>>;
};

export type UpdateDiaryEntryInput = {
  care?: InputMaybe<Array<InputMaybe<CareItemInput>>>;
  delete_photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doctor_visit_date?: InputMaybe<Scalars['String']['input']>;
  new_photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  sleep_maintenance_problems?: InputMaybe<Scalars['Int']['input']>;
  sleep_quality?: InputMaybe<Scalars['Int']['input']>;
  therapy?: InputMaybe<Array<InputMaybe<TherapyItemInput>>>;
};

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput';
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist;
};

export type UploadDiaryEntryPhoto = {
  __typename?: 'UploadDiaryEntryPhoto';
  filename?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadDiaryEntryPhotoInput = {
  file_id: Scalars['String']['input'];
};

export type UploadExpertPhotoInput = {
  file_id: Scalars['String']['input'];
};

export type UploadExpertPhotoOutput = {
  __typename?: 'UploadExpertPhotoOutput';
  filename?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadReviewImage = {
  __typename?: 'UploadReviewImage';
  filename?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadReviewImageInput = {
  file_id: Scalars['String']['input'];
};

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars['String']['output']>;
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  Category = 'CATEGORY',
  CmsPage = 'CMS_PAGE',
  Product = 'PRODUCT',
  Promotion = 'PROMOTION',
  Specialist = 'SPECIALIST'
}

/** Defines whether the attribute is filterable in layered navigation. */
export enum UseInLayeredNavigationOptions {
  FilterableNoResult = 'FILTERABLE_NO_RESULT',
  FilterableWithResults = 'FILTERABLE_WITH_RESULTS',
  No = 'NO'
}

export type Vacancy = {
  __typename?: 'Vacancy';
  /** Vacancy city. */
  city?: Maybe<Scalars['String']['output']>;
  /** Vacancy description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Vacancy group ID. */
  group_id?: Maybe<Scalars['Int']['output']>;
  /** Vacancy title. */
  name: Scalars['String']['output'];
  /** Vacancy position. */
  position: Scalars['Int']['output'];
  /** Responsibilities. */
  responsibilities?: Maybe<Scalars['String']['output']>;
  /** Selection process. */
  selection_process?: Maybe<Scalars['String']['output']>;
  /** Vacancy type code. */
  type?: Maybe<Scalars['String']['output']>;
  /** Vacancy type label. */
  type_label?: Maybe<Scalars['String']['output']>;
  /** Vacancy ID. */
  vacancy_id: Scalars['Int']['output'];
  /** What awaits you. */
  what_awaits_you?: Maybe<Scalars['String']['output']>;
  /** What we offer. */
  what_we_offer?: Maybe<Scalars['String']['output']>;
  /** Who we are looking for. */
  who_we_are_looking_for?: Maybe<Scalars['String']['output']>;
};

export type VacancyFilterInput = {
  group_id?: InputMaybe<FilterEqualTypeInput>;
  vacancy_id?: InputMaybe<FilterEqualTypeInput>;
};

export type VacancyGroup = {
  __typename?: 'VacancyGroup';
  /** Vacancy group ID. */
  group_id: Scalars['Int']['output'];
  /** Vacancy group name. */
  name: Scalars['String']['output'];
  /** Vacancy group position. */
  position: Scalars['Int']['output'];
};

export type VacancySearchResult = {
  __typename?: 'VacancySearchResult';
  /** A list of vacancies. */
  items: Array<Maybe<Vacancy>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
  /** The total number of matching vacancies. */
  total_count: Scalars['Int']['output'];
};

/** Defines a customer attribute validation rule. */
export type ValidationRule = {
  __typename?: 'ValidationRule';
  /** Validation rule name applied to a customer attribute. */
  name?: Maybe<ValidationRuleEnum>;
  /** Validation rule value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** List of validation rule names applied to a customer attribute. */
export enum ValidationRuleEnum {
  DateRangeMax = 'DATE_RANGE_MAX',
  DateRangeMin = 'DATE_RANGE_MIN',
  FileExtensions = 'FILE_EXTENSIONS',
  InputValidation = 'INPUT_VALIDATION',
  MaxFileSize = 'MAX_FILE_SIZE',
  MaxImageHeight = 'MAX_IMAGE_HEIGHT',
  MaxImageWidth = 'MAX_IMAGE_WIDTH',
  MaxTextLength = 'MAX_TEXT_LENGTH',
  MinTextLength = 'MIN_TEXT_LENGTH'
}

/** Retrieves the vault configuration */
export type VaultConfigOutput = {
  __typename?: 'VaultConfigOutput';
  /** Credit card vault method configuration */
  credit_card?: Maybe<VaultCreditCardConfig>;
};

export type VaultCreditCardConfig = {
  __typename?: 'VaultCreditCardConfig';
  /** Is vault enabled */
  is_vault_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The parameters required to load the Paypal JS SDK */
  sdk_params?: Maybe<Array<Maybe<SdkParams>>>;
  /** 3DS mode */
  three_ds_mode?: Maybe<ThreeDsMode>;
};

/** Vault payment inputs */
export type VaultMethodInput = {
  /** The payment source for the payment method */
  payment_source?: InputMaybe<Scalars['String']['input']>;
  /** The payment services order ID */
  payments_order_id?: InputMaybe<Scalars['String']['input']>;
  /** PayPal order ID */
  paypal_order_id?: InputMaybe<Scalars['String']['input']>;
  /** The public hash of the token. */
  public_hash?: InputMaybe<Scalars['String']['input']>;
};

/** The payment source information */
export type VaultSetupTokenInput = {
  /** The payment source information */
  payment_source: PaymentSourceInput;
};

/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String']['input'];
};

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates if item is a gift from cart rule */
  is_cart_rule_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message?: Maybe<Scalars['String']['output']>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
  /** User selected gift rule id */
  user_choice_rule_id?: Maybe<Scalars['String']['output']>;
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface & ProductInterface & RoutableInterface & {
  __typename?: 'VirtualProduct';
  /** @deprecated Use the `custom_attributes` field instead. */
  active_components?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  age?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  application_area?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  benefits?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /**
   * Certificate URL
   * @deprecated Use the `custom_attributes` field instead.
   */
  certificate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  composition?: Maybe<Scalars['String']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  description_html?: Maybe<Scalars['String']['output']>;
  /** The average of all the ratings given to the product. */
  detailed_rating?: Maybe<Array<Maybe<ProductDetailedRating>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  diagnostic_label?: Maybe<Scalars['String']['output']>;
  /** Earn bonus percent */
  earned_bonus_percent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  effect?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_opinion_photo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  expert_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_post?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_quote?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  export_opinion_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  for_whom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gallery_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_bioderma?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_esthederm?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  gamma_etat_pur?: Maybe<Scalars['String']['output']>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars['Boolean']['output'];
  /** @deprecated Use the `custom_attributes` field instead. */
  group_type?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mindbox_id?: Maybe<Scalars['String']['output']>;
  mindbox_price_data?: Maybe<MindboxProductPriceData>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  nom_code?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  otdushka?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pol?: Maybe<Scalars['String']['output']>;
  /** The list of products posts. */
  posts?: Maybe<Array<Maybe<Post>>>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  problems?: Maybe<Scalars['String']['output']>;
  /** Product Banners */
  product_banners: Array<Maybe<ProductBanner>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_group?: Maybe<Scalars['String']['output']>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_name_subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  professional_care?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  promo_exclude?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Amount of available stock */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The total count of all the reviews given to the product. */
  question_count: Scalars['Int']['output'];
  /** The list of products questions. */
  questions: ProductQuestions;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** The total recommended percentage of all the reviews given to the product. */
  recommendation_rate: Scalars['Int']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  /** @deprecated Use the `custom_attributes` field instead. */
  shade?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  skin_type?: Maybe<Scalars['String']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Historical SKUs. Returned only when the product is found by a historical SKU. */
  sku_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  structure_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  sun_protection_factor?: Maybe<Scalars['String']['output']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  texture?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  type_of_cosmetic?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  usage_instructions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_expert_url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  video_expert_opinion_video?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  volume?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  vremya_ispolzovaniya?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductPostsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductQuestionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortEnum>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError';
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

/** A list of possible error types. */
export enum WishListUserInputErrorType {
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  Undefined = 'UNDEFINED'
}

/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist';
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']['output']>;
};


/** Contains a customer wish list. */
export type WishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError';
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID']['output'];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID']['output'];
};

/** A list of possible error types. */
export enum WishlistCartUserInputErrorType {
  InsufficientStock = 'INSUFFICIENT_STOCK',
  NotSalable = 'NOT_SALABLE',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  Undefined = 'UNDEFINED'
}

/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']['output']>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** The amount or number of items to add. */
  quantity: Scalars['Float']['input'];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String']['input'];
};

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID']['input'];
};

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems';
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput';
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddressFragment = { __typename?: 'CustomerAddress', city?: string | null, firstname?: string | null, id?: number | null, lastname?: string | null, middlename?: string | null, postcode?: string | null, country_code?: CountryCodeEnum | null, street?: Array<string | null> | null, telephone?: string | null, default_shipping?: boolean | null, is_pickup?: string | null, center_longitude?: string | null, center_latitude?: string | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null } | null, custom_attributesV2: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string } | { __typename?: 'AttributeSelectedOptions', code: string } | { __typename?: 'AttributeValue', value: string, code: string } | null>, extension_attributes?: Array<{ __typename?: 'CustomerAddressAttribute', attribute_code?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'AddressFragment' };

export type AggregationFragment = { __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', count?: number | null, label?: string | null, value: string } | null> | null } & { ' $fragmentName'?: 'AggregationFragment' };

export type BannerFragment = { __typename?: 'BannerEntity', id: string, slug: string, show_from?: string | null, show_to?: string | null, device_type: Array<BannerDeviceTypeEnum | null>, entity_type: BannerEntityTypeEnum, banner_type?: BannerTypeEnum | null, children: Array<string | null>, banner_data: { __typename?: 'BannerData', display_type?: SliderDisplayTypeEnum | null, slides_to_display?: number | null, slides_to_display_tablet?: number | null, slides_to_display_mobile?: number | null, slides_to_scroll?: number | null, slides_to_scroll_tablet?: number | null, slides_to_scroll_mobile?: number | null, slide_speed?: number | null, lazy_load?: boolean | null, size?: BannerSize | null, background_color?: string | null, title?: string | null, show_all_link?: string | null, discount_label?: string | null, first_link?: string | null, first_link_label?: string | null, first_link_new_tab: boolean, second_link?: string | null, second_link_label?: string | null, second_link_new_tab: boolean, disclaimer_text?: string | null, erid?: string | null, button_display?: ButtonDisplayEnum | null, button_text?: string | null, button_position?: ButtonPositionEnum | null, desktop_image?: string | null, desktop_image_alt?: string | null, tablet_image?: string | null, tablet_image_alt?: string | null, mobile_image?: string | null, mobile_image_alt?: string | null, large_text?: string | null, small_text?: string | null, counter?: string | null, banner_link?: string | null, open_in_new_tab: boolean, height?: number | null, width?: number | null, theme?: BannerThemeEnum | null, text_position?: BannerTextPositionEnum | null, footnote?: string | null, desktop_video?: string | null, tablet_video?: string | null, mobile_video?: string | null, information?: string | null, information_second_line?: string | null, pdp_position?: PagePosition | null, highlight_with_color?: boolean | null } } & { ' $fragmentName'?: 'BannerFragment' };

export type CartFragment = { __typename?: 'Cart', id: string, total_quantity: number, free_shipping_by_coupon?: boolean | null, itemsV2?: { __typename?: 'CartItems', items: Array<(
      { __typename?: 'BundleCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_BundleCartItem_Fragment': CartItem_BundleCartItem_Fragment } }
    ) | (
      { __typename?: 'CertificateCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_CertificateCartItem_Fragment': CartItem_CertificateCartItem_Fragment } }
    ) | (
      { __typename?: 'ConfigurableCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_ConfigurableCartItem_Fragment': CartItem_ConfigurableCartItem_Fragment } }
    ) | (
      { __typename?: 'DownloadableCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_DownloadableCartItem_Fragment': CartItem_DownloadableCartItem_Fragment } }
    ) | (
      { __typename?: 'GroupedCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_GroupedCartItem_Fragment': CartItem_GroupedCartItem_Fragment } }
    ) | (
      { __typename?: 'SimpleCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_SimpleCartItem_Fragment': CartItem_SimpleCartItem_Fragment } }
    ) | (
      { __typename?: 'VirtualCartItem' }
      & { ' $fragmentRefs'?: { 'CartItem_VirtualCartItem_Fragment': CartItem_VirtualCartItem_Fragment } }
    ) | null> } | null, prices?: { __typename?: 'CartPrices', grand_total?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null, subtotal_excluding_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', selected_shipping_method?: { __typename?: 'SelectedShippingMethod', amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | null>, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null, certificates_amount?: { __typename?: 'Money', value?: number | null } | null, applied_certificates?: Array<{ __typename?: 'AppliedCertificate', code?: string | null } | null> | null, total_bonus_points_info?: { __typename?: 'TotalBonusPointsInfo', available_amount_for_current_cart: number, available_amount_total: number, earned_amount: number, spent_amount_for_current_cart: number } | null } & { ' $fragmentName'?: 'CartFragment' };

type CartItem_BundleCartItem_Fragment = { __typename?: 'BundleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_BundleCartItem_Fragment' };

type CartItem_CertificateCartItem_Fragment = { __typename?: 'CertificateCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_CertificateCartItem_Fragment' };

type CartItem_ConfigurableCartItem_Fragment = { __typename?: 'ConfigurableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_ConfigurableCartItem_Fragment' };

type CartItem_DownloadableCartItem_Fragment = { __typename?: 'DownloadableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_DownloadableCartItem_Fragment' };

type CartItem_GroupedCartItem_Fragment = { __typename?: 'GroupedCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_GroupedCartItem_Fragment' };

type CartItem_SimpleCartItem_Fragment = { __typename?: 'SimpleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_SimpleCartItem_Fragment' };

type CartItem_VirtualCartItem_Fragment = { __typename?: 'VirtualCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ), prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total_including_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItem_VirtualCartItem_Fragment' };

export type CartItemFragment = CartItem_BundleCartItem_Fragment | CartItem_CertificateCartItem_Fragment | CartItem_ConfigurableCartItem_Fragment | CartItem_DownloadableCartItem_Fragment | CartItem_GroupedCartItem_Fragment | CartItem_SimpleCartItem_Fragment | CartItem_VirtualCartItem_Fragment;

type CartItemCheckout_BundleCartItem_Fragment = { __typename?: 'BundleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_BundleCartItem_Fragment' };

type CartItemCheckout_CertificateCartItem_Fragment = { __typename?: 'CertificateCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_CertificateCartItem_Fragment' };

type CartItemCheckout_ConfigurableCartItem_Fragment = { __typename?: 'ConfigurableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_ConfigurableCartItem_Fragment' };

type CartItemCheckout_DownloadableCartItem_Fragment = { __typename?: 'DownloadableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_DownloadableCartItem_Fragment' };

type CartItemCheckout_GroupedCartItem_Fragment = { __typename?: 'GroupedCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_GroupedCartItem_Fragment' };

type CartItemCheckout_SimpleCartItem_Fragment = { __typename?: 'SimpleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_SimpleCartItem_Fragment' };

type CartItemCheckout_VirtualCartItem_Fragment = { __typename?: 'VirtualCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, user_choice_rule_id?: string | null, product: { __typename: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } | { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, stockStatus?: ProductStockStatus | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, thumbnail?: (
      { __typename?: 'ProductImage' }
      & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
    ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, row_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_item_discount?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null } & { ' $fragmentName'?: 'CartItemCheckout_VirtualCartItem_Fragment' };

export type CartItemCheckoutFragment = CartItemCheckout_BundleCartItem_Fragment | CartItemCheckout_CertificateCartItem_Fragment | CartItemCheckout_ConfigurableCartItem_Fragment | CartItemCheckout_DownloadableCartItem_Fragment | CartItemCheckout_GroupedCartItem_Fragment | CartItemCheckout_SimpleCartItem_Fragment | CartItemCheckout_VirtualCartItem_Fragment;

export type CartMiniFragment = { __typename?: 'Cart', id: string, itemsV2?: { __typename?: 'CartItems', items: Array<{ __typename?: 'BundleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'CertificateCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'ConfigurableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'DownloadableCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'GroupedCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'SimpleCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | { __typename?: 'VirtualCartItem', id: string, quantity: number, is_cart_rule_gift?: boolean | null, product: { __typename?: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null } | { __typename?: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, name?: string | null, image?: (
          { __typename?: 'ProductImage' }
          & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
        ) | null, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions' } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue' } | null> } | null }, prices?: { __typename?: 'CartItemPrices', price: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null } | null> } | null } & { ' $fragmentName'?: 'CartMiniFragment' };

export type CategoryFragment = { __typename?: 'CategoryTree', uid: string, name?: string | null, level?: number | null, url_key?: string | null, url_path?: string | null, path?: string | null, position?: number | null, children_count?: string | null, image?: string | null, description?: string | null } & { ' $fragmentName'?: 'CategoryFragment' };

export type CheckoutFragment = { __typename?: 'Cart', id: string, email?: string | null, free_shipping_by_coupon?: boolean | null, itemsV2?: { __typename?: 'CartItems', items: Array<(
      { __typename?: 'BundleCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_BundleCartItem_Fragment': CartItemCheckout_BundleCartItem_Fragment } }
    ) | (
      { __typename?: 'CertificateCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_CertificateCartItem_Fragment': CartItemCheckout_CertificateCartItem_Fragment } }
    ) | (
      { __typename?: 'ConfigurableCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_ConfigurableCartItem_Fragment': CartItemCheckout_ConfigurableCartItem_Fragment } }
    ) | (
      { __typename?: 'DownloadableCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_DownloadableCartItem_Fragment': CartItemCheckout_DownloadableCartItem_Fragment } }
    ) | (
      { __typename?: 'GroupedCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_GroupedCartItem_Fragment': CartItemCheckout_GroupedCartItem_Fragment } }
    ) | (
      { __typename?: 'SimpleCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_SimpleCartItem_Fragment': CartItemCheckout_SimpleCartItem_Fragment } }
    ) | (
      { __typename?: 'VirtualCartItem' }
      & { ' $fragmentRefs'?: { 'CartItemCheckout_VirtualCartItem_Fragment': CartItemCheckout_VirtualCartItem_Fragment } }
    ) | null> } | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', id?: number | null, firstname: string, lastname: string, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, customer_notes?: string | null, pickup_location_code?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null, label?: string | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string }, pickup_point?: (
      { __typename?: 'DeliveryAddress' }
      & { ' $fragmentRefs'?: { 'PickupPointFragment': PickupPointFragment } }
    ) | null, selected_shipping_method?: { __typename?: 'SelectedShippingMethod', carrier_code: string, method_code: string, carrier_title: string, method_title: string, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null, available_shipping_methods?: Array<(
      { __typename?: 'AvailableShippingMethod' }
      & { ' $fragmentRefs'?: { 'ShippingMethodFragment': ShippingMethodFragment } }
    ) | null> | null } | null>, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null, prices?: { __typename?: 'CartPrices', grand_total?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null, subtotal_excluding_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null, certificates_amount?: { __typename?: 'Money', value?: number | null } | null, applied_certificates?: Array<{ __typename?: 'AppliedCertificate', code?: string | null } | null> | null, total_bonus_points_info?: { __typename?: 'TotalBonusPointsInfo', available_amount_for_current_cart: number, available_amount_total: number, earned_amount: number, spent_amount_for_current_cart: number } | null } & { ' $fragmentName'?: 'CheckoutFragment' };

export type ConfigurableProductFragment = { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null } | null> | null, product?: (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_SimpleProduct_Fragment': SimpleProduct_SimpleProduct_Fragment } }
    ) | null } | null> | null } & { ' $fragmentName'?: 'ConfigurableProductFragment' };

export type CustomerFragment = { __typename?: 'Customer', id?: number | null, firstname?: string | null, lastname?: string | null, middlename?: string | null, email?: string | null, date_of_birth?: string | null, gender?: number | null, is_subscribed?: boolean | null, custom_attributes?: Array<{ __typename: 'AttributeSelectedColorfulOptions', code: string } | { __typename: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename: 'AttributeValue', value: string, code: string } | null> | null } & { ' $fragmentName'?: 'CustomerFragment' };

export type GroupedProductFragment = { __typename?: 'GroupedProduct', groupType?: number | null, items?: Array<{ __typename?: 'GroupedProductItem', position?: number | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_BundleProduct_Fragment': SimpleProduct_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_CertificateProduct_Fragment': SimpleProduct_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_ConfigurableProduct_Fragment': SimpleProduct_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_DownloadableProduct_Fragment': SimpleProduct_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_GroupedProduct_Fragment': SimpleProduct_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_SimpleProduct_Fragment': SimpleProduct_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_VirtualProduct_Fragment': SimpleProduct_VirtualProduct_Fragment } }
    ) | null } | null> | null } & { ' $fragmentName'?: 'GroupedProductFragment' };

export type OrderFragment = { __typename?: 'CustomerOrder', id: string, number: string, order_date: string, delivery_date_from?: string | null, delivery_date_actual?: string | null, delivery_time?: string | null, order_status_change_date: string, receipt_url?: string | null, payment_timeout?: number | null, bonus_earned_amount?: number | null, customer_comment?: string | null, status: string, status_code: string, email?: string | null, carrier?: string | null, shipping_method?: string | null, gateway_url?: string | null, qr_code?: string | null, token: string, can_be_canceled?: boolean | null, is_virtual: boolean, pickup_address?: { __typename?: 'DeliveryAddress', city?: string | null, nom_code?: string | null, point_type?: string | null, work_time?: string | null, latitude?: string | null, longitude?: string | null, address?: string | null, phone?: string | null } | null, total?: { __typename?: 'OrderTotal', base_grand_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, grand_total: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, subtotal: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, subtotal_excl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, subtotal_incl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, total_shipping: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } | null> | null } | null, shipments?: Array<{ __typename?: 'OrderShipment', tracking?: Array<{ __typename?: 'ShipmentTracking', number?: string | null, carrier: string, title: string, tracking_url?: string | null } | null> | null } | null> | null, shipping_address?: { __typename?: 'OrderAddress', firstname: string, lastname: string, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, country_code?: CountryCodeEnum | null, comment?: string | null } | null, payment_methods?: Array<{ __typename?: 'OrderPaymentMethod', name: string, type: string, additional_data?: Array<{ __typename?: 'KeyValue', name?: string | null, value?: string | null } | null> | null } | null> | null, items?: Array<{ __typename?: 'BundleOrderItem', id: string, product_name?: string | null, status?: string | null, quantity_ordered?: number | null, prices?: { __typename?: 'OrderItemPrices', original_price_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null } | { __typename?: 'CertificateOrderItem', id: string, product_name?: string | null, status?: string | null, quantity_ordered?: number | null, certificate?: { __typename?: 'CertificateItem', send_date?: string | null, design_url?: string | null } | null, prices?: { __typename?: 'OrderItemPrices', original_price_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null } | { __typename?: 'ConfigurableOrderItem', id: string, product_name?: string | null, status?: string | null, quantity_ordered?: number | null, prices?: { __typename?: 'OrderItemPrices', original_price_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null } | { __typename?: 'DownloadableOrderItem', id: string, product_name?: string | null, status?: string | null, quantity_ordered?: number | null, prices?: { __typename?: 'OrderItemPrices', original_price_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null } | { __typename?: 'OrderItem', id: string, product_name?: string | null, status?: string | null, quantity_ordered?: number | null, prices?: { __typename?: 'OrderItemPrices', original_price_including_tax?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null, product?: (
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null } | null> | null } & { ' $fragmentName'?: 'OrderFragment' };

export type PageInfoFragment = { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } & { ' $fragmentName'?: 'PageInfoFragment' };

export type PickupPointFragment = { __typename?: 'DeliveryAddress', id: string, nom_code?: string | null, name?: string | null, address?: string | null, city?: string | null, region?: string | null, phone?: string | null, work_time?: string | null, latitude?: string | null, price?: string | null, longitude?: string | null, point_type?: string | null, type?: string | null, day_from?: string | null, day_to?: string | null } & { ' $fragmentName'?: 'PickupPointFragment' };

type Product_BundleProduct_Fragment = (
  { __typename: 'BundleProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_BundleProduct_Fragment': SimpleProduct_BundleProduct_Fragment } }
) & { ' $fragmentName'?: 'Product_BundleProduct_Fragment' };

type Product_CertificateProduct_Fragment = (
  { __typename: 'CertificateProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_CertificateProduct_Fragment': SimpleProduct_CertificateProduct_Fragment } }
) & { ' $fragmentName'?: 'Product_CertificateProduct_Fragment' };

type Product_ConfigurableProduct_Fragment = (
  { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_ConfigurableProduct_Fragment': SimpleProduct_ConfigurableProduct_Fragment;'ConfigurableProductFragment': ConfigurableProductFragment } }
) & { ' $fragmentName'?: 'Product_ConfigurableProduct_Fragment' };

type Product_DownloadableProduct_Fragment = (
  { __typename: 'DownloadableProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_DownloadableProduct_Fragment': SimpleProduct_DownloadableProduct_Fragment } }
) & { ' $fragmentName'?: 'Product_DownloadableProduct_Fragment' };

type Product_GroupedProduct_Fragment = (
  { __typename: 'GroupedProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_GroupedProduct_Fragment': SimpleProduct_GroupedProduct_Fragment;'GroupedProductFragment': GroupedProductFragment } }
) & { ' $fragmentName'?: 'Product_GroupedProduct_Fragment' };

type Product_SimpleProduct_Fragment = (
  { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_SimpleProduct_Fragment': SimpleProduct_SimpleProduct_Fragment } }
) & { ' $fragmentName'?: 'Product_SimpleProduct_Fragment' };

type Product_VirtualProduct_Fragment = (
  { __typename: 'VirtualProduct', id?: number | null, sku?: string | null, sku_history?: Array<string | null> | null, name?: string | null, url_key?: string | null, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'SimpleProduct_VirtualProduct_Fragment': SimpleProduct_VirtualProduct_Fragment } }
) & { ' $fragmentName'?: 'Product_VirtualProduct_Fragment' };

export type ProductFragment = Product_BundleProduct_Fragment | Product_CertificateProduct_Fragment | Product_ConfigurableProduct_Fragment | Product_DownloadableProduct_Fragment | Product_GroupedProduct_Fragment | Product_SimpleProduct_Fragment | Product_VirtualProduct_Fragment;

type ProductCategories_BundleProduct_Fragment = { __typename?: 'BundleProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_BundleProduct_Fragment' };

type ProductCategories_CertificateProduct_Fragment = { __typename?: 'CertificateProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_CertificateProduct_Fragment' };

type ProductCategories_ConfigurableProduct_Fragment = { __typename?: 'ConfigurableProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_ConfigurableProduct_Fragment' };

type ProductCategories_DownloadableProduct_Fragment = { __typename?: 'DownloadableProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_DownloadableProduct_Fragment' };

type ProductCategories_GroupedProduct_Fragment = { __typename?: 'GroupedProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_GroupedProduct_Fragment' };

type ProductCategories_SimpleProduct_Fragment = { __typename?: 'SimpleProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_SimpleProduct_Fragment' };

type ProductCategories_VirtualProduct_Fragment = { __typename?: 'VirtualProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, color?: string | null, level?: number | null, url?: string | null, isBrand?: number | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, url?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ProductCategories_VirtualProduct_Fragment' };

export type ProductCategoriesFragment = ProductCategories_BundleProduct_Fragment | ProductCategories_CertificateProduct_Fragment | ProductCategories_ConfigurableProduct_Fragment | ProductCategories_DownloadableProduct_Fragment | ProductCategories_GroupedProduct_Fragment | ProductCategories_SimpleProduct_Fragment | ProductCategories_VirtualProduct_Fragment;

export type ProductImageFragment = { __typename?: 'ProductImage', src?: string | null, alt?: string | null } & { ' $fragmentName'?: 'ProductImageFragment' };

export type ProductReviewFragment = { __typename?: 'ProductReview', id: string, summary?: string | null, text: string, nickname: string, created_at: string, average_rating: number, is_recommended?: boolean | null, age?: number | null, skin_type?: string | null, skin_problem?: string | null, pros?: string | null, cons?: string | null, is_external?: boolean | null, source?: string | null, source_logo?: string | null, source_url?: string | null, answer?: string | null, images?: Array<string | null> | null, product: { __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'CertificateProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null }, answer_product?: { __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'CertificateProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null } | null } | null, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } & { ' $fragmentName'?: 'ProductReviewFragment' };

export type QuestionFragment = { __typename?: 'ProductQuestion', product_sku: string, question: string, answer?: string | null, customer_name: string, age?: number | null, email?: string | null, skin_type?: string | null, skin_problem?: string | null, created_at: string, answer_product?: { __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'CertificateProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null, thumbnail?: { __typename?: 'ProductImage', url?: string | null, label?: string | null } | null } | null } & { ' $fragmentName'?: 'QuestionFragment' };

export type ShippingMethodFragment = { __typename?: 'AvailableShippingMethod', carrier_code: string, carrier_title: string, method_code?: string | null, method_title?: string | null, available: boolean, delivery_date_from?: string | null, description?: string | null, day_from?: string | null, day_to?: string | null, amount: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null }, price_incl_tax: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } } & { ' $fragmentName'?: 'ShippingMethodFragment' };

type SimpleProduct_BundleProduct_Fragment = { __typename: 'BundleProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_BundleProduct_Fragment' };

type SimpleProduct_CertificateProduct_Fragment = { __typename: 'CertificateProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_CertificateProduct_Fragment' };

type SimpleProduct_ConfigurableProduct_Fragment = { __typename: 'ConfigurableProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_ConfigurableProduct_Fragment' };

type SimpleProduct_DownloadableProduct_Fragment = { __typename: 'DownloadableProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_DownloadableProduct_Fragment' };

type SimpleProduct_GroupedProduct_Fragment = { __typename: 'GroupedProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_GroupedProduct_Fragment' };

type SimpleProduct_SimpleProduct_Fragment = { __typename: 'SimpleProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_SimpleProduct_Fragment' };

type SimpleProduct_VirtualProduct_Fragment = { __typename: 'VirtualProduct', sku?: string | null, mindbox_id?: string | null, url_key?: string | null, certificate?: string | null, meta_description?: string | null, meta_title?: string | null, special_price?: number | null, only_x_left_in_stock?: number | null, earned_bonus_percent?: number | null, description_html?: string | null, ingredients?: string | null, ratingSummary: number, stockStatus?: ProductStockStatus | null, reviewCount: number, detailedRating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, price: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null }, image?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, thumbnail?: (
    { __typename?: 'ProductImage' }
    & { ' $fragmentRefs'?: { 'ProductImageFragment': ProductImageFragment } }
  ) | null, mediaGallery?: Array<{ __typename: 'ProductImage', types?: Array<string | null> | null, position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | { __typename: 'ProductVideo', position?: number | null, url?: string | null, label?: string | null, disabled?: boolean | null } | null> | null, banners: Array<{ __typename?: 'ProductBanner', position: PagePosition, entity: (
      { __typename?: 'BannerEntity' }
      & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
    ) } | null>, attributes?: { __typename?: 'ProductCustomAttributes', items: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string, color?: string | null, url?: string | null } | null> } | { __typename?: 'AttributeSelectedOptions', code: string, selected_options: Array<{ __typename?: 'AttributeSelectedColorfulOption', label: string, value: string } | { __typename?: 'AttributeSelectedOption', label: string, value: string } | null> } | { __typename?: 'AttributeValue', code: string, value: string } | null> } | null } & { ' $fragmentName'?: 'SimpleProduct_VirtualProduct_Fragment' };

export type SimpleProductFragment = SimpleProduct_BundleProduct_Fragment | SimpleProduct_CertificateProduct_Fragment | SimpleProduct_ConfigurableProduct_Fragment | SimpleProduct_DownloadableProduct_Fragment | SimpleProduct_GroupedProduct_Fragment | SimpleProduct_SimpleProduct_Fragment | SimpleProduct_VirtualProduct_Fragment;

type WishlistItem_BundleWishlistItem_Fragment = { __typename?: 'BundleWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_BundleWishlistItem_Fragment' };

type WishlistItem_CertificateWishlistItem_Fragment = { __typename?: 'CertificateWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_CertificateWishlistItem_Fragment' };

type WishlistItem_ConfigurableWishlistItem_Fragment = { __typename?: 'ConfigurableWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_ConfigurableWishlistItem_Fragment' };

type WishlistItem_DownloadableWishlistItem_Fragment = { __typename?: 'DownloadableWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_DownloadableWishlistItem_Fragment' };

type WishlistItem_GroupedProductWishlistItem_Fragment = { __typename?: 'GroupedProductWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_GroupedProductWishlistItem_Fragment' };

type WishlistItem_SimpleWishlistItem_Fragment = { __typename?: 'SimpleWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_SimpleWishlistItem_Fragment' };

type WishlistItem_VirtualWishlistItem_Fragment = { __typename?: 'VirtualWishlistItem', id: string, quantity: number, added_at: string, description?: string | null, product?: (
    { __typename?: 'BundleProduct' }
    & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
  ) | (
    { __typename?: 'CertificateProduct' }
    & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
  ) | (
    { __typename?: 'ConfigurableProduct' }
    & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
  ) | (
    { __typename?: 'DownloadableProduct' }
    & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
  ) | (
    { __typename?: 'GroupedProduct' }
    & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
  ) | (
    { __typename?: 'SimpleProduct' }
    & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
  ) | (
    { __typename?: 'VirtualProduct' }
    & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
  ) | null } & { ' $fragmentName'?: 'WishlistItem_VirtualWishlistItem_Fragment' };

export type WishlistItemFragment = WishlistItem_BundleWishlistItem_Fragment | WishlistItem_CertificateWishlistItem_Fragment | WishlistItem_ConfigurableWishlistItem_Fragment | WishlistItem_DownloadableWishlistItem_Fragment | WishlistItem_GroupedProductWishlistItem_Fragment | WishlistItem_SimpleWishlistItem_Fragment | WishlistItem_VirtualWishlistItem_Fragment;

export type AddProductsToCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItems: Array<CartItemInput> | CartItemInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type AddProductsToCartMutation = { __typename?: 'Mutation', addProductsToCart?: { __typename?: 'AddProductsToCartOutput', cart: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartMiniFragment': CartMiniFragment } }
    ) } | null };

export type AddProductsToWishlistMutationVariables = Exact<{
  wishlistId: Scalars['ID']['input'];
  wishlistItems: Array<WishlistItemInput> | WishlistItemInput;
}>;


export type AddProductsToWishlistMutation = { __typename?: 'Mutation', addProductsToWishlist?: { __typename?: 'AddProductsToWishlistOutput', wishlist: { __typename?: 'Wishlist', id?: string | null, items_count?: number | null, sharing_code?: string | null, updated_at?: string | null, items_v2?: { __typename?: 'WishlistItems', items: Array<(
          { __typename?: 'BundleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_BundleWishlistItem_Fragment': WishlistItem_BundleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'CertificateWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_CertificateWishlistItem_Fragment': WishlistItem_CertificateWishlistItem_Fragment } }
        ) | (
          { __typename?: 'ConfigurableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_ConfigurableWishlistItem_Fragment': WishlistItem_ConfigurableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'DownloadableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_DownloadableWishlistItem_Fragment': WishlistItem_DownloadableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'GroupedProductWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_GroupedProductWishlistItem_Fragment': WishlistItem_GroupedProductWishlistItem_Fragment } }
        ) | (
          { __typename?: 'SimpleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_SimpleWishlistItem_Fragment': WishlistItem_SimpleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'VirtualWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_VirtualWishlistItem_Fragment': WishlistItem_VirtualWishlistItem_Fragment } }
        ) | null> } | null } } | null };

export type AddSamplerToCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
}>;


export type AddSamplerToCartMutation = { __typename?: 'Mutation', addProductsToCart?: { __typename?: 'AddProductsToCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type ApplyBonusPointsToCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  bonusPoints: Scalars['Float']['input'];
}>;


export type ApplyBonusPointsToCartMutation = { __typename?: 'Mutation', applyBonusPointsToCart?: { __typename?: 'ApplyBonusPointsToCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type ApplyCertificateToCartMutationVariables = Exact<{
  input: ApplyCertificateToCartInput;
}>;


export type ApplyCertificateToCartMutation = { __typename?: 'Mutation', applyCertificateToCart?: { __typename?: 'ApplyCertificateToCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type ApplyCouponToCartMutationVariables = Exact<{
  input: ApplyCouponToCartInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type ApplyCouponToCartMutation = { __typename?: 'Mutation', applyCouponToCart?: { __typename?: 'ApplyCouponToCartOutput', cart: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartFragment': CartFragment } }
    ) } | null };

export type AuthorizeByPhoneMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type AuthorizeByPhoneMutation = { __typename?: 'Mutation', authorizeByPhone?: { __typename?: 'CustomerToken', token?: string | null } | null };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: { __typename?: 'CancelOrderOutput', errorV2?: { __typename?: 'CancelOrderError', code: CancelOrderErrorCode, message: string } | null, order?: { __typename?: 'CustomerOrder', status: string } | null } | null };

export type ChangeCustomerPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangeCustomerPasswordMutation = { __typename?: 'Mutation', changeCustomerPassword?: { __typename?: 'Customer', id?: number | null, email?: string | null } | null };

export type ContactUsMutationVariables = Exact<{
  input: ContactUsInput;
}>;


export type ContactUsMutation = { __typename?: 'Mutation', contactUs?: { __typename?: 'ContactUsOutput', status: boolean } | null };

export type CreateAcneRequestMutationVariables = Exact<{
  input: TreatingAcneTogetherRequestCreateInput;
}>;


export type CreateAcneRequestMutation = { __typename?: 'Mutation', createAcneRequest?: boolean | null };

export type CreateBlogCommentMutationVariables = Exact<{
  input: BlogCommentCreateInput;
}>;


export type CreateBlogCommentMutation = { __typename?: 'Mutation', createBlogComment?: boolean | null };

export type CreateCombinedMethodsQuestionMutationVariables = Exact<{
  input: CombinedMethodsQuestionInput;
}>;


export type CreateCombinedMethodsQuestionMutation = { __typename?: 'Mutation', createCombinedMethodsQuestion?: boolean | null };

export type CreateCombinedMethodsRequestMutationVariables = Exact<{
  input: CombinedMethodsRequestInput;
}>;


export type CreateCombinedMethodsRequestMutation = { __typename?: 'Mutation', createCombinedMethodsRequest?: boolean | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerCreateInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomerV2?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', email?: string | null } } | null };

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CustomerAddressInput;
}>;


export type CreateCustomerAddressMutation = { __typename?: 'Mutation', createCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, telephone?: string | null, street?: Array<string | null> | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null } | null, custom_attributesV2: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string } | { __typename?: 'AttributeSelectedOptions', code: string } | { __typename?: 'AttributeValue', value: string, code: string } | null> } | null };

export type CreateDiagnosticResultMutationVariables = Exact<{
  input: DiagnosticResultCreateInput;
}>;


export type CreateDiagnosticResultMutation = { __typename?: 'Mutation', createDiagnosticResult?: { __typename?: 'DiagnosticResult', uid?: string | null, product_list?: string | null, customer_id?: string | null, customer_name?: string | null, customer_email?: string | null, created_at?: string | null } | null };

export type CreateDoctorMutationVariables = Exact<{
  input: CreateExpertInput;
}>;


export type CreateDoctorMutation = { __typename?: 'Mutation', createDoctor?: { __typename?: 'CreateExpertOutput', success: boolean, message?: string | null, expert?: { __typename?: 'Expert', full_name: string, city?: string | null, photo?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null } | null> | null } | null } | null };

export type CreateGuestCartMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGuestCartMutation = { __typename?: 'Mutation', createGuestCart?: { __typename?: 'CreateGuestCartOutput', cart?: { __typename?: 'Cart', id: string } | null } | null };

export type CreateProductReviewMutationVariables = Exact<{
  input: CreateProductReviewInput;
}>;


export type CreateProductReviewMutation = { __typename?: 'Mutation', createProductReview: { __typename?: 'CreateProductReviewOutput', review: { __typename?: 'ProductReview', summary?: string | null, text: string, nickname: string, created_at: string, average_rating: number, is_recommended?: boolean | null, age?: number | null, skin_type?: string | null, skin_problem?: string | null, pros?: string | null, cons?: string | null, answer?: string | null, images?: Array<string | null> | null, product: { __typename?: 'BundleProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'CertificateProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'ConfigurableProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'DownloadableProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'GroupedProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'SimpleProduct', name?: string | null, sku?: string | null, url_key?: string | null } | { __typename?: 'VirtualProduct', name?: string | null, sku?: string | null, url_key?: string | null }, answer_product?: { __typename?: 'BundleProduct', name?: string | null } | { __typename?: 'CertificateProduct', name?: string | null } | { __typename?: 'ConfigurableProduct', name?: string | null } | { __typename?: 'DownloadableProduct', name?: string | null } | { __typename?: 'GroupedProduct', name?: string | null } | { __typename?: 'SimpleProduct', name?: string | null } | { __typename?: 'VirtualProduct', name?: string | null } | null, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> }, recommend_products?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_BundleProduct_Fragment': SimpleProduct_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_CertificateProduct_Fragment': SimpleProduct_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_ConfigurableProduct_Fragment': SimpleProduct_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_DownloadableProduct_Fragment': SimpleProduct_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_GroupedProduct_Fragment': SimpleProduct_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_SimpleProduct_Fragment': SimpleProduct_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'SimpleProduct_VirtualProduct_Fragment': SimpleProduct_VirtualProduct_Fragment } }
    ) | null> | null } };

export type CreateQuestionMutationVariables = Exact<{
  input: QuestionCreateInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion?: boolean | null };

export type DeleteCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCustomerAddressMutation = { __typename?: 'Mutation', deleteCustomerAddress?: boolean | null };

export type GenerateCustomerTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type GenerateCustomerTokenMutation = { __typename?: 'Mutation', generateCustomerToken?: { __typename?: 'CustomerToken', token?: string | null } | null };

export type MergeCartsMutationVariables = Exact<{
  sourceCartId: Scalars['String']['input'];
  destinationCartId: Scalars['String']['input'];
}>;


export type MergeCartsMutation = { __typename?: 'Mutation', mergeCarts: { __typename?: 'Cart', id: string } };

export type PlaceFreeGiftsRequestMutationVariables = Exact<{
  input: FreeGiftsRequestInput;
}>;


export type PlaceFreeGiftsRequestMutation = { __typename?: 'Mutation', placeFreeGiftsRequest?: { __typename?: 'FreeGiftsRequestOutput', success: boolean, error_message?: string | null } | null };

export type PlaceOrderMutationVariables = Exact<{
  input: PlaceOrderInput;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder?: { __typename?: 'PlaceOrderOutput', orderV2?: { __typename?: 'CustomerOrder', number: string, token: string, gateway_url?: string | null } | null, errors: Array<{ __typename?: 'PlaceOrderError', message: string } | null> } | null };

export type RemoveBonusPointsFromCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type RemoveBonusPointsFromCartMutation = { __typename?: 'Mutation', removeBonusPointsFromCart?: { __typename?: 'RemoveBonusPointsFromCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type RemoveCertificateFromCartMutationVariables = Exact<{
  input: RemoveCertificateFromCartInput;
}>;


export type RemoveCertificateFromCartMutation = { __typename?: 'Mutation', removeCertificateFromCart?: { __typename?: 'RemoveCertificateFromCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type RemoveCouponMutationVariables = Exact<{
  input: RemoveCouponInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type RemoveCouponMutation = { __typename?: 'Mutation', removeCoupon?: { __typename?: 'RemoveCouponFromCartOutput', cart?: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartFragment': CartFragment } }
    ) | null } | null };

export type RemoveCouponFromCartMutationVariables = Exact<{
  input: RemoveCouponFromCartInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type RemoveCouponFromCartMutation = { __typename?: 'Mutation', removeCouponFromCart?: { __typename?: 'RemoveCouponFromCartOutput', cart?: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartFragment': CartFragment } }
    ) | null } | null };

export type RemoveItemFromCartMutationVariables = Exact<{
  input: RemoveItemFromCartInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type RemoveItemFromCartMutation = { __typename?: 'Mutation', removeItemFromCart?: { __typename?: 'RemoveItemFromCartOutput', cart: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartMiniFragment': CartMiniFragment } }
    ) } | null };

export type RemoveProductsFromWishlistMutationVariables = Exact<{
  wishlistId: Scalars['ID']['input'];
  wishlistItemsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveProductsFromWishlistMutation = { __typename?: 'Mutation', removeProductsFromWishlist?: { __typename?: 'RemoveProductsFromWishlistOutput', wishlist: { __typename?: 'Wishlist', id?: string | null, items_count?: number | null, sharing_code?: string | null, updated_at?: string | null, items_v2?: { __typename?: 'WishlistItems', items: Array<(
          { __typename?: 'BundleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_BundleWishlistItem_Fragment': WishlistItem_BundleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'CertificateWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_CertificateWishlistItem_Fragment': WishlistItem_CertificateWishlistItem_Fragment } }
        ) | (
          { __typename?: 'ConfigurableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_ConfigurableWishlistItem_Fragment': WishlistItem_ConfigurableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'DownloadableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_DownloadableWishlistItem_Fragment': WishlistItem_DownloadableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'GroupedProductWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_GroupedProductWishlistItem_Fragment': WishlistItem_GroupedProductWishlistItem_Fragment } }
        ) | (
          { __typename?: 'SimpleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_SimpleWishlistItem_Fragment': WishlistItem_SimpleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'VirtualWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_VirtualWishlistItem_Fragment': WishlistItem_VirtualWishlistItem_Fragment } }
        ) | null> } | null } } | null };

export type ReorderItemsMutationVariables = Exact<{
  orderNumber: Scalars['String']['input'];
}>;


export type ReorderItemsMutation = { __typename?: 'Mutation', reorderItems?: { __typename?: 'ReorderItemsOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type RequestPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetEmailMutation = { __typename?: 'Mutation', requestPasswordResetEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type RevokeCustomerTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeCustomerTokenMutation = { __typename?: 'Mutation', revokeCustomerToken?: { __typename?: 'RevokeCustomerTokenOutput', result: boolean } | null };

export type SavePickupPointToAddressMutationVariables = Exact<{
  cart_id: Scalars['String']['input'];
  nom_code: Scalars['String']['input'];
  saveInAddressBook?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SavePickupPointToAddressMutation = { __typename?: 'Mutation', savePickupPointToAddress?: { __typename?: 'DeliveryAddress', id: string, nom_code?: string | null, name?: string | null, address?: string | null, city?: string | null, region?: string | null, phone?: string | null, work_time?: string | null, latitude?: string | null, price?: string | null, longitude?: string | null, point_type?: string | null } | null };

export type SendAuthorizationCodeMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type SendAuthorizationCodeMutation = { __typename?: 'Mutation', sendAuthorizationCode?: boolean | null };

export type SendDiagnosticChecklistMutationVariables = Exact<{
  input: SendDiagnosticChecklistInput;
}>;


export type SendDiagnosticChecklistMutation = { __typename?: 'Mutation', sendDiagnosticChecklist?: boolean | null };

export type SendRegistrationCodeMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type SendRegistrationCodeMutation = { __typename?: 'Mutation', sendRegistrationCode?: boolean | null };

export type SetBillingAddressOnCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  sameAsShipping?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<CartAddressInput>;
}>;


export type SetBillingAddressOnCartMutation = { __typename?: 'Mutation', setBillingAddressOnCart?: { __typename?: 'SetBillingAddressOnCartOutput', cart: { __typename?: 'Cart', id: string, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null } } | null };

export type SetCityMutationVariables = Exact<{
  cart_id?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  city: Scalars['String']['input'];
}>;


export type SetCityMutation = { __typename?: 'Mutation', setCity?: { __typename?: 'SetCityOutput', success: boolean } | null };

export type SetGuestEmailOnCartMutationVariables = Exact<{
  input: SetGuestEmailOnCartInput;
}>;


export type SetGuestEmailOnCartMutation = { __typename?: 'Mutation', setGuestEmailOnCart?: { __typename?: 'SetGuestEmailOnCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type SetPaymentMethodOnCartMutationVariables = Exact<{
  input: SetPaymentMethodOnCartInput;
}>;


export type SetPaymentMethodOnCartMutation = { __typename?: 'Mutation', setPaymentMethodOnCart?: { __typename?: 'SetPaymentMethodOnCartOutput', cart: { __typename?: 'Cart', id: string, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string, title: string } | null } } | null };

export type SetShippingAddressesOnCartMutationVariables = Exact<{
  input: SetShippingAddressesOnCartInput;
}>;


export type SetShippingAddressesOnCartMutation = { __typename?: 'Mutation', setShippingAddressesOnCart?: { __typename?: 'SetShippingAddressesOnCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type SetShippingMethodsOnCartMutationVariables = Exact<{
  input: SetShippingMethodsOnCartInput;
}>;


export type SetShippingMethodsOnCartMutation = { __typename?: 'Mutation', setShippingMethodsOnCart?: { __typename?: 'SetShippingMethodsOnCartOutput', cart: { __typename?: 'Cart', id: string } } | null };

export type UpdateCartItemsMutationVariables = Exact<{
  input: UpdateCartItemsInput;
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type UpdateCartItemsMutation = { __typename?: 'Mutation', updateCartItems?: { __typename?: 'UpdateCartItemsOutput', cart: (
      { __typename?: 'Cart' }
      & { ' $fragmentRefs'?: { 'CartMiniFragment': CartMiniFragment } }
    ) } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: CustomerUpdateInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomerV2?: { __typename?: 'CustomerOutput', customer: (
      { __typename?: 'Customer' }
      & { ' $fragmentRefs'?: { 'CustomerFragment': CustomerFragment } }
    ) } | null };

export type UpdateCustomerAddressMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input?: InputMaybe<CustomerAddressInput>;
}>;


export type UpdateCustomerAddressMutation = { __typename?: 'Mutation', updateCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, telephone?: string | null, street?: Array<string | null> | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null } | null, custom_attributesV2: Array<{ __typename?: 'AttributeSelectedColorfulOptions', code: string } | { __typename?: 'AttributeSelectedOptions', code: string } | { __typename?: 'AttributeValue', value: string, code: string } | null> } | null };

export type UploadExpertPhotoMutationVariables = Exact<{
  input: UploadExpertPhotoInput;
}>;


export type UploadExpertPhotoMutation = { __typename?: 'Mutation', uploadExpertPhoto?: { __typename?: 'UploadExpertPhotoOutput', filename?: string | null, url?: string | null, success: boolean, message?: string | null } | null };

export type UploadReviewImageMutationVariables = Exact<{
  input: UploadReviewImageInput;
}>;


export type UploadReviewImageMutation = { __typename?: 'Mutation', uploadReviewImage?: { __typename?: 'UploadReviewImage', filename?: string | null, url?: string | null, success: boolean, message?: string | null } | null };

export type VerifyRegistrationCodeMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyRegistrationCodeMutation = { __typename?: 'Mutation', verifyRegistrationCode?: boolean | null };

export type GetAcneCabinetsQueryVariables = Exact<{
  filter?: InputMaybe<TreatingAcneTogetherFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TreatingAcneTogetherSortInput>;
}>;


export type GetAcneCabinetsQuery = { __typename?: 'Query', acneCabinets?: { __typename?: 'AcneCabinetOutput', total_count: number, items?: Array<{ __typename?: 'AcneCabinet', acnecabinet_id: number, is_active: boolean, title: string, city?: string | null, address?: string | null, phone_number?: string | null, latitude?: string | null, longitude?: string | null, start_date?: string | null, end_date?: string | null, doctors?: Array<{ __typename?: 'Expert', is_participant_treating_acne_together: boolean, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, full_name: string, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null } | null> | null } | null> | null, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetAcneSchoolsQueryVariables = Exact<{
  filter?: InputMaybe<TreatingAcneTogetherFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TreatingAcneTogetherSortInput>;
}>;


export type GetAcneSchoolsQuery = { __typename?: 'Query', acneSchools?: { __typename?: 'AcneSchoolOutput', total_count: number, items?: Array<{ __typename?: 'AcneSchool', acneschool_id: number, is_active: boolean, city?: string | null, link?: string | null, start_date?: string | null, end_date?: string | null } | null> | null, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetAvailablePromoCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePromoCodesQuery = { __typename?: 'Query', availablePromoCodes?: Array<{ __typename?: 'AvailablePromoCode', coupon_code?: string | null, name?: string | null, description?: string | null, available_date?: string | null } | null> | null };

export type GetBannersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBannersQuery = { __typename?: 'Query', bannerEntities: Array<(
    { __typename?: 'BannerEntity' }
    & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
  ) | null> };

export type GetBlogCategoriesQueryVariables = Exact<{
  action: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlogCategoriesQuery = { __typename?: 'Query', mpBlogCategories?: { __typename?: 'CategoriesOutput', items?: Array<{ __typename?: 'Category', path?: string | null, name?: string | null, image?: string | null, url_key?: string | null, color?: string | null, type?: BlogEntityTypeEnum | null } | null> | null } | null };

export type GetBlogPostQueryVariables = Exact<{
  action: Scalars['String']['input'];
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlogPostQuery = { __typename?: 'Query', mpBlogPosts?: { __typename?: 'PostsOutput', items?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, best_rating?: number | null, qa_page?: string | null, name?: string | null, with_doctor?: boolean | null, header_text?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null, simplecast_code?: string | null, video_1?: string | null, video_image_1?: string | null, video_2?: string | null, video_image_2?: string | null, video_3?: string | null, video_image_3?: string | null, video_4?: string | null, video_image_4?: string | null, video_5?: string | null, video_image_5?: string | null, text_1?: string | null, text_image_1?: string | null, text_image_position_1?: string | null, text_image_alt_1?: string | null, text_image_link_1?: string | null, text_2?: string | null, text_image_2?: string | null, text_image_position_2?: string | null, text_image_alt_2?: string | null, text_image_link_2?: string | null, text_3?: string | null, text_image_3?: string | null, text_image_position_3?: string | null, text_image_alt_3?: string | null, text_image_link_3?: string | null, text_4?: string | null, text_image_4?: string | null, text_image_position_4?: string | null, text_image_alt_4?: string | null, text_image_link_4?: string | null, text_5?: string | null, text_image_5?: string | null, text_image_position_5?: string | null, text_image_alt_5?: string | null, text_image_link_5?: string | null, text_6?: string | null, text_image_6?: string | null, text_image_position_6?: string | null, text_image_alt_6?: string | null, text_image_link_6?: string | null, text_7?: string | null, text_image_7?: string | null, text_image_position_7?: string | null, text_image_alt_7?: string | null, text_image_link_7?: string | null, text_8?: string | null, text_image_8?: string | null, text_image_position_8?: string | null, text_image_alt_8?: string | null, text_image_link_8?: string | null, text_9?: string | null, text_image_9?: string | null, text_image_position_9?: string | null, text_image_alt_9?: string | null, text_image_link_9?: string | null, text_10?: string | null, text_image_10?: string | null, text_image_position_10?: string | null, text_image_alt_10?: string | null, text_image_link_10?: string | null, categories?: { __typename?: 'CategoriesOutputNoPage', total_count?: number | null, items?: Array<{ __typename?: 'Category', name?: string | null, url_key?: string | null, color?: string | null, path?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', total_count?: number | null, items?: Array<{ __typename?: 'Topic', name?: string | null, color?: string | null, url_key?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null } | null> | null } | null, comments: { __typename?: 'BlogComments', total_count?: number | null }, text_products?: Array<{ __typename?: 'BlogTextProduct', index: number, items?: Array<(
          { __typename?: 'BundleProduct' }
          & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
        ) | (
          { __typename?: 'CertificateProduct' }
          & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
        ) | (
          { __typename?: 'ConfigurableProduct' }
          & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
        ) | (
          { __typename?: 'DownloadableProduct' }
          & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
        ) | (
          { __typename?: 'GroupedProduct' }
          & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
        ) | (
          { __typename?: 'SimpleProduct' }
          & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
        ) | (
          { __typename?: 'VirtualProduct' }
          & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
        ) | null> | null } | null> | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, full_name: string, photo?: string | null, photo_alt?: string | null, regalia?: string | null, url_key?: string | null } | null> | null, posts?: { __typename?: 'PostsOutputNoPage', total_count?: number | null, items?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, image?: string | null, with_doctor?: boolean | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, small_image?: string | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type GetBlogPostsQueryVariables = Exact<{
  action: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  postIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PostSortTypeEnum>;
  categoryKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  topicKey?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlogPostsQuery = { __typename?: 'Query', mpBlogPosts?: { __typename?: 'PostsOutput', total_count?: number | null, pageInfo?: { __typename?: 'PageInfo', pageSize?: number | null, currentPage?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startPage?: number | null, endPage?: number | null } | null, items?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, best_rating?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, comments: { __typename?: 'BlogComments', total_count?: number | null }, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | null };

export type GetBlogTopicsQueryVariables = Exact<{
  urlKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlogTopicsQuery = { __typename?: 'Query', mpBlogTopics?: { __typename?: 'TopicsOutput', items?: Array<{ __typename?: 'Topic', url_key?: string | null, name?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null } | null> | null } | null };

export type GetCartQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type GetCartQuery = { __typename?: 'Query', cart?: (
    { __typename?: 'Cart' }
    & { ' $fragmentRefs'?: { 'CartFragment': CartFragment } }
  ) | null };

export type GetCartIdQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type GetCartIdQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string } | null };

export type GetCatalogCategoriesQueryVariables = Exact<{
  filters?: InputMaybe<CategoryFilterInput>;
}>;


export type GetCatalogCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryResult', total_count?: number | null, items?: Array<{ __typename?: 'CategoryTree', id?: number | null, uid: string, level?: number | null, image?: string | null, name?: string | null, h1?: string | null, benefits?: string | null, path?: string | null, url_key?: string | null, url_path?: string | null, children_count?: string | null, meta_title?: string | null, meta_description?: string | null, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', category_id?: number | null, category_name?: string | null, category_url_key?: string | null, category_url_path?: string | null } | null> | null, cms_block?: { __typename?: 'CmsBlock', content?: string | null, identifier?: string | null, title?: string | null } | null, category_banners: { __typename?: 'CategoryBanners', top_banners: Array<{ __typename?: 'BannerOnTop', entity: (
            { __typename?: 'BannerEntity' }
            & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
          ) } | null>, sidebar_banners: Array<{ __typename?: 'BannerInSidebar', entity: (
            { __typename?: 'BannerEntity' }
            & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
          ) } | null>, listing_banners: Array<{ __typename?: 'BannerInListing', entity: (
            { __typename?: 'BannerEntity' }
            & { ' $fragmentRefs'?: { 'BannerFragment': BannerFragment } }
          ) } | null> } } | null> | null } | null };

export type GetCategoriesQueryVariables = Exact<{
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryResult', total_count?: number | null, items?: Array<{ __typename?: 'CategoryTree', uid: string, level?: number | null, image?: string | null, name?: string | null, h1?: string | null, benefits?: string | null, path?: string | null, url_key?: string | null, url_path?: string | null, children_count?: string | null } | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null };

export type GetCategoryListQueryVariables = Exact<{
  filters?: InputMaybe<CategoryFilterInput>;
}>;


export type GetCategoryListQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', uid: string, level?: number | null, name?: string | null, h1?: string | null, path?: string | null, url_key?: string | null, url_path?: string | null, children_count?: string | null, children?: Array<{ __typename?: 'CategoryTree', uid: string, level?: number | null, name?: string | null, path?: string | null, url_key?: string | null, url_path?: string | null, children_count?: string | null } | null> | null } | null> | null };

export type GetCertificateAccountQueryVariables = Exact<{
  input: CertificateAccountInput;
}>;


export type GetCertificateAccountQuery = { __typename?: 'Query', certificateAccount?: { __typename?: 'CertificateAccount', code?: string | null, expiration_date?: string | null, balance?: { __typename?: 'Money', value?: number | null, currency?: CurrencyEnum | null } | null } | null };

export type GetCheckoutQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type GetCheckoutQuery = { __typename?: 'Query', cart?: (
    { __typename?: 'Cart' }
    & { ' $fragmentRefs'?: { 'CheckoutFragment': CheckoutFragment } }
  ) | null };

export type GetCmsBlocksQueryVariables = Exact<{
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCmsBlocksQuery = { __typename?: 'Query', cmsBlocks?: { __typename?: 'CmsBlocks', items?: Array<{ __typename?: 'CmsBlock', content?: string | null, identifier?: string | null, title?: string | null } | null> | null } | null };

export type GetCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: (
    { __typename?: 'Customer' }
    & { ' $fragmentRefs'?: { 'CustomerFragment': CustomerFragment } }
  ) | null };

export type GetCustomerAddressesQueryVariables = Exact<{
  addressType: AddressTypeEnum;
  pageSize: Scalars['Int']['input'];
  currentPage: Scalars['Int']['input'];
}>;


export type GetCustomerAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', addressesV2?: { __typename?: 'CustomerAddresses', total_count?: number | null, items?: Array<(
        { __typename?: 'CustomerAddress' }
        & { ' $fragmentRefs'?: { 'AddressFragment': AddressFragment } }
      ) | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null } | null };

export type GetCustomerCartQueryVariables = Exact<{
  cartItemsPageSize: Scalars['Int']['input'];
}>;


export type GetCustomerCartQuery = { __typename?: 'Query', customerCart: (
    { __typename?: 'Cart' }
    & { ' $fragmentRefs'?: { 'CartFragment': CartFragment } }
  ) };

export type GetCustomerCartIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerCartIdQuery = { __typename?: 'Query', customerCart: { __typename?: 'Cart', id: string } };

export type GetCustomerDiagnosticResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerDiagnosticResultsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', diagnostic_results?: Array<{ __typename?: 'DiagnosticResult', uid?: string | null, created_at?: string | null, product_list?: string | null } | null> | null } | null };

export type GetCustomerWishlistQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomerWishlistQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', wishlists: Array<{ __typename?: 'Wishlist', id?: string | null, items_count?: number | null, sharing_code?: string | null, updated_at?: string | null, items_v2?: { __typename?: 'WishlistItems', items: Array<(
          { __typename?: 'BundleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_BundleWishlistItem_Fragment': WishlistItem_BundleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'CertificateWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_CertificateWishlistItem_Fragment': WishlistItem_CertificateWishlistItem_Fragment } }
        ) | (
          { __typename?: 'ConfigurableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_ConfigurableWishlistItem_Fragment': WishlistItem_ConfigurableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'DownloadableWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_DownloadableWishlistItem_Fragment': WishlistItem_DownloadableWishlistItem_Fragment } }
        ) | (
          { __typename?: 'GroupedProductWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_GroupedProductWishlistItem_Fragment': WishlistItem_GroupedProductWishlistItem_Fragment } }
        ) | (
          { __typename?: 'SimpleWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_SimpleWishlistItem_Fragment': WishlistItem_SimpleWishlistItem_Fragment } }
        ) | (
          { __typename?: 'VirtualWishlistItem' }
          & { ' $fragmentRefs'?: { 'WishlistItem_VirtualWishlistItem_Fragment': WishlistItem_VirtualWishlistItem_Fragment } }
        ) | null>, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null } | null> } | null };

export type GetCustomerWishlistIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerWishlistIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', wishlists: Array<{ __typename?: 'Wishlist', id?: string | null } | null> } | null };

export type GetDiagnosticQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetDiagnosticQuery = { __typename?: 'Query', diagnostic?: { __typename?: 'Diagnostic', entity_id?: string | null, slug?: string | null, graph?: string | null } | null };

export type GetDiagnosticResultQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type GetDiagnosticResultQuery = { __typename?: 'Query', diagnosticResult?: { __typename?: 'DiagnosticResult', uid?: string | null, product_list?: string | null } | null };

export type GetDictionaryQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type GetDictionaryQuery = { __typename?: 'Query', dictionary?: Array<{ __typename?: 'DictionaryOption', code: string, label: string, position: number } | null> | null };

export type GetDoctorByUrlQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetDoctorByUrlQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', items: Array<{ __typename?: 'Expert', full_name: string, entity_id?: string | null, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, taplink?: string | null, telegram?: string | null, vk?: string | null, url_key?: string | null, is_participant_treating_acne_together: boolean, content?: string | null, meta_title?: string | null, meta_description?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null> } | null };

export type GetDoctorCitiesQueryVariables = Exact<{
  filter?: InputMaybe<ExpertCityFilterInput>;
}>;


export type GetDoctorCitiesQuery = { __typename?: 'Query', expertCities?: Array<{ __typename?: 'ExpertCity', city?: string | null } | null> | null };

export type GetDoctorsByCitiesQueryVariables = Exact<{
  cities: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDoctorsByCitiesQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, url_key?: string | null, is_participant_treating_acne_together: boolean, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, content?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetDoctorsByCitiesWithFiltersQueryVariables = Exact<{
  cities: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  bother: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDoctorsByCitiesWithFiltersQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, url_key?: string | null, is_participant_treating_acne_together: boolean, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, content?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetDoctorsForAcneProjectQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDoctorsForAcneProjectQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, url_key?: string | null, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, content?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetDoctorsForCityQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDoctorsForCityQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, url_key?: string | null, is_participant_treating_acne_together: boolean, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, content?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetDoctorsWithSearchQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDoctorsWithSearchQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, url_key?: string | null, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type GetDoctorsWithFiltersQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  bother?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDoctorsWithFiltersQuery = { __typename?: 'Query', experts?: { __typename?: 'ExpertOutput', total_count: number, items: Array<{ __typename?: 'Expert', full_name: string, city?: string | null, bother?: Array<string | null> | null, occupation?: Array<string | null> | null, seniority?: string | null, qualification?: Array<string | null> | null, regalia?: string | null, photo?: string | null, photo_alt?: string | null, treating_acne_together_photo?: string | null, treating_acne_together_description?: string | null, url_key?: string | null, is_participant_treating_acne_together: boolean, clinics?: Array<{ __typename?: 'ExpertClinic', name?: string | null, address?: string | null, telephone?: string | null, latitude?: string | null, longitude?: string | null } | null> | null } | null>, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } } | null };

export type MenuQueryVariables = Exact<{
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type MenuQuery = { __typename?: 'Query', snowdogMenus?: { __typename?: 'SnowdogMenus', items: Array<{ __typename?: 'SnowdogMenu', identifier: string, menu_id: number, nodes?: { __typename?: 'SnowdogMenuNodes', items?: Array<{ __typename?: 'SnowdogMenuCmsPageNode', level: number, menu_id: number, node_id: number, parent_id?: number | null, type: string, position: number, title?: string | null, url_key?: string | null, classes?: string | null } | { __typename?: 'SnowdogMenuCustomUrlNode', level: number, menu_id: number, node_id: number, parent_id?: number | null, type: string, position: number, title?: string | null, url_key?: string | null, classes?: string | null } | { __typename?: 'SnowdogMenuNode', level: number, menu_id: number, node_id: number, parent_id?: number | null, type: string, position: number, title?: string | null, url_key?: string | null, classes?: string | null } | { __typename?: 'SnowdogMenuWrapperNode', level: number, menu_id: number, node_id: number, parent_id?: number | null, type: string, position: number, title?: string | null, url_key?: string | null, classes?: string | null } | null> | null } | null } | null> } | null };

export type GetOrderQueryVariables = Exact<{
  number: Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', orders?: { __typename?: 'CustomerOrders', items: Array<(
        { __typename?: 'CustomerOrder' }
        & { ' $fragmentRefs'?: { 'OrderFragment': OrderFragment } }
      ) | null> } | null } | null };

export type GetOrdersQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CustomerOrderSortInput>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', orders?: { __typename?: 'CustomerOrders', items: Array<(
        { __typename?: 'CustomerOrder' }
        & { ' $fragmentRefs'?: { 'OrderFragment': OrderFragment } }
      ) | null>, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null } | null };

export type GetPickupPointsByCityQueryVariables = Exact<{
  city: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPickupPointsByCityQuery = { __typename?: 'Query', getPickupPointsByCity?: Array<(
    { __typename?: 'DeliveryAddress' }
    & { ' $fragmentRefs'?: { 'PickupPointFragment': PickupPointFragment } }
  ) | null> | null };

export type GetPostCommentsQueryVariables = Exact<{
  action: Scalars['String']['input'];
  urlKey?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostCommentsQuery = { __typename?: 'Query', mpBlogPosts?: { __typename?: 'PostsOutput', items?: Array<{ __typename?: 'Post', post_id?: number | null, rating_summary?: number | null, comments: { __typename?: 'BlogComments', total_count?: number | null, page_info: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null }, items: Array<{ __typename?: 'BlogComment', comment_id?: string | null, post_id?: number | null, rating?: number | null, user_name?: string | null, content?: string | null, created_at?: string | null } | null> } } | null> | null } | null };

export type GetPostsByAuthorQueryVariables = Exact<{
  action: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PostSortTypeEnum>;
  authorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostsByAuthorQuery = { __typename?: 'Query', mpBlogPosts?: { __typename?: 'PostsOutput', total_count?: number | null, pageInfo?: { __typename?: 'PageInfo', pageSize?: number | null, currentPage?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startPage?: number | null, endPage?: number | null } | null, items?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, comments: { __typename?: 'BlogComments', total_count?: number | null }, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null, meta_title?: string | null, meta_description?: string | null, meta_robots?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | null };

export type GetProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type GetProductBySkuQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null> | null } | null };

export type GetProductCareProgramQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductCareProgramQuery = { __typename?: 'Query', productSet?: { __typename?: 'Products', total_count?: number | null, program?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null> | null } | null };

export type GetProductCatalogQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type GetProductCatalogQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, search_result_meta?: { __typename?: 'ProductsSearchResultMeta', zero_queries?: boolean | null, redirect_url?: string | null, redirect_mobile_url?: string | null } | null, items?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment;'ConfigurableProductFragment': ConfigurableProductFragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } | null, aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, position?: number | null, label?: string | null, count?: number | null, hide_in_side_filters?: boolean | null, care_selection?: boolean | null, options?: Array<{ __typename?: 'AggregationOption', label?: string | null, value: string, count?: number | null, from?: number | null, to?: number | null } | null> | null } | null> | null } | null };

export type GetProductCertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCertificatesQuery = { __typename?: 'Query', productCertificates?: { __typename?: 'ProductCertificatesOutput', items?: Array<{ __typename?: 'ProductCertificateItem', name?: string | null, gamma?: string | null, brand?: string | null, certificate?: string | null } | null> | null } | null };

export type GetProductDetailsPageQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductDetailsPageQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<(
      { __typename?: 'BundleProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment;'ProductCategories_BundleProduct_Fragment': ProductCategories_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment;'ProductCategories_CertificateProduct_Fragment': ProductCategories_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment;'ProductCategories_ConfigurableProduct_Fragment': ProductCategories_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment;'ProductCategories_DownloadableProduct_Fragment': ProductCategories_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment;'ProductCategories_GroupedProduct_Fragment': ProductCategories_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment;'ProductCategories_SimpleProduct_Fragment': ProductCategories_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct', reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment;'ProductCategories_VirtualProduct_Fragment': ProductCategories_VirtualProduct_Fragment } }
    ) | null> | null } | null };

export type GetProductPostsQueryVariables = Exact<{
  sku?: InputMaybe<Scalars['String']['input']>;
  postCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductPostsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'CertificateProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'ConfigurableProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'DownloadableProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'GroupedProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'SimpleProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | { __typename?: 'VirtualProduct', sku?: string | null, name?: string | null, posts?: Array<{ __typename?: 'Post', post_id?: number | null, type?: BlogEntityTypeEnum | null, url_key?: string | null, name?: string | null, short_description?: string | null, with_doctor?: boolean | null, image?: string | null, small_image?: string | null, time_to_read?: string | null, publish_date?: string | null, rating_summary?: number | null, categories?: { __typename?: 'CategoriesOutputNoPage', items?: Array<{ __typename?: 'Category', url_key?: string | null, name?: string | null, color?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicsOutputNoPage', items?: Array<{ __typename?: 'Topic', url_key?: string | null, color?: string | null, name?: string | null } | null> | null } | null, authors?: Array<{ __typename?: 'Expert', is_doctor: boolean, photo?: string | null, photo_alt?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetProductReviewsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type GetProductReviewsQuery = { __typename?: 'Query', reviewImages?: Array<{ __typename?: 'ReviewImage', review_id: string, file: string } | null> | null, products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'CertificateProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'ConfigurableProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'DownloadableProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'GroupedProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'SimpleProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'VirtualProduct', recommendation_rate: number, rating_summary: number, review_count: number, question_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null> }, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | null> | null } | null };

export type GetProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, items?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', page_size?: number | null, current_page?: number | null, total_pages?: number | null } | null, aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', label?: string | null, value: string, count?: number | null } | null> | null } | null> | null } | null };

export type GetProductsAggregationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type GetProductsAggregationsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, position?: number | null, label?: string | null, count?: number | null, hide_in_side_filters?: boolean | null, care_selection?: boolean | null, options?: Array<{ __typename?: 'AggregationOption', label?: string | null, value: string, count?: number | null, from?: number | null, to?: number | null } | null> | null } | null> | null } | null };

export type GetProductsCarouselQueryVariables = Exact<{
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type GetProductsCarouselQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, items?: Array<(
      { __typename?: 'BundleProduct' }
      & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
    ) | (
      { __typename?: 'CertificateProduct' }
      & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
    ) | (
      { __typename?: 'ConfigurableProduct' }
      & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment } }
    ) | (
      { __typename?: 'DownloadableProduct' }
      & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
    ) | (
      { __typename?: 'GroupedProduct' }
      & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
    ) | (
      { __typename?: 'SimpleProduct' }
      & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
    ) | (
      { __typename?: 'VirtualProduct' }
      & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
    ) | null> | null } | null };

export type GetPromotionDetailsByIdQueryVariables = Exact<{
  entity_id: Scalars['String']['input'];
}>;


export type GetPromotionDetailsByIdQuery = { __typename?: 'Query', promotions?: { __typename?: 'PromotionOutput', total_count: number, items?: Array<{ __typename?: 'Promotion', brand_name: string, created_at: string, description?: string | null, meta_title?: string | null, meta_description?: string | null, end_date: string, entity_id: number, erid?: string | null, image_desktop?: string | null, image_mobile?: string | null, is_active: boolean, link?: string | null, list_image?: string | null, priority: number, redirect_code: number, relative_url?: string | null, start_date: string, store_id: number, title: string, type?: UrlRewriteEntityTypeEnum | null, display_enhanced_cashback_widget?: boolean | null, description_after_image?: string | null, theme?: PromotionThemeEnum | null, description_after?: string | null, disclaimer?: string | null, category?: { __typename?: 'Category', uid: string, name?: string | null, url?: string | null } | null, products?: Array<(
        { __typename?: 'BundleProduct' }
        & { ' $fragmentRefs'?: { 'Product_BundleProduct_Fragment': Product_BundleProduct_Fragment } }
      ) | (
        { __typename?: 'CertificateProduct' }
        & { ' $fragmentRefs'?: { 'Product_CertificateProduct_Fragment': Product_CertificateProduct_Fragment } }
      ) | (
        { __typename?: 'ConfigurableProduct' }
        & { ' $fragmentRefs'?: { 'Product_ConfigurableProduct_Fragment': Product_ConfigurableProduct_Fragment;'ConfigurableProductFragment': ConfigurableProductFragment } }
      ) | (
        { __typename?: 'DownloadableProduct' }
        & { ' $fragmentRefs'?: { 'Product_DownloadableProduct_Fragment': Product_DownloadableProduct_Fragment } }
      ) | (
        { __typename?: 'GroupedProduct' }
        & { ' $fragmentRefs'?: { 'Product_GroupedProduct_Fragment': Product_GroupedProduct_Fragment } }
      ) | (
        { __typename?: 'SimpleProduct' }
        & { ' $fragmentRefs'?: { 'Product_SimpleProduct_Fragment': Product_SimpleProduct_Fragment } }
      ) | (
        { __typename?: 'VirtualProduct' }
        & { ' $fragmentRefs'?: { 'Product_VirtualProduct_Fragment': Product_VirtualProduct_Fragment } }
      ) | null> | null } | null> | null } | null };

export type GetPromotionsQueryVariables = Exact<{
  filter?: InputMaybe<PromotionFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPromotionsQuery = { __typename?: 'Query', promotions?: { __typename?: 'PromotionOutput', total_count: number, items?: Array<{ __typename?: 'Promotion', brand_name: string, description?: string | null, end_date: string, entity_id: number, erid?: string | null, is_active: boolean, link?: string | null, title: string, type?: UrlRewriteEntityTypeEnum | null, list_image?: string | null, promo_type?: Array<{ __typename?: 'PromotionType', code?: string | null, label?: string | null } | null> | null } | null> | null, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } | null };

export type GetQuestionsByPageQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  sortOrder: SortEnum;
}>;


export type GetQuestionsByPageQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'CertificateProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'ConfigurableProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'DownloadableProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'GroupedProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'SimpleProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | { __typename?: 'VirtualProduct', question_count: number, questions: { __typename?: 'ProductQuestions', items: Array<(
          { __typename?: 'ProductQuestion' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        ) | null> } } | null> | null } | null };

export type GetRatingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRatingsQuery = { __typename?: 'Query', productReviewRatingsMetadata: { __typename?: 'ProductReviewRatingsMetadata', items: Array<{ __typename?: 'ProductReviewRatingMetadata', id: string, name: string, values: Array<{ __typename?: 'ProductReviewRatingValueMetadata', value_id: string, value: string } | null> } | null> } };

export type ReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReviewQuery = { __typename?: 'Query', review?: (
    { __typename?: 'ProductReview' }
    & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
  ) | null };

export type GetReviewsByPageQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  sources?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onlyWithImage?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReviewsByPageQuery = { __typename?: 'Query', reviewImages?: Array<{ __typename?: 'ReviewImage', review_id: string, file: string } | null> | null, products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'CertificateProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'ConfigurableProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'DownloadableProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'GroupedProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'SimpleProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | { __typename?: 'VirtualProduct', recommendation_rate: number, rating_summary: number, review_count: number, detailed_rating?: Array<{ __typename?: 'ProductDetailedRating', rating: number, percent: number } | null> | null, reviews: { __typename?: 'ProductReviews', items: Array<(
          { __typename?: 'ProductReview' }
          & { ' $fragmentRefs'?: { 'ProductReviewFragment': ProductReviewFragment } }
        ) | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, total_pages?: number | null } } } | null> | null } | null };

export type GetRouteQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetRouteQuery = { __typename?: 'Query', route?: { __typename?: 'BundleProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'CategoryTree', redirect_code: number, relative_url?: string | null } | { __typename?: 'CertificateProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'CmsPage', redirect_code: number, relative_url?: string | null } | { __typename?: 'ConfigurableProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'DownloadableProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'Expert', redirect_code: number, relative_url?: string | null } | { __typename?: 'GroupedProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'Promotion', redirect_code: number, relative_url?: string | null } | { __typename?: 'RoutableUrl', redirect_code: number, relative_url?: string | null } | { __typename?: 'SimpleProduct', redirect_code: number, relative_url?: string | null } | { __typename?: 'VirtualProduct', redirect_code: number, relative_url?: string | null } | null, seoParams?: { __typename?: 'SeoParams', canonical?: string | null, meta_description?: string | null, meta_title?: string | null, h1?: string | null } | null };

export type GetSecureOrderInfoQueryVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type GetSecureOrderInfoQuery = { __typename?: 'Query', secureOrder: (
    { __typename?: 'CustomerOrder' }
    & { ' $fragmentRefs'?: { 'OrderFragment': OrderFragment } }
  ) };

export type GetShippingMethodsQueryVariables = Exact<{
  city: Scalars['String']['input'];
}>;


export type GetShippingMethodsQuery = { __typename?: 'Query', getShippingMethods?: Array<(
    { __typename?: 'AvailableShippingMethod' }
    & { ' $fragmentRefs'?: { 'ShippingMethodFragment': ShippingMethodFragment } }
  ) | null> | null };

export type StoreConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreConfigQuery = { __typename?: 'Query', storeConfig?: { __typename?: 'StoreConfig', copyright?: string | null, default_title?: string | null, store_name?: string | null, store_ogrn?: string | null, store_city?: string | null, store_region?: string | null, store_schedule?: string | null, store_street?: string | null, header_logo_src?: string | null, recipient_email?: string | null, call_center_hours?: string | null, store_telephone?: string | null, store_vat_number?: string | null, store_zip_code?: string | null, store_country?: string | null, store_code?: string | null, payments_company_name?: string | null, payments_company_vat_number?: string | null, payments_company_street?: string | null, payments_company_city?: string | null, payments_company_region?: string | null, payments_company_ogrn?: string | null, payments_company_zip_code?: string | null, second_payments_company_name?: string | null, second_payments_company_vat_number?: string | null, second_payments_company_street?: string | null, second_payments_company_city?: string | null, second_payments_company_region?: string | null, second_payments_company_ogrn?: string | null, second_payments_company_zip_code?: string | null, free_shipping_sum?: string | null, mindbox_customer_id_prefix?: string | null, advertising_warning_text?: string | null, search_suggestion_limit?: string | null, cookie_restriction_enabled?: boolean | null } | null };

export type StoresQueryVariables = Exact<{
  city: Scalars['String']['input'];
}>;


export type StoresQuery = { __typename?: 'Query', stores?: Array<{ __typename?: 'OfflineStore', name?: string | null, latitude?: string | null, longitude?: string | null, street?: string | null, brand?: BrandEnum | null, store_id?: number | null } | null> | null };

export type GetThresholdedRulesQueryVariables = Exact<{
  cart_id: Scalars['String']['input'];
}>;


export type GetThresholdedRulesQuery = { __typename?: 'Query', getThresholdedRules?: { __typename?: 'ThresholdedRulesOutput', rules?: Array<{ __typename?: 'ThresholdedRule', rule_id: number, description?: string | null, minimal_total: number, is_reached: boolean, image?: string | null } | null> | null } | null };

export type GetUserChoiceRulesQueryVariables = Exact<{
  cart_id: Scalars['String']['input'];
}>;


export type GetUserChoiceRulesQuery = { __typename?: 'Query', getUserChoiceRules?: { __typename?: 'CartGiftRulesOutput', products_skus: Array<string | null>, rules: Array<{ __typename?: 'CartGiftRule', rule_id: number, selected_gifts_qty: number, max_gifts_qty: number } | null> } | null };

export type IsValidCartIdQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type IsValidCartIdQuery = { __typename?: 'Query', isValidQuote?: { __typename?: 'QuoteValidationResult', is_valid: boolean, message?: string | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AddressFragmentDoc = new TypedDocumentString(`
    fragment Address on CustomerAddress {
  city
  firstname
  id
  lastname
  middlename
  postcode
  region {
    region
  }
  country_code
  street
  telephone
  default_shipping
  is_pickup
  center_longitude
  center_latitude
  custom_attributesV2 {
    code
    ... on AttributeValue {
      value
    }
  }
  extension_attributes {
    attribute_code
    value
  }
}
    `, {"fragmentName":"Address"}) as unknown as TypedDocumentString<AddressFragment, unknown>;
export const AggregationFragmentDoc = new TypedDocumentString(`
    fragment Aggregation on Aggregation {
  attribute_code
  count
  label
  options {
    count
    label
    value
  }
}
    `, {"fragmentName":"Aggregation"}) as unknown as TypedDocumentString<AggregationFragment, unknown>;
export const ProductImageFragmentDoc = new TypedDocumentString(`
    fragment ProductImage on ProductImage {
  src: url
  alt: label
}
    `, {"fragmentName":"ProductImage"}) as unknown as TypedDocumentString<ProductImageFragment, unknown>;
export const BannerFragmentDoc = new TypedDocumentString(`
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
    `, {"fragmentName":"Banner"}) as unknown as TypedDocumentString<BannerFragment, unknown>;
export const SimpleProductFragmentDoc = new TypedDocumentString(`
    fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"fragmentName":"SimpleProduct"}) as unknown as TypedDocumentString<SimpleProductFragment, unknown>;
export const ConfigurableProductFragmentDoc = new TypedDocumentString(`
    fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"ConfigurableProduct"}) as unknown as TypedDocumentString<ConfigurableProductFragment, unknown>;
export const GroupedProductFragmentDoc = new TypedDocumentString(`
    fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"GroupedProduct"}) as unknown as TypedDocumentString<GroupedProductFragment, unknown>;
export const ProductFragmentDoc = new TypedDocumentString(`
    fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"Product"}) as unknown as TypedDocumentString<ProductFragment, unknown>;
export const CartItemFragmentDoc = new TypedDocumentString(`
    fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"CartItem"}) as unknown as TypedDocumentString<CartItemFragment, unknown>;
export const CartFragmentDoc = new TypedDocumentString(`
    fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"Cart"}) as unknown as TypedDocumentString<CartFragment, unknown>;
export const CartMiniFragmentDoc = new TypedDocumentString(`
    fragment CartMini on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      id
      quantity
      is_cart_rule_gift
      product {
        sku
        mindbox_id
        name
        image {
          ...ProductImage
        }
        attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
          items {
            ... on AttributeSelectedOptions {
              code
              selected_options {
                label
                value
              }
            }
          }
        }
      }
      prices {
        price {
          value
          currency
        }
      }
    }
  }
}
    fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"fragmentName":"CartMini"}) as unknown as TypedDocumentString<CartMiniFragment, unknown>;
export const CategoryFragmentDoc = new TypedDocumentString(`
    fragment Category on CategoryTree {
  uid
  name
  level
  url_key
  url_path
  path
  position
  children_count
  image
  description
}
    `, {"fragmentName":"Category"}) as unknown as TypedDocumentString<CategoryFragment, unknown>;
export const CartItemCheckoutFragmentDoc = new TypedDocumentString(`
    fragment CartItemCheckout on CartItemInterface {
  id
  quantity
  product {
    __typename
    id
    sku
    name
    url_key
    stockStatus: stock_status
    price: price_range {
      maximum_price {
        final_price {
          currency
          value
        }
      }
    }
    image {
      ...ProductImage
    }
    thumbnail {
      ...ProductImage
    }
    attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
      items {
        ... on AttributeValue {
          code
          value
        }
        ... on AttributeSelectedOptions {
          code
          selected_options {
            label
            value
          }
        }
        ... on AttributeSelectedColorfulOptions {
          code
          selected_options {
            label
            value
            color
            url
          }
        }
      }
    }
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
    fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"fragmentName":"CartItemCheckout"}) as unknown as TypedDocumentString<CartItemCheckoutFragment, unknown>;
export const PickupPointFragmentDoc = new TypedDocumentString(`
    fragment PickupPoint on DeliveryAddress {
  id
  nom_code
  name
  address
  city
  region
  phone
  work_time
  latitude
  price
  longitude
  point_type
  type
  day_from
  day_to
}
    `, {"fragmentName":"PickupPoint"}) as unknown as TypedDocumentString<PickupPointFragment, unknown>;
export const ShippingMethodFragmentDoc = new TypedDocumentString(`
    fragment ShippingMethod on AvailableShippingMethod {
  carrier_code
  carrier_title
  method_code
  method_title
  available
  delivery_date_from
  description
  day_from
  day_to
  available
  amount {
    value
    currency
  }
  price_incl_tax {
    value
    currency
  }
}
    `, {"fragmentName":"ShippingMethod"}) as unknown as TypedDocumentString<ShippingMethodFragment, unknown>;
export const CheckoutFragmentDoc = new TypedDocumentString(`
    fragment Checkout on Cart {
  id
  email
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItemCheckout
    }
  }
  shipping_addresses {
    id
    firstname
    lastname
    street
    city
    region {
      code
      label
    }
    postcode
    country {
      code
      label
    }
    telephone
    customer_notes
    pickup_location_code
    pickup_point {
      ...PickupPoint
    }
    selected_shipping_method {
      carrier_code
      method_code
      carrier_title
      method_title
      amount {
        value
        currency
      }
    }
    available_shipping_methods {
      ...ShippingMethod
    }
  }
  available_payment_methods {
    code
    title
  }
  selected_payment_method {
    code
    title
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
    fragment CartItemCheckout on CartItemInterface {
  id
  quantity
  product {
    __typename
    id
    sku
    name
    url_key
    stockStatus: stock_status
    price: price_range {
      maximum_price {
        final_price {
          currency
          value
        }
      }
    }
    image {
      ...ProductImage
    }
    thumbnail {
      ...ProductImage
    }
    attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
      items {
        ... on AttributeValue {
          code
          value
        }
        ... on AttributeSelectedOptions {
          code
          selected_options {
            label
            value
          }
        }
        ... on AttributeSelectedColorfulOptions {
          code
          selected_options {
            label
            value
            color
            url
          }
        }
      }
    }
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment PickupPoint on DeliveryAddress {
  id
  nom_code
  name
  address
  city
  region
  phone
  work_time
  latitude
  price
  longitude
  point_type
  type
  day_from
  day_to
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment ShippingMethod on AvailableShippingMethod {
  carrier_code
  carrier_title
  method_code
  method_title
  available
  delivery_date_from
  description
  day_from
  day_to
  available
  amount {
    value
    currency
  }
  price_incl_tax {
    value
    currency
  }
}`, {"fragmentName":"Checkout"}) as unknown as TypedDocumentString<CheckoutFragment, unknown>;
export const CustomerFragmentDoc = new TypedDocumentString(`
    fragment Customer on Customer {
  id
  firstname
  lastname
  middlename
  email
  date_of_birth
  gender
  is_subscribed
  custom_attributes {
    __typename
    code
    ... on AttributeValue {
      value
    }
    ... on AttributeSelectedOptions {
      selected_options {
        label
        value
      }
    }
  }
}
    `, {"fragmentName":"Customer"}) as unknown as TypedDocumentString<CustomerFragment, unknown>;
export const OrderFragmentDoc = new TypedDocumentString(`
    fragment Order on CustomerOrder {
  id
  number
  order_date
  delivery_date_from
  delivery_date_actual
  delivery_time
  order_status_change_date
  receipt_url
  payment_timeout
  bonus_earned_amount
  customer_comment
  pickup_address {
    city
    nom_code
    point_type
    work_time
    latitude
    longitude
    address
    phone
  }
  status
  status_code
  email
  carrier
  shipping_method
  gateway_url
  qr_code
  token
  can_be_canceled
  is_virtual
  total {
    base_grand_total {
      value
      currency
    }
    grand_total {
      value
      currency
    }
    subtotal {
      value
      currency
    }
    subtotal_excl_tax {
      value
      currency
    }
    subtotal_incl_tax {
      value
      currency
    }
    total_shipping {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
  }
  shipments {
    tracking {
      number
      carrier
      title
      tracking_url
    }
  }
  shipping_address {
    firstname
    lastname
    street
    city
    postcode
    telephone
    country_code
    comment
  }
  payment_methods {
    name
    type
    additional_data {
      name
      value
    }
  }
  items {
    id
    product_name
    status
    quantity_ordered
    prices {
      original_price_including_tax {
        value
        currency
      }
    }
    product {
      ...Product
    }
    ... on CertificateOrderItem {
      certificate {
        send_date
        design_url
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"Order"}) as unknown as TypedDocumentString<OrderFragment, unknown>;
export const PageInfoFragmentDoc = new TypedDocumentString(`
    fragment PageInfo on SearchResultPageInfo {
  current_page
  page_size
  total_pages
}
    `, {"fragmentName":"PageInfo"}) as unknown as TypedDocumentString<PageInfoFragment, unknown>;
export const ProductCategoriesFragmentDoc = new TypedDocumentString(`
    fragment ProductCategories on ProductInterface {
  categories {
    id
    url: url_path
    name
    color
    isBrand: is_brand
    level
    breadcrumbs {
      name: category_name
      url: category_url_path
    }
  }
}
    `, {"fragmentName":"ProductCategories"}) as unknown as TypedDocumentString<ProductCategoriesFragment, unknown>;
export const ProductReviewFragmentDoc = new TypedDocumentString(`
    fragment ProductReview on ProductReview {
  id
  product {
    name
    sku
    url_key
  }
  summary
  text
  nickname
  created_at
  average_rating
  is_recommended
  age
  skin_type
  skin_problem
  pros
  cons
  is_external
  source
  source_logo
  source_url
  answer
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
    }
  }
  images
  ratings_breakdown {
    name
    value
  }
}
    `, {"fragmentName":"ProductReview"}) as unknown as TypedDocumentString<ProductReviewFragment, unknown>;
export const QuestionFragmentDoc = new TypedDocumentString(`
    fragment Question on ProductQuestion {
  product_sku
  question
  answer
  customer_name
  age
  email
  skin_type
  skin_problem
  created_at
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
      label
    }
  }
}
    `, {"fragmentName":"Question"}) as unknown as TypedDocumentString<QuestionFragment, unknown>;
export const WishlistItemFragmentDoc = new TypedDocumentString(`
    fragment WishlistItem on WishlistItemInterface {
  id
  quantity
  added_at
  description
  product {
    ...Product
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"fragmentName":"WishlistItem"}) as unknown as TypedDocumentString<WishlistItemFragment, unknown>;
export const AddProductsToCartDocument = new TypedDocumentString(`
    mutation addProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!, $cartItemsPageSize: Int!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      ...CartMini
    }
  }
}
    fragment CartMini on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      id
      quantity
      is_cart_rule_gift
      product {
        sku
        mindbox_id
        name
        image {
          ...ProductImage
        }
        attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
          items {
            ... on AttributeSelectedOptions {
              code
              selected_options {
                label
                value
              }
            }
          }
        }
      }
      prices {
        price {
          value
          currency
        }
      }
    }
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"hash":"f4f6f6607940e99630e8e631f12a9f191e8dd28e"}) as unknown as TypedDocumentString<AddProductsToCartMutation, AddProductsToCartMutationVariables>;
export const AddProductsToWishlistDocument = new TypedDocumentString(`
    mutation addProductsToWishlist($wishlistId: ID!, $wishlistItems: [WishlistItemInput!]!) {
  addProductsToWishlist(wishlistId: $wishlistId, wishlistItems: $wishlistItems) {
    wishlist {
      id
      items_v2 {
        items {
          ...WishlistItem
        }
      }
      items_count
      sharing_code
      updated_at
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}
fragment WishlistItem on WishlistItemInterface {
  id
  quantity
  added_at
  description
  product {
    ...Product
  }
}`, {"hash":"0784cb828472d2ccc3534ec5fc9a2245bacc1f76"}) as unknown as TypedDocumentString<AddProductsToWishlistMutation, AddProductsToWishlistMutationVariables>;
export const AddSamplerToCartDocument = new TypedDocumentString(`
    mutation AddSamplerToCart($cartId: String!, $sku: String!, $ruleId: String!) {
  addProductsToCart(
    cartId: $cartId
    cartItems: [{sku: $sku, quantity: 1, entered_options: [{uid: "user_choice_rule", value: $ruleId}]}]
  ) {
    cart {
      id
    }
  }
}
    `, {"hash":"9be21bfbf847e8213b4eed5afac5236f1b3e715e"}) as unknown as TypedDocumentString<AddSamplerToCartMutation, AddSamplerToCartMutationVariables>;
export const ApplyBonusPointsToCartDocument = new TypedDocumentString(`
    mutation ApplyBonusPointsToCart($cartId: String!, $bonusPoints: Float!) {
  applyBonusPointsToCart(input: {cart_id: $cartId, bonus_points: $bonusPoints}) {
    cart {
      id
    }
  }
}
    `, {"hash":"e0153ce2f065de1bb4e345fb80fc6fc4652489c3"}) as unknown as TypedDocumentString<ApplyBonusPointsToCartMutation, ApplyBonusPointsToCartMutationVariables>;
export const ApplyCertificateToCartDocument = new TypedDocumentString(`
    mutation applyCertificateToCart($input: ApplyCertificateToCartInput!) {
  applyCertificateToCart(input: $input) {
    cart {
      id
    }
  }
}
    `, {"hash":"cabe9d1e486285e6c1d7b7a3d3fe4d1da2d3a479"}) as unknown as TypedDocumentString<ApplyCertificateToCartMutation, ApplyCertificateToCartMutationVariables>;
export const ApplyCouponToCartDocument = new TypedDocumentString(`
    mutation applyCouponToCart($input: ApplyCouponToCartInput!, $cartItemsPageSize: Int!) {
  applyCouponToCart(input: $input) {
    cart {
      ...Cart
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"e1725f22e864134b27b8029867389ac35459ce0f"}) as unknown as TypedDocumentString<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>;
export const AuthorizeByPhoneDocument = new TypedDocumentString(`
    mutation authorizeByPhone($phone: String!, $code: String!) {
  authorizeByPhone(phone: $phone, code: $code) {
    token
  }
}
    `, {"hash":"5281955ce93def6a96f66056367594c6538a40ce"}) as unknown as TypedDocumentString<AuthorizeByPhoneMutation, AuthorizeByPhoneMutationVariables>;
export const CancelOrderDocument = new TypedDocumentString(`
    mutation cancelOrder($orderId: ID!) {
  cancelOrder(input: {order_id: $orderId}) {
    errorV2 {
      code
      message
    }
    order {
      status
    }
  }
}
    `, {"hash":"a4a9ace2d2366d06352a8db7a9f0ec02b67c089d"}) as unknown as TypedDocumentString<CancelOrderMutation, CancelOrderMutationVariables>;
export const ChangeCustomerPasswordDocument = new TypedDocumentString(`
    mutation changeCustomerPassword($currentPassword: String!, $newPassword: String!) {
  changeCustomerPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
  ) {
    id
    email
  }
}
    `, {"hash":"679de658e7975a2f908107617238b4164b16db24"}) as unknown as TypedDocumentString<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>;
export const ContactUsDocument = new TypedDocumentString(`
    mutation contactUs($input: ContactUsInput!) {
  contactUs(input: $input) {
    status
  }
}
    `, {"hash":"e0fb3520bfe07ad97c2685bf23b5d09e20bec3b6"}) as unknown as TypedDocumentString<ContactUsMutation, ContactUsMutationVariables>;
export const CreateAcneRequestDocument = new TypedDocumentString(`
    mutation createAcneRequest($input: TreatingAcneTogetherRequestCreateInput!) {
  createAcneRequest(input: $input)
}
    `, {"hash":"c7b6a10ee1a96df1ce071a759e164e076d67cf30"}) as unknown as TypedDocumentString<CreateAcneRequestMutation, CreateAcneRequestMutationVariables>;
export const CreateBlogCommentDocument = new TypedDocumentString(`
    mutation createBlogComment($input: BlogCommentCreateInput!) {
  createBlogComment(input: $input)
}
    `, {"hash":"51b503b63f897c5b162da0affd0fcebeee0f97fa"}) as unknown as TypedDocumentString<CreateBlogCommentMutation, CreateBlogCommentMutationVariables>;
export const CreateCombinedMethodsQuestionDocument = new TypedDocumentString(`
    mutation createCombinedMethodsQuestion($input: CombinedMethodsQuestionInput!) {
  createCombinedMethodsQuestion(input: $input)
}
    `, {"hash":"a103eb5dd2d888c65326dc286bc0ec44eec89d2e"}) as unknown as TypedDocumentString<CreateCombinedMethodsQuestionMutation, CreateCombinedMethodsQuestionMutationVariables>;
export const CreateCombinedMethodsRequestDocument = new TypedDocumentString(`
    mutation createCombinedMethodsRequest($input: CombinedMethodsRequestInput!) {
  createCombinedMethodsRequest(input: $input)
}
    `, {"hash":"8ba0e93c711d83554418503b7e0cb2792a166443"}) as unknown as TypedDocumentString<CreateCombinedMethodsRequestMutation, CreateCombinedMethodsRequestMutationVariables>;
export const CreateCustomerDocument = new TypedDocumentString(`
    mutation createCustomer($input: CustomerCreateInput!) {
  createCustomerV2(input: $input) {
    customer {
      email
    }
  }
}
    `, {"hash":"f115f0621aae9e664c2e951ab27a3b44054effde"}) as unknown as TypedDocumentString<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateCustomerAddressDocument = new TypedDocumentString(`
    mutation CreateCustomerAddress($input: CustomerAddressInput!) {
  createCustomerAddress(input: $input) {
    city
    telephone
    region {
      region
    }
    street
    custom_attributesV2 {
      code
      ... on AttributeValue {
        value
      }
    }
  }
}
    `, {"hash":"99351ae29a2629880fc2a9e3845f61ff6f244d31"}) as unknown as TypedDocumentString<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>;
export const CreateDiagnosticResultDocument = new TypedDocumentString(`
    mutation createDiagnosticResult($input: DiagnosticResultCreateInput!) {
  createDiagnosticResult(input: $input) {
    uid
    product_list
    customer_id
    customer_name
    customer_email
    created_at
  }
}
    `, {"hash":"19a6d8933e59e55e8228c07d2c05c5e63e8acec7"}) as unknown as TypedDocumentString<CreateDiagnosticResultMutation, CreateDiagnosticResultMutationVariables>;
export const CreateDoctorDocument = new TypedDocumentString(`
    mutation CreateDoctor($input: CreateExpertInput!) {
  createDoctor(input: $input) {
    expert {
      full_name
      city
      photo
      clinics {
        name
        address
        telephone
      }
    }
    success
    message
  }
}
    `, {"hash":"2effcbe605ef8732d93b477500802cd1a43b7f47"}) as unknown as TypedDocumentString<CreateDoctorMutation, CreateDoctorMutationVariables>;
export const CreateGuestCartDocument = new TypedDocumentString(`
    mutation createGuestCart {
  createGuestCart {
    cart {
      id
    }
  }
}
    `, {"hash":"3e74a703dd1098c8608f15a5fed6d7d585778e40"}) as unknown as TypedDocumentString<CreateGuestCartMutation, CreateGuestCartMutationVariables>;
export const CreateProductReviewDocument = new TypedDocumentString(`
    mutation createProductReview($input: CreateProductReviewInput!) {
  createProductReview(input: $input) {
    review {
      product {
        name
        sku
        url_key
      }
      summary
      text
      nickname
      created_at
      average_rating
      is_recommended
      age
      skin_type
      skin_problem
      pros
      cons
      answer
      answer_product {
        name
      }
      images
      ratings_breakdown {
        name
        value
      }
    }
    recommend_products(count: 3) {
      ...SimpleProduct
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"bd5130e9fea4f8e46da27c1652ec45ad752855e9"}) as unknown as TypedDocumentString<CreateProductReviewMutation, CreateProductReviewMutationVariables>;
export const CreateQuestionDocument = new TypedDocumentString(`
    mutation createQuestion($input: QuestionCreateInput!) {
  createQuestion(input: $input)
}
    `, {"hash":"eed7d5ceef602fa7c890a032ac8b90a98ac3a10c"}) as unknown as TypedDocumentString<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const DeleteCustomerAddressDocument = new TypedDocumentString(`
    mutation deleteCustomerAddress($id: Int!) {
  deleteCustomerAddress(id: $id)
}
    `, {"hash":"fcb3f0822de5a160f19f820fb5f144c13663ff42"}) as unknown as TypedDocumentString<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>;
export const GenerateCustomerTokenDocument = new TypedDocumentString(`
    mutation generateCustomerToken($email: String!, $password: String!) {
  generateCustomerToken(email: $email, password: $password) {
    token
  }
}
    `, {"hash":"d6450cd6d65d5127ffd1385e483be4d4728c526b"}) as unknown as TypedDocumentString<GenerateCustomerTokenMutation, GenerateCustomerTokenMutationVariables>;
export const MergeCartsDocument = new TypedDocumentString(`
    mutation mergeCarts($sourceCartId: String!, $destinationCartId: String!) {
  mergeCarts(
    source_cart_id: $sourceCartId
    destination_cart_id: $destinationCartId
  ) {
    id
  }
}
    `, {"hash":"6c677d0b01fb5e811ce88496a25e22f01231d77b"}) as unknown as TypedDocumentString<MergeCartsMutation, MergeCartsMutationVariables>;
export const PlaceFreeGiftsRequestDocument = new TypedDocumentString(`
    mutation PlaceFreeGiftsRequest($input: FreeGiftsRequestInput!) {
  placeFreeGiftsRequest(input: $input) {
    success
    error_message
  }
}
    `, {"hash":"f915288ca3e749c451ca9d32ccf3d5863b6377f9"}) as unknown as TypedDocumentString<PlaceFreeGiftsRequestMutation, PlaceFreeGiftsRequestMutationVariables>;
export const PlaceOrderDocument = new TypedDocumentString(`
    mutation placeOrder($input: PlaceOrderInput!) {
  placeOrder(input: $input) {
    orderV2 {
      number
      token
      gateway_url
    }
    errors {
      message
    }
  }
}
    `, {"hash":"b17bf7be1b6871085713017a846166176472e3fc"}) as unknown as TypedDocumentString<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const RemoveBonusPointsFromCartDocument = new TypedDocumentString(`
    mutation RemoveBonusPointsFromCart($cartId: String!) {
  removeBonusPointsFromCart(input: {cart_id: $cartId}) {
    cart {
      id
    }
  }
}
    `, {"hash":"0daa542dc5a3e0d67f71912f75466a439d898a55"}) as unknown as TypedDocumentString<RemoveBonusPointsFromCartMutation, RemoveBonusPointsFromCartMutationVariables>;
export const RemoveCertificateFromCartDocument = new TypedDocumentString(`
    mutation removeCertificateFromCart($input: RemoveCertificateFromCartInput!) {
  removeCertificateFromCart(input: $input) {
    cart {
      id
    }
  }
}
    `, {"hash":"adcf760faa3e5c4370967f912e84e17eb961fd44"}) as unknown as TypedDocumentString<RemoveCertificateFromCartMutation, RemoveCertificateFromCartMutationVariables>;
export const RemoveCouponDocument = new TypedDocumentString(`
    mutation removeCoupon($input: RemoveCouponInput!, $cartItemsPageSize: Int!) {
  removeCoupon(input: $input) {
    cart {
      ...Cart
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"4f637ff44c0f1c4e56c59347de72b64aa5667593"}) as unknown as TypedDocumentString<RemoveCouponMutation, RemoveCouponMutationVariables>;
export const RemoveCouponFromCartDocument = new TypedDocumentString(`
    mutation removeCouponFromCart($input: RemoveCouponFromCartInput!, $cartItemsPageSize: Int!) {
  removeCouponFromCart(input: $input) {
    cart {
      ...Cart
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"eb368636e73dbf1cc45f5c1600edbb6a301766d2"}) as unknown as TypedDocumentString<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;
export const RemoveItemFromCartDocument = new TypedDocumentString(`
    mutation removeItemFromCart($input: RemoveItemFromCartInput!, $cartItemsPageSize: Int!) {
  removeItemFromCart(input: $input) {
    cart {
      ...CartMini
    }
  }
}
    fragment CartMini on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      id
      quantity
      is_cart_rule_gift
      product {
        sku
        mindbox_id
        name
        image {
          ...ProductImage
        }
        attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
          items {
            ... on AttributeSelectedOptions {
              code
              selected_options {
                label
                value
              }
            }
          }
        }
      }
      prices {
        price {
          value
          currency
        }
      }
    }
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"hash":"4bc63c9d50d3f908fe77e868f5c5155d12cca6d4"}) as unknown as TypedDocumentString<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;
export const RemoveProductsFromWishlistDocument = new TypedDocumentString(`
    mutation removeProductsFromWishlist($wishlistId: ID!, $wishlistItemsIds: [ID!]!) {
  removeProductsFromWishlist(
    wishlistId: $wishlistId
    wishlistItemsIds: $wishlistItemsIds
  ) {
    wishlist {
      id
      items_v2 {
        items {
          ...WishlistItem
        }
      }
      items_count
      sharing_code
      updated_at
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}
fragment WishlistItem on WishlistItemInterface {
  id
  quantity
  added_at
  description
  product {
    ...Product
  }
}`, {"hash":"f3a53f354c30ce50c4c388f75e213e23f7cf99df"}) as unknown as TypedDocumentString<RemoveProductsFromWishlistMutation, RemoveProductsFromWishlistMutationVariables>;
export const ReorderItemsDocument = new TypedDocumentString(`
    mutation reorderItems($orderNumber: String!) {
  reorderItems(orderNumber: $orderNumber) {
    cart {
      id
    }
  }
}
    `, {"hash":"383f928ecac496b3000a77d33bc6bfc59732f19a"}) as unknown as TypedDocumentString<ReorderItemsMutation, ReorderItemsMutationVariables>;
export const RequestPasswordResetEmailDocument = new TypedDocumentString(`
    mutation requestPasswordResetEmail($email: String!) {
  requestPasswordResetEmail(email: $email)
}
    `, {"hash":"0d29cd48742867b6a36ca6c704f8ed5d29cd252e"}) as unknown as TypedDocumentString<RequestPasswordResetEmailMutation, RequestPasswordResetEmailMutationVariables>;
export const ResetPasswordDocument = new TypedDocumentString(`
    mutation resetPassword($email: String!, $resetPasswordToken: String!, $newPassword: String!) {
  resetPassword(
    email: $email
    resetPasswordToken: $resetPasswordToken
    newPassword: $newPassword
  )
}
    `, {"hash":"fcd6f743e14d5b097ff0247397fbd335a8ae9876"}) as unknown as TypedDocumentString<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RevokeCustomerTokenDocument = new TypedDocumentString(`
    mutation revokeCustomerToken {
  revokeCustomerToken {
    result
  }
}
    `, {"hash":"f0c7421af4bfe5856051a056ab2452797bc41013"}) as unknown as TypedDocumentString<RevokeCustomerTokenMutation, RevokeCustomerTokenMutationVariables>;
export const SavePickupPointToAddressDocument = new TypedDocumentString(`
    mutation savePickupPointToAddress($cart_id: String!, $nom_code: String!, $saveInAddressBook: Boolean) {
  savePickupPointToAddress(
    cart_id: $cart_id
    nom_code: $nom_code
    save_in_address_book: $saveInAddressBook
  ) {
    id
    nom_code
    name
    address
    city
    region
    phone
    work_time
    latitude
    price
    longitude
    point_type
  }
}
    `, {"hash":"81279dff757cc56e0b010a0fa7a1586216ef066d"}) as unknown as TypedDocumentString<SavePickupPointToAddressMutation, SavePickupPointToAddressMutationVariables>;
export const SendAuthorizationCodeDocument = new TypedDocumentString(`
    mutation sendAuthorizationCode($phone: String!) {
  sendAuthorizationCode(phone: $phone)
}
    `, {"hash":"4be364a2f81630e6f0e4b2751221a3b6ea95fd08"}) as unknown as TypedDocumentString<SendAuthorizationCodeMutation, SendAuthorizationCodeMutationVariables>;
export const SendDiagnosticChecklistDocument = new TypedDocumentString(`
    mutation sendDiagnosticChecklist($input: SendDiagnosticChecklistInput!) {
  sendDiagnosticChecklist(input: $input)
}
    `, {"hash":"323f135734d97ff787e95bcc7980d5bce5132319"}) as unknown as TypedDocumentString<SendDiagnosticChecklistMutation, SendDiagnosticChecklistMutationVariables>;
export const SendRegistrationCodeDocument = new TypedDocumentString(`
    mutation sendRegistrationCode($phone: String!) {
  sendRegistrationCode(phone: $phone)
}
    `, {"hash":"a042489637344c2c264e375d0501695042fe3d46"}) as unknown as TypedDocumentString<SendRegistrationCodeMutation, SendRegistrationCodeMutationVariables>;
export const SetBillingAddressOnCartDocument = new TypedDocumentString(`
    mutation setBillingAddressOnCart($cartId: String!, $sameAsShipping: Boolean, $address: CartAddressInput) {
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: {same_as_shipping: $sameAsShipping, address: $address}}
  ) {
    cart {
      id
      available_payment_methods {
        code
        title
      }
    }
  }
}
    `, {"hash":"95792d62b1e05a8506774cf22eee5568469de292"}) as unknown as TypedDocumentString<SetBillingAddressOnCartMutation, SetBillingAddressOnCartMutationVariables>;
export const SetCityDocument = new TypedDocumentString(`
    mutation setCity($cart_id: String, $region: String!, $city: String!) {
  setCity(input: {cart_id: $cart_id, region: $region, city: $city}) {
    success
  }
}
    `, {"hash":"88e694a698038e3e178e5e199c51113925d07aae"}) as unknown as TypedDocumentString<SetCityMutation, SetCityMutationVariables>;
export const SetGuestEmailOnCartDocument = new TypedDocumentString(`
    mutation setGuestEmailOnCart($input: SetGuestEmailOnCartInput!) {
  setGuestEmailOnCart(input: $input) {
    cart {
      id
    }
  }
}
    `, {"hash":"ff27b81263a13430f665db6991376fe825c926b9"}) as unknown as TypedDocumentString<SetGuestEmailOnCartMutation, SetGuestEmailOnCartMutationVariables>;
export const SetPaymentMethodOnCartDocument = new TypedDocumentString(`
    mutation setPaymentMethodOnCart($input: SetPaymentMethodOnCartInput!) {
  setPaymentMethodOnCart(input: $input) {
    cart {
      id
      selected_payment_method {
        code
        title
      }
    }
  }
}
    `, {"hash":"fa17ef47753e71f6385188da402ff11bac320156"}) as unknown as TypedDocumentString<SetPaymentMethodOnCartMutation, SetPaymentMethodOnCartMutationVariables>;
export const SetShippingAddressesOnCartDocument = new TypedDocumentString(`
    mutation setShippingAddressesOnCart($input: SetShippingAddressesOnCartInput!) {
  setShippingAddressesOnCart(input: $input) {
    cart {
      id
    }
  }
}
    `, {"hash":"7b2c257aacc41e8b444608267493ab8e8e2783c8"}) as unknown as TypedDocumentString<SetShippingAddressesOnCartMutation, SetShippingAddressesOnCartMutationVariables>;
export const SetShippingMethodsOnCartDocument = new TypedDocumentString(`
    mutation setShippingMethodsOnCart($input: SetShippingMethodsOnCartInput!) {
  setShippingMethodsOnCart(input: $input) {
    cart {
      id
    }
  }
}
    `, {"hash":"2a4d1e1e1741488308c57c7fbc28c5af21ea9405"}) as unknown as TypedDocumentString<SetShippingMethodsOnCartMutation, SetShippingMethodsOnCartMutationVariables>;
export const UpdateCartItemsDocument = new TypedDocumentString(`
    mutation updateCartItems($input: UpdateCartItemsInput!, $cartItemsPageSize: Int!) {
  updateCartItems(input: $input) {
    cart {
      ...CartMini
    }
  }
}
    fragment CartMini on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      id
      quantity
      is_cart_rule_gift
      product {
        sku
        mindbox_id
        name
        image {
          ...ProductImage
        }
        attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
          items {
            ... on AttributeSelectedOptions {
              code
              selected_options {
                label
                value
              }
            }
          }
        }
      }
      prices {
        price {
          value
          currency
        }
      }
    }
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}`, {"hash":"efc6d08316fc24c1e4ffe6de5a0a922a669444c5"}) as unknown as TypedDocumentString<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>;
export const UpdateCustomerDocument = new TypedDocumentString(`
    mutation updateCustomer($input: CustomerUpdateInput!) {
  updateCustomerV2(input: $input) {
    customer {
      ...Customer
    }
  }
}
    fragment Customer on Customer {
  id
  firstname
  lastname
  middlename
  email
  date_of_birth
  gender
  is_subscribed
  custom_attributes {
    __typename
    code
    ... on AttributeValue {
      value
    }
    ... on AttributeSelectedOptions {
      selected_options {
        label
        value
      }
    }
  }
}`, {"hash":"c41ae85aa979cc609449b34ccff670398e193e90"}) as unknown as TypedDocumentString<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateCustomerAddressDocument = new TypedDocumentString(`
    mutation updateCustomerAddress($id: Int!, $input: CustomerAddressInput) {
  updateCustomerAddress(id: $id, input: $input) {
    city
    telephone
    region {
      region
    }
    street
    custom_attributesV2 {
      code
      ... on AttributeValue {
        value
      }
    }
  }
}
    `, {"hash":"ab4ad454a67083cb4a105eb8ae5f27d129c42ca7"}) as unknown as TypedDocumentString<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;
export const UploadExpertPhotoDocument = new TypedDocumentString(`
    mutation uploadExpertPhoto($input: UploadExpertPhotoInput!) {
  uploadExpertPhoto(input: $input) {
    filename
    url
    success
    message
  }
}
    `, {"hash":"628c0662c920e622e6d11894b08486466d3e55f9"}) as unknown as TypedDocumentString<UploadExpertPhotoMutation, UploadExpertPhotoMutationVariables>;
export const UploadReviewImageDocument = new TypedDocumentString(`
    mutation UploadReviewImage($input: UploadReviewImageInput!) {
  uploadReviewImage(input: $input) {
    filename
    url
    success
    message
  }
}
    `, {"hash":"8ebcab8a139301ccec8e1c04dacfd6d656042753"}) as unknown as TypedDocumentString<UploadReviewImageMutation, UploadReviewImageMutationVariables>;
export const VerifyRegistrationCodeDocument = new TypedDocumentString(`
    mutation verifyRegistrationCode($phone: String!, $code: String!) {
  verifyRegistrationCode(phone: $phone, code: $code)
}
    `, {"hash":"7500335ff7e4ffd51dcbf1e67ed7ac5f635cc572"}) as unknown as TypedDocumentString<VerifyRegistrationCodeMutation, VerifyRegistrationCodeMutationVariables>;
export const GetAcneCabinetsDocument = new TypedDocumentString(`
    query getAcneCabinets($filter: TreatingAcneTogetherFilterInput, $pageSize: Int, $currentPage: Int, $sort: TreatingAcneTogetherSortInput) {
  acneCabinets(
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    items {
      acnecabinet_id
      is_active
      title
      city
      address
      phone_number
      latitude
      longitude
      start_date
      end_date
      doctors {
        is_participant_treating_acne_together
        treating_acne_together_photo
        treating_acne_together_description
        full_name
        seniority
        qualification
        regalia
        photo
      }
    }
    total_count
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"2e102f2da26594bbc533b9941ccc501f2bff6f7a"}) as unknown as TypedDocumentString<GetAcneCabinetsQuery, GetAcneCabinetsQueryVariables>;
export const GetAcneSchoolsDocument = new TypedDocumentString(`
    query getAcneSchools($filter: TreatingAcneTogetherFilterInput, $pageSize: Int, $currentPage: Int, $sort: TreatingAcneTogetherSortInput) {
  acneSchools(
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    items {
      acneschool_id
      is_active
      city
      link
      start_date
      end_date
    }
    total_count
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"1cfa98a9ddb64a79f65bd4426ef2084adb692105"}) as unknown as TypedDocumentString<GetAcneSchoolsQuery, GetAcneSchoolsQueryVariables>;
export const GetAvailablePromoCodesDocument = new TypedDocumentString(`
    query getAvailablePromoCodes {
  availablePromoCodes {
    coupon_code
    name
    description
    available_date
  }
}
    `, {"hash":"81e99bda4973dae1f937fa4b184fff264af3f8ae"}) as unknown as TypedDocumentString<GetAvailablePromoCodesQuery, GetAvailablePromoCodesQueryVariables>;
export const GetBannersDocument = new TypedDocumentString(`
    query getBanners($ids: [ID!], $slug: String) {
  bannerEntities(ids: $ids, slug: $slug) {
    ...Banner
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}`, {"hash":"656eee9ac7f362a2e4ee073414d077ffc09d3810"}) as unknown as TypedDocumentString<GetBannersQuery, GetBannersQueryVariables>;
export const GetBlogCategoriesDocument = new TypedDocumentString(`
    query getBlogCategories($action: String!, $type: String) {
  mpBlogCategories(action: $action, filter: {type: {eq: $type}}) {
    items {
      path
      name
      image
      url_key
      color
      type
    }
  }
}
    `, {"hash":"589a8687bd54c0b2899678cce8edd17741261fe4"}) as unknown as TypedDocumentString<GetBlogCategoriesQuery, GetBlogCategoriesQueryVariables>;
export const GetBlogPostDocument = new TypedDocumentString(`
    query getBlogPost($action: String!, $urlKey: String) {
  mpBlogPosts(action: $action, filter: {url_key: {eq: $urlKey}}) {
    items {
      post_id
      type
      image
      small_image
      categories {
        total_count
        items {
          name
          url_key
          color
          path
        }
      }
      time_to_read
      publish_date
      rating_summary
      best_rating
      qa_page
      topics {
        total_count
        items {
          name
          color
          url_key
          meta_title
          meta_description
          meta_robots
        }
      }
      comments {
        total_count
      }
      text_products {
        index
        items {
          ...Product
        }
      }
      name
      with_doctor
      header_text
      authors {
        is_doctor
        full_name
        photo
        photo_alt
        regalia
        url_key
      }
      meta_title
      meta_description
      meta_robots
      simplecast_code
      video_1
      video_image_1
      video_2
      video_image_2
      video_3
      video_image_3
      video_4
      video_image_4
      video_5
      video_image_5
      text_1
      text_image_1
      text_image_position_1
      text_image_alt_1
      text_image_link_1
      text_2
      text_image_2
      text_image_position_2
      text_image_alt_2
      text_image_link_2
      text_3
      text_image_3
      text_image_position_3
      text_image_alt_3
      text_image_link_3
      text_4
      text_image_4
      text_image_position_4
      text_image_alt_4
      text_image_link_4
      text_5
      text_image_5
      text_image_position_5
      text_image_alt_5
      text_image_link_5
      text_6
      text_image_6
      text_image_position_6
      text_image_alt_6
      text_image_link_6
      text_7
      text_image_7
      text_image_position_7
      text_image_alt_7
      text_image_link_7
      text_8
      text_image_8
      text_image_position_8
      text_image_alt_8
      text_image_link_8
      text_9
      text_image_9
      text_image_position_9
      text_image_alt_9
      text_image_link_9
      text_10
      text_image_10
      text_image_position_10
      text_image_alt_10
      text_image_link_10
      posts(count: 10) {
        total_count
        items {
          post_id
          type
          url_key
          name
          short_description
          image
          with_doctor
          time_to_read
          publish_date
          rating_summary
          small_image
          categories {
            items {
              url_key
              name
              color
            }
          }
          topics {
            items {
              url_key
              color
              name
              meta_title
              meta_description
              meta_robots
            }
          }
          authors {
            is_doctor
            photo
            photo_alt
          }
        }
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"1e0a3cc350a654de073fa608d1763f0c673c5c08"}) as unknown as TypedDocumentString<GetBlogPostQuery, GetBlogPostQueryVariables>;
export const GetBlogPostsDocument = new TypedDocumentString(`
    query getBlogPosts($action: String!, $type: String, $postIds: [String!], $pageSize: Int, $currentPage: Int, $sortBy: PostSortTypeEnum, $categoryKeys: [String!], $topicKey: String, $isMain: String) {
  mpBlogPosts(
    action: $action
    filter: {type: {eq: $type}, post_id: {in: $postIds}, main_article: {eq: $isMain}}
    pageSize: $pageSize
    currentPage: $currentPage
    sortBy: $sortBy
    categoryKeys: $categoryKeys
    topicKey: $topicKey
  ) {
    total_count
    pageInfo {
      pageSize
      currentPage
      hasNextPage
      hasPreviousPage
      startPage
      endPage
    }
    items {
      post_id
      type
      url_key
      name
      short_description
      with_doctor
      image
      small_image
      time_to_read
      publish_date
      rating_summary
      best_rating
      categories {
        items {
          url_key
          name
          color
        }
      }
      comments {
        total_count
      }
      topics {
        items {
          url_key
          color
          name
          meta_title
          meta_description
          meta_robots
        }
      }
      authors {
        is_doctor
        photo
        photo_alt
      }
    }
  }
}
    `, {"hash":"00f758b1d3a22b83c60f3bb7962a6288acf7a58b"}) as unknown as TypedDocumentString<GetBlogPostsQuery, GetBlogPostsQueryVariables>;
export const GetBlogTopicsDocument = new TypedDocumentString(`
    query getBlogTopics($urlKey: String) {
  mpBlogTopics(filter: {url_key: {eq: $urlKey}}) {
    items {
      url_key
      name
      meta_title
      meta_description
      meta_robots
    }
  }
}
    `, {"hash":"e95401590f22a45f6d87cf494df05337c2e0b200"}) as unknown as TypedDocumentString<GetBlogTopicsQuery, GetBlogTopicsQueryVariables>;
export const GetCartDocument = new TypedDocumentString(`
    query getCart($cartId: String!, $cartItemsPageSize: Int!) {
  cart(cart_id: $cartId) {
    ...Cart
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"eacad055a8044bdf61114eaedb1e1a98a0695e06"}) as unknown as TypedDocumentString<GetCartQuery, GetCartQueryVariables>;
export const GetCartIdDocument = new TypedDocumentString(`
    query getCartId($cartId: String!) {
  cart(cart_id: $cartId) {
    id
  }
}
    `, {"hash":"c4050ca8f62a04cf59bb761c8e190be1b12e7b34"}) as unknown as TypedDocumentString<GetCartIdQuery, GetCartIdQueryVariables>;
export const GetCatalogCategoriesDocument = new TypedDocumentString(`
    query getCatalogCategories($filters: CategoryFilterInput) {
  categories(filters: $filters) {
    total_count
    items {
      id
      uid
      level
      image
      name
      h1
      benefits
      breadcrumbs {
        category_id
        category_name
        category_url_key
        category_url_path
      }
      path
      url_key
      url_path
      children_count
      meta_title
      meta_description
      cms_block {
        content
        identifier
        title
      }
      category_banners {
        top_banners {
          entity {
            ...Banner
          }
        }
        sidebar_banners {
          entity {
            ...Banner
          }
        }
        listing_banners {
          entity {
            ...Banner
          }
        }
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}`, {"hash":"1e0e41ae7f31c987e70c4bb146164e0c2218d510"}) as unknown as TypedDocumentString<GetCatalogCategoriesQuery, GetCatalogCategoriesQueryVariables>;
export const GetCategoriesDocument = new TypedDocumentString(`
    query getCategories($filters: CategoryFilterInput, $pageSize: Int, $currentPage: Int) {
  categories(filters: $filters, pageSize: $pageSize, currentPage: $currentPage) {
    total_count
    items {
      uid
      level
      image
      name
      h1
      benefits
      path
      url_key
      url_path
      children_count
    }
    page_info {
      current_page
      page_size
      total_pages
    }
  }
}
    `, {"hash":"f0bcf375c48d73644b92681b71d854dbc5315a9f"}) as unknown as TypedDocumentString<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryListDocument = new TypedDocumentString(`
    query getCategoryList($filters: CategoryFilterInput) {
  categoryList(filters: $filters) {
    uid
    level
    name
    h1
    path
    url_key
    url_path
    children_count
    children {
      uid
      level
      name
      path
      url_key
      url_path
      children_count
    }
  }
}
    `, {"hash":"fd556e4105c877a40de97ac00e77bf5ac1fd75c6"}) as unknown as TypedDocumentString<GetCategoryListQuery, GetCategoryListQueryVariables>;
export const GetCertificateAccountDocument = new TypedDocumentString(`
    query getCertificateAccount($input: CertificateAccountInput!) {
  certificateAccount(input: $input) {
    code
    balance {
      value
      currency
    }
    expiration_date
  }
}
    `, {"hash":"563bebcf68d1b55c40d1cfca929baaf7aaeb748b"}) as unknown as TypedDocumentString<GetCertificateAccountQuery, GetCertificateAccountQueryVariables>;
export const GetCheckoutDocument = new TypedDocumentString(`
    query getCheckout($cartId: String!, $cartItemsPageSize: Int!) {
  cart(cart_id: $cartId) {
    ...Checkout
  }
}
    fragment CartItemCheckout on CartItemInterface {
  id
  quantity
  product {
    __typename
    id
    sku
    name
    url_key
    stockStatus: stock_status
    price: price_range {
      maximum_price {
        final_price {
          currency
          value
        }
      }
    }
    image {
      ...ProductImage
    }
    thumbnail {
      ...ProductImage
    }
    attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
      items {
        ... on AttributeValue {
          code
          value
        }
        ... on AttributeSelectedOptions {
          code
          selected_options {
            label
            value
          }
        }
        ... on AttributeSelectedColorfulOptions {
          code
          selected_options {
            label
            value
            color
            url
          }
        }
      }
    }
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment Checkout on Cart {
  id
  email
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItemCheckout
    }
  }
  shipping_addresses {
    id
    firstname
    lastname
    street
    city
    region {
      code
      label
    }
    postcode
    country {
      code
      label
    }
    telephone
    customer_notes
    pickup_location_code
    pickup_point {
      ...PickupPoint
    }
    selected_shipping_method {
      carrier_code
      method_code
      carrier_title
      method_title
      amount {
        value
        currency
      }
    }
    available_shipping_methods {
      ...ShippingMethod
    }
  }
  available_payment_methods {
    code
    title
  }
  selected_payment_method {
    code
    title
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment PickupPoint on DeliveryAddress {
  id
  nom_code
  name
  address
  city
  region
  phone
  work_time
  latitude
  price
  longitude
  point_type
  type
  day_from
  day_to
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment ShippingMethod on AvailableShippingMethod {
  carrier_code
  carrier_title
  method_code
  method_title
  available
  delivery_date_from
  description
  day_from
  day_to
  available
  amount {
    value
    currency
  }
  price_incl_tax {
    value
    currency
  }
}`, {"hash":"ab9e6760731ae75f6520080d8d2e0995bb45987f"}) as unknown as TypedDocumentString<GetCheckoutQuery, GetCheckoutQueryVariables>;
export const GetCmsBlocksDocument = new TypedDocumentString(`
    query getCmsBlocks($slugs: [String!]!) {
  cmsBlocks(identifiers: $slugs) {
    items {
      content
      identifier
      title
    }
  }
}
    `, {"hash":"eea154ec62794be562edc5aa2596c70cd932cc49"}) as unknown as TypedDocumentString<GetCmsBlocksQuery, GetCmsBlocksQueryVariables>;
export const GetCustomerDocument = new TypedDocumentString(`
    query getCustomer {
  customer {
    ...Customer
  }
}
    fragment Customer on Customer {
  id
  firstname
  lastname
  middlename
  email
  date_of_birth
  gender
  is_subscribed
  custom_attributes {
    __typename
    code
    ... on AttributeValue {
      value
    }
    ... on AttributeSelectedOptions {
      selected_options {
        label
        value
      }
    }
  }
}`, {"hash":"4a59f0fbec332ba38b9e8b067edf2cb82c806529"}) as unknown as TypedDocumentString<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetCustomerAddressesDocument = new TypedDocumentString(`
    query getCustomerAddresses($addressType: AddressTypeEnum!, $pageSize: Int!, $currentPage: Int!) {
  customer {
    addressesV2(
      filter: {type: $addressType}
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        ...Address
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
    }
  }
}
    fragment Address on CustomerAddress {
  city
  firstname
  id
  lastname
  middlename
  postcode
  region {
    region
  }
  country_code
  street
  telephone
  default_shipping
  is_pickup
  center_longitude
  center_latitude
  custom_attributesV2 {
    code
    ... on AttributeValue {
      value
    }
  }
  extension_attributes {
    attribute_code
    value
  }
}`, {"hash":"16420866b89c90e4362685d1198d3d1531bc761f"}) as unknown as TypedDocumentString<GetCustomerAddressesQuery, GetCustomerAddressesQueryVariables>;
export const GetCustomerCartDocument = new TypedDocumentString(`
    query getCustomerCart($cartItemsPageSize: Int!) {
  customerCart {
    ...Cart
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment Cart on Cart {
  id
  itemsV2(pageSize: $cartItemsPageSize) {
    items {
      ...CartItem
    }
  }
  prices {
    grand_total {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
    subtotal_excluding_tax {
      value
      currency
    }
  }
  total_quantity
  shipping_addresses {
    selected_shipping_method {
      amount {
        value
        currency
      }
    }
  }
  applied_coupons {
    code
  }
  certificates_amount {
    value
  }
  applied_certificates {
    code
  }
  total_bonus_points_info {
    available_amount_for_current_cart
    available_amount_total
    earned_amount
    spent_amount_for_current_cart
  }
  free_shipping_by_coupon
}
fragment CartItem on CartItemInterface {
  id
  quantity
  product {
    ...Product
  }
  prices {
    price {
      value
      currency
    }
    row_total {
      value
      currency
    }
    row_total_including_tax {
      value
      currency
    }
    total_item_discount {
      value
      currency
    }
  }
  is_cart_rule_gift
  user_choice_rule_id
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"cf1d84e7f45f0a8b2b556627d32022d0fca51d7d"}) as unknown as TypedDocumentString<GetCustomerCartQuery, GetCustomerCartQueryVariables>;
export const GetCustomerCartIdDocument = new TypedDocumentString(`
    query getCustomerCartId {
  customerCart {
    id
  }
}
    `, {"hash":"b3e3a99abe59168300c18eaa6bfc0a3e2ac7f276"}) as unknown as TypedDocumentString<GetCustomerCartIdQuery, GetCustomerCartIdQueryVariables>;
export const GetCustomerDiagnosticResultsDocument = new TypedDocumentString(`
    query getCustomerDiagnosticResults {
  customer {
    diagnostic_results {
      uid
      created_at
      product_list
    }
  }
}
    `, {"hash":"5fdc25325004971fb513078a3af534965d4fb06c"}) as unknown as TypedDocumentString<GetCustomerDiagnosticResultsQuery, GetCustomerDiagnosticResultsQueryVariables>;
export const GetCustomerWishlistDocument = new TypedDocumentString(`
    query getCustomerWishlist($currentPage: Int, $pageSize: Int) {
  customer {
    wishlists {
      id
      items_v2(currentPage: $currentPage, pageSize: $pageSize) {
        items {
          ...WishlistItem
        }
        page_info {
          current_page
          page_size
          total_pages
        }
      }
      items_count
      sharing_code
      updated_at
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}
fragment WishlistItem on WishlistItemInterface {
  id
  quantity
  added_at
  description
  product {
    ...Product
  }
}`, {"hash":"1c82c3c51d074200a5aad32f6a9dfa1b57b5e880"}) as unknown as TypedDocumentString<GetCustomerWishlistQuery, GetCustomerWishlistQueryVariables>;
export const GetCustomerWishlistIdDocument = new TypedDocumentString(`
    query getCustomerWishlistId {
  customer {
    wishlists(pageSize: 1, currentPage: 1) {
      id
    }
  }
}
    `, {"hash":"417206c4d461cb3bbb4f59e972a9f04d46d99482"}) as unknown as TypedDocumentString<GetCustomerWishlistIdQuery, GetCustomerWishlistIdQueryVariables>;
export const GetDiagnosticDocument = new TypedDocumentString(`
    query getDiagnostic($slug: String!) {
  diagnostic(slug: $slug) {
    entity_id
    slug
    graph
  }
}
    `, {"hash":"b655080c51c89ad958e2d2ce22c7bdd1c619255f"}) as unknown as TypedDocumentString<GetDiagnosticQuery, GetDiagnosticQueryVariables>;
export const GetDiagnosticResultDocument = new TypedDocumentString(`
    query getDiagnosticResult($uid: ID!) {
  diagnosticResult(uid: $uid) {
    uid
    product_list
  }
}
    `, {"hash":"54eb773ede763f4b9a53d877554ff1ef71bb17c8"}) as unknown as TypedDocumentString<GetDiagnosticResultQuery, GetDiagnosticResultQueryVariables>;
export const GetDictionaryDocument = new TypedDocumentString(`
    query getDictionary($identifier: String!) {
  dictionary(identifier: $identifier) {
    code
    label
    position
  }
}
    `, {"hash":"f532e02d9de71d86af0dab16ecf72a288fbe4b3a"}) as unknown as TypedDocumentString<GetDictionaryQuery, GetDictionaryQueryVariables>;
export const GetDoctorByUrlDocument = new TypedDocumentString(`
    query getDoctorByUrl($urlKey: String!) {
  experts(filter: {url_key: {eq: $urlKey}}) {
    items {
      full_name
      entity_id
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      treating_acne_together_photo
      treating_acne_together_description
      taplink
      telegram
      vk
      url_key
      is_participant_treating_acne_together
      content
      meta_title
      meta_description
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
  }
}
    `, {"hash":"e5bfc5e19373abf80838ba9f611c67a4afa2d7f2"}) as unknown as TypedDocumentString<GetDoctorByUrlQuery, GetDoctorByUrlQueryVariables>;
export const GetDoctorCitiesDocument = new TypedDocumentString(`
    query getDoctorCities($filter: ExpertCityFilterInput) {
  expertCities(filter: $filter) {
    city
  }
}
    `, {"hash":"97306f8fac369a30ba2b4734b6a9fc908d4b42e5"}) as unknown as TypedDocumentString<GetDoctorCitiesQuery, GetDoctorCitiesQueryVariables>;
export const GetDoctorsByCitiesDocument = new TypedDocumentString(`
    query getDoctorsByCities($cities: [String!]!, $pageSize: Int, $currentPage: Int, $search: String) {
  experts(
    filter: {city: {in: $cities}, is_doctor: true, is_display_in_find_doctor: true}
    pageSize: $pageSize
    currentPage: $currentPage
    search: $search
  ) {
    total_count
    items {
      full_name
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      url_key
      is_participant_treating_acne_together
      treating_acne_together_photo
      treating_acne_together_description
      content
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"239f8916bc3322d185e508812afa9801a1eb9760"}) as unknown as TypedDocumentString<GetDoctorsByCitiesQuery, GetDoctorsByCitiesQueryVariables>;
export const GetDoctorsByCitiesWithFiltersDocument = new TypedDocumentString(`
    query getDoctorsByCitiesWithFilters($cities: [String!]!, $pageSize: Int, $currentPage: Int, $search: String, $bother: [String!]!) {
  experts(
    filter: {city: {in: $cities}, is_doctor: true, is_display_in_find_doctor: true, bother: {in: $bother}}
    pageSize: $pageSize
    currentPage: $currentPage
    search: $search
  ) {
    total_count
    items {
      full_name
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      url_key
      is_participant_treating_acne_together
      treating_acne_together_photo
      treating_acne_together_description
      content
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"1f97d74cba291e4be3fd8ad554ae982f3d339aac"}) as unknown as TypedDocumentString<GetDoctorsByCitiesWithFiltersQuery, GetDoctorsByCitiesWithFiltersQueryVariables>;
export const GetDoctorsForAcneProjectDocument = new TypedDocumentString(`
    query getDoctorsForAcneProject($city: String, $pageSize: Int, $currentPage: Int) {
  experts(
    filter: {city: {eq: $city}, is_doctor: true, is_participant_treating_acne_together: true}
    pageSize: $pageSize
    currentPage: $currentPage
  ) {
    total_count
    items {
      full_name
      seniority
      qualification
      regalia
      photo
      url_key
      treating_acne_together_photo
      treating_acne_together_description
      content
      clinics {
        name
        address
        telephone
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"c3464069e4b791b779b66a2ad17e952d7ebead3e"}) as unknown as TypedDocumentString<GetDoctorsForAcneProjectQuery, GetDoctorsForAcneProjectQueryVariables>;
export const GetDoctorsForCityDocument = new TypedDocumentString(`
    query getDoctorsForCity($city: String, $pageSize: Int, $currentPage: Int) {
  experts(
    filter: {city: {eq: $city}, is_doctor: true, is_display_in_find_doctor: true}
    pageSize: $pageSize
    currentPage: $currentPage
  ) {
    total_count
    items {
      full_name
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      url_key
      is_participant_treating_acne_together
      treating_acne_together_photo
      treating_acne_together_description
      content
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"afcef6ef4f3521d6b873a6ca7427e2648e44168c"}) as unknown as TypedDocumentString<GetDoctorsForCityQuery, GetDoctorsForCityQueryVariables>;
export const GetDoctorsWithSearchDocument = new TypedDocumentString(`
    query getDoctorsWithSearch($city: String, $pageSize: Int, $currentPage: Int, $search: String) {
  experts(
    filter: {city: {eq: $city}, is_doctor: true, is_display_in_find_doctor: true}
    pageSize: $pageSize
    currentPage: $currentPage
    search: $search
  ) {
    total_count
    items {
      full_name
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      treating_acne_together_photo
      treating_acne_together_description
      url_key
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"1c7da88da85bb0e22342c58b44cbbec225f6dc51"}) as unknown as TypedDocumentString<GetDoctorsWithSearchQuery, GetDoctorsWithSearchQueryVariables>;
export const GetDoctorsWithFiltersDocument = new TypedDocumentString(`
    query getDoctorsWithFilters($city: String, $pageSize: Int, $currentPage: Int, $search: String, $bother: [String]) {
  experts(
    filter: {city: {eq: $city}, is_doctor: true, is_display_in_find_doctor: true, bother: {in: $bother}}
    pageSize: $pageSize
    currentPage: $currentPage
    search: $search
  ) {
    total_count
    items {
      full_name
      city
      bother
      occupation
      seniority
      qualification
      regalia
      photo
      photo_alt
      treating_acne_together_photo
      treating_acne_together_description
      url_key
      is_participant_treating_acne_together
      clinics {
        name
        address
        telephone
        latitude
        longitude
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
    `, {"hash":"2a9afa61ca49e116460a05f2c814767cfc73db50"}) as unknown as TypedDocumentString<GetDoctorsWithFiltersQuery, GetDoctorsWithFiltersQueryVariables>;
export const MenuDocument = new TypedDocumentString(`
    query Menu($identifiers: [String]) {
  snowdogMenus(identifiers: $identifiers) {
    items {
      identifier
      menu_id
      nodes {
        items {
          level
          menu_id
          node_id
          parent_id
          type
          position
          title
          url_key
          classes
        }
      }
    }
  }
}
    `, {"hash":"7a585e4e75c010b109e653bf0ebf21bc5d2d51c0"}) as unknown as TypedDocumentString<MenuQuery, MenuQueryVariables>;
export const GetOrderDocument = new TypedDocumentString(`
    query getOrder($number: String!) {
  customer {
    orders(filter: {number: {eq: $number}}) {
      items {
        ...Order
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Order on CustomerOrder {
  id
  number
  order_date
  delivery_date_from
  delivery_date_actual
  delivery_time
  order_status_change_date
  receipt_url
  payment_timeout
  bonus_earned_amount
  customer_comment
  pickup_address {
    city
    nom_code
    point_type
    work_time
    latitude
    longitude
    address
    phone
  }
  status
  status_code
  email
  carrier
  shipping_method
  gateway_url
  qr_code
  token
  can_be_canceled
  is_virtual
  total {
    base_grand_total {
      value
      currency
    }
    grand_total {
      value
      currency
    }
    subtotal {
      value
      currency
    }
    subtotal_excl_tax {
      value
      currency
    }
    subtotal_incl_tax {
      value
      currency
    }
    total_shipping {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
  }
  shipments {
    tracking {
      number
      carrier
      title
      tracking_url
    }
  }
  shipping_address {
    firstname
    lastname
    street
    city
    postcode
    telephone
    country_code
    comment
  }
  payment_methods {
    name
    type
    additional_data {
      name
      value
    }
  }
  items {
    id
    product_name
    status
    quantity_ordered
    prices {
      original_price_including_tax {
        value
        currency
      }
    }
    product {
      ...Product
    }
    ... on CertificateOrderItem {
      certificate {
        send_date
        design_url
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"9db688e59a185346e801ea338e1bd9a3818a436e"}) as unknown as TypedDocumentString<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = new TypedDocumentString(`
    query getOrders($pageSize: Int = 20, $currentPage: Int = 1, $sort: CustomerOrderSortInput) {
  customer {
    orders(pageSize: $pageSize, currentPage: $currentPage, sort: $sort) {
      items {
        ...Order
      }
      page_info {
        current_page
        page_size
        total_pages
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Order on CustomerOrder {
  id
  number
  order_date
  delivery_date_from
  delivery_date_actual
  delivery_time
  order_status_change_date
  receipt_url
  payment_timeout
  bonus_earned_amount
  customer_comment
  pickup_address {
    city
    nom_code
    point_type
    work_time
    latitude
    longitude
    address
    phone
  }
  status
  status_code
  email
  carrier
  shipping_method
  gateway_url
  qr_code
  token
  can_be_canceled
  is_virtual
  total {
    base_grand_total {
      value
      currency
    }
    grand_total {
      value
      currency
    }
    subtotal {
      value
      currency
    }
    subtotal_excl_tax {
      value
      currency
    }
    subtotal_incl_tax {
      value
      currency
    }
    total_shipping {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
  }
  shipments {
    tracking {
      number
      carrier
      title
      tracking_url
    }
  }
  shipping_address {
    firstname
    lastname
    street
    city
    postcode
    telephone
    country_code
    comment
  }
  payment_methods {
    name
    type
    additional_data {
      name
      value
    }
  }
  items {
    id
    product_name
    status
    quantity_ordered
    prices {
      original_price_including_tax {
        value
        currency
      }
    }
    product {
      ...Product
    }
    ... on CertificateOrderItem {
      certificate {
        send_date
        design_url
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"bbe100c12ba67b783beda3063d717d581870e2fd"}) as unknown as TypedDocumentString<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetPickupPointsByCityDocument = new TypedDocumentString(`
    query getPickupPointsByCity($city: String!, $region: String) {
  getPickupPointsByCity(city: $city, region: $region) {
    ...PickupPoint
  }
}
    fragment PickupPoint on DeliveryAddress {
  id
  nom_code
  name
  address
  city
  region
  phone
  work_time
  latitude
  price
  longitude
  point_type
  type
  day_from
  day_to
}`, {"hash":"c869fe6fbabc52552a5e51994a774432affd50a3"}) as unknown as TypedDocumentString<GetPickupPointsByCityQuery, GetPickupPointsByCityQueryVariables>;
export const GetPostCommentsDocument = new TypedDocumentString(`
    query getPostComments($action: String!, $urlKey: String, $pageSize: Int, $currentPage: Int) {
  mpBlogPosts(action: $action, filter: {url_key: {eq: $urlKey}}) {
    items {
      post_id
      rating_summary
      comments(pageSize: $pageSize, currentPage: $currentPage) {
        total_count
        page_info {
          page_size
          current_page
          total_pages
        }
        items {
          comment_id
          post_id
          rating
          user_name
          content
          created_at
        }
      }
    }
  }
}
    `, {"hash":"290760ddb56331a748a0ac99fddae58abd13daf4"}) as unknown as TypedDocumentString<GetPostCommentsQuery, GetPostCommentsQueryVariables>;
export const GetPostsByAuthorDocument = new TypedDocumentString(`
    query getPostsByAuthor($action: String!, $pageSize: Int, $currentPage: Int, $sortBy: PostSortTypeEnum, $authorId: String) {
  mpBlogPosts(
    action: $action
    filter: {author_id: {finset: [$authorId]}}
    pageSize: $pageSize
    currentPage: $currentPage
    sortBy: $sortBy
  ) {
    total_count
    pageInfo {
      pageSize
      currentPage
      hasNextPage
      hasPreviousPage
      startPage
      endPage
    }
    items {
      post_id
      type
      url_key
      name
      short_description
      with_doctor
      image
      small_image
      time_to_read
      publish_date
      rating_summary
      categories {
        items {
          url_key
          name
          color
        }
      }
      comments {
        total_count
      }
      topics {
        items {
          url_key
          color
          name
          meta_title
          meta_description
          meta_robots
        }
      }
      authors {
        is_doctor
        photo
        photo_alt
      }
    }
  }
}
    `, {"hash":"c22be606eb26ad92d2478643c0c4dde5fab524a4"}) as unknown as TypedDocumentString<GetPostsByAuthorQuery, GetPostsByAuthorQueryVariables>;
export const GetProductBySkuDocument = new TypedDocumentString(`
    query getProductBySku($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      ...Product
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"da6e580e4c618ae0e15da5b5dcbf0ef6bad390d1"}) as unknown as TypedDocumentString<GetProductBySkuQuery, GetProductBySkuQueryVariables>;
export const GetProductCareProgramDocument = new TypedDocumentString(`
    query getProductCareProgram($productId: String!) {
  productSet(urlKey: $productId) {
    program: items {
      ...Product
    }
    total_count
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"61d5499c557fdd735d8974157c1d001773b5724c"}) as unknown as TypedDocumentString<GetProductCareProgramQuery, GetProductCareProgramQueryVariables>;
export const GetProductCatalogDocument = new TypedDocumentString(`
    query getProductCatalog($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    total_count
    search_result_meta {
      zero_queries
      redirect_url
      redirect_mobile_url
    }
    items {
      ...Product
      ...ConfigurableProduct
    }
    page_info {
      page_size
      current_page
      total_pages
    }
    aggregations {
      attribute_code
      position
      label
      count
      care_selection: participates_in_care_selection
      hide_in_side_filters
      options {
        label
        value
        count
        from
        to
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"f23b5dfad02f12e8214067205136e2b1c2ffcf29"}) as unknown as TypedDocumentString<GetProductCatalogQuery, GetProductCatalogQueryVariables>;
export const GetProductCertificatesDocument = new TypedDocumentString(`
    query getProductCertificates {
  productCertificates {
    items {
      name
      gamma
      brand
      certificate
    }
  }
}
    `, {"hash":"abeee81913a40188c3c8672cc198a27374a31530"}) as unknown as TypedDocumentString<GetProductCertificatesQuery, GetProductCertificatesQueryVariables>;
export const GetProductDetailsPageDocument = new TypedDocumentString(`
    query getProductDetailsPage($productId: String!) {
  products(filter: {url_key: {eq: $productId}}) {
    items {
      ...Product
      ...ProductCategories
      reviews(pageSize: 10, currentPage: 1) {
        items {
          ...ProductReview
        }
      }
      questions(pageSize: 10, currentPage: 1) {
        items {
          ...Question
        }
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductCategories on ProductInterface {
  categories {
    id
    url: url_path
    name
    color
    isBrand: is_brand
    level
    breadcrumbs {
      name: category_name
      url: category_url_path
    }
  }
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment ProductReview on ProductReview {
  id
  product {
    name
    sku
    url_key
  }
  summary
  text
  nickname
  created_at
  average_rating
  is_recommended
  age
  skin_type
  skin_problem
  pros
  cons
  is_external
  source
  source_logo
  source_url
  answer
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
    }
  }
  images
  ratings_breakdown {
    name
    value
  }
}
fragment Question on ProductQuestion {
  product_sku
  question
  answer
  customer_name
  age
  email
  skin_type
  skin_problem
  created_at
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
      label
    }
  }
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"f7659002cc035e4d293ca3aade43def1bcf47959"}) as unknown as TypedDocumentString<GetProductDetailsPageQuery, GetProductDetailsPageQueryVariables>;
export const GetProductPostsDocument = new TypedDocumentString(`
    query getProductPosts($sku: String, $postCount: Int) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      sku
      name
      posts(count: $postCount) {
        post_id
        type
        url_key
        name
        short_description
        with_doctor
        image
        small_image
        time_to_read
        publish_date
        rating_summary
        categories {
          items {
            url_key
            name
            color
          }
        }
        topics {
          items {
            url_key
            color
            name
          }
        }
        authors {
          is_doctor
          photo
          photo_alt
        }
      }
    }
  }
}
    `, {"hash":"ebb0726b6aca2e12d345f54796d3bea0cd5074d3"}) as unknown as TypedDocumentString<GetProductPostsQuery, GetProductPostsQueryVariables>;
export const GetProductReviewsDocument = new TypedDocumentString(`
    query getProductReviews($sku: String!) {
  reviewImages(sku: $sku) {
    review_id
    file
  }
  products(filter: {sku: {eq: $sku}}) {
    items {
      recommendation_rate
      rating_summary
      review_count
      question_count
      detailed_rating {
        rating
        percent
      }
      reviews(
        pageSize: 3
        currentPage: 1
        onlyWithImage: false
        sources: ["magento", "www.ozon.ru", "www.wildberries.ru", "irecommend.ru", "otzovik.com", "market.yandex.ru"]
      ) {
        items {
          ...ProductReview
        }
      }
      questions(pageSize: 3, currentPage: 1, sortOrder: DESC) {
        items {
          ...Question
        }
      }
    }
  }
}
    fragment ProductReview on ProductReview {
  id
  product {
    name
    sku
    url_key
  }
  summary
  text
  nickname
  created_at
  average_rating
  is_recommended
  age
  skin_type
  skin_problem
  pros
  cons
  is_external
  source
  source_logo
  source_url
  answer
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
    }
  }
  images
  ratings_breakdown {
    name
    value
  }
}
fragment Question on ProductQuestion {
  product_sku
  question
  answer
  customer_name
  age
  email
  skin_type
  skin_problem
  created_at
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
      label
    }
  }
}`, {"hash":"f41f2f6e35a257437b7137c963bb7d7cdf7dd625"}) as unknown as TypedDocumentString<GetProductReviewsQuery, GetProductReviewsQueryVariables>;
export const GetProductsDocument = new TypedDocumentString(`
    query getProducts($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    total_count
    items {
      ...Product
    }
    page_info {
      page_size
      current_page
      total_pages
    }
    aggregations {
      attribute_code
      count
      label
      options {
        label
        value
        count
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"1c81a93ee2994acf3e1e85f0b14ea8ed15d2502e"}) as unknown as TypedDocumentString<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductsAggregationsDocument = new TypedDocumentString(`
    query getProductsAggregations($search: String, $filter: ProductAttributeFilterInput, $sort: ProductAttributeSortInput) {
  products(search: $search, filter: $filter, sort: $sort) {
    total_count
    aggregations {
      attribute_code
      position
      label
      count
      care_selection: participates_in_care_selection
      hide_in_side_filters
      options {
        label
        value
        count
        from
        to
      }
    }
  }
}
    `, {"hash":"30996a7452461558791a7db3cae16b4a73b8a839"}) as unknown as TypedDocumentString<GetProductsAggregationsQuery, GetProductsAggregationsQueryVariables>;
export const GetProductsCarouselDocument = new TypedDocumentString(`
    query getProductsCarousel($filter: ProductAttributeFilterInput, $pageSize: Int, $sort: ProductAttributeSortInput) {
  products(filter: $filter, pageSize: $pageSize, sort: $sort) {
    total_count
    items {
      ...Product
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"e25ce99dbec32c0e475bf77c4030fb9f9709ee8f"}) as unknown as TypedDocumentString<GetProductsCarouselQuery, GetProductsCarouselQueryVariables>;
export const GetPromotionDetailsByIdDocument = new TypedDocumentString(`
    query getPromotionDetailsById($entity_id: String!) {
  promotions(filter: {entity_id: {eq: $entity_id}}) {
    total_count
    items {
      brand_name
      created_at
      description
      meta_title
      meta_description
      end_date
      entity_id
      erid
      image_desktop
      image_mobile
      is_active
      link
      list_image
      priority
      redirect_code
      relative_url
      start_date
      store_id
      title
      type
      display_enhanced_cashback_widget
      description_after_image
      theme
      description_after
      disclaimer
      category {
        uid
        name
        url
      }
      products {
        ...Product
        ...ConfigurableProduct
      }
    }
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"1080436c72ec35646ed6ff38c48b3a1880f4908a"}) as unknown as TypedDocumentString<GetPromotionDetailsByIdQuery, GetPromotionDetailsByIdQueryVariables>;
export const GetPromotionsDocument = new TypedDocumentString(`
    query getPromotions($filter: PromotionFilterInput, $pageSize: Int, $currentPage: Int) {
  promotions(filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
    total_count
    items {
      brand_name
      description
      end_date
      entity_id
      erid
      is_active
      link
      title
      type
      list_image
      promo_type {
        code
        label
      }
    }
    page_info {
      current_page
      page_size
      total_pages
    }
  }
}
    `, {"hash":"88a865fd28b70103c12c5d75f293583c26276ccc"}) as unknown as TypedDocumentString<GetPromotionsQuery, GetPromotionsQueryVariables>;
export const GetQuestionsByPageDocument = new TypedDocumentString(`
    query getQuestionsByPage($sku: String!, $page: Int!, $sortOrder: SortEnum!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      question_count
      questions(pageSize: 10, currentPage: $page, sortOrder: $sortOrder) {
        items {
          ...Question
        }
      }
    }
  }
}
    fragment Question on ProductQuestion {
  product_sku
  question
  answer
  customer_name
  age
  email
  skin_type
  skin_problem
  created_at
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
      label
    }
  }
}`, {"hash":"3a5308abb2a2d3b47cb8bbc392edd716d9db326a"}) as unknown as TypedDocumentString<GetQuestionsByPageQuery, GetQuestionsByPageQueryVariables>;
export const GetRatingsDocument = new TypedDocumentString(`
    query getRatings {
  productReviewRatingsMetadata {
    items {
      id
      name
      values {
        value_id
        value
      }
    }
  }
}
    `, {"hash":"44d4836492c9e541aefd840026ce76bdc862a3ae"}) as unknown as TypedDocumentString<GetRatingsQuery, GetRatingsQueryVariables>;
export const ReviewDocument = new TypedDocumentString(`
    query review($id: ID!) {
  review(id: $id) {
    ...ProductReview
  }
}
    fragment ProductReview on ProductReview {
  id
  product {
    name
    sku
    url_key
  }
  summary
  text
  nickname
  created_at
  average_rating
  is_recommended
  age
  skin_type
  skin_problem
  pros
  cons
  is_external
  source
  source_logo
  source_url
  answer
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
    }
  }
  images
  ratings_breakdown {
    name
    value
  }
}`, {"hash":"45b0469bd7eb87e0ce98a25337b023ecc8ed6c9d"}) as unknown as TypedDocumentString<ReviewQuery, ReviewQueryVariables>;
export const GetReviewsByPageDocument = new TypedDocumentString(`
    query getReviewsByPage($sku: String!, $page: Int!, $sources: [String!], $onlyWithImage: Boolean, $rating: Int) {
  reviewImages(sku: $sku) {
    review_id
    file
  }
  products(filter: {sku: {eq: $sku}}) {
    items {
      recommendation_rate
      rating_summary
      review_count
      detailed_rating {
        rating
        percent
      }
      reviews(
        pageSize: 10
        currentPage: $page
        sources: $sources
        onlyWithImage: $onlyWithImage
        rating: $rating
      ) {
        items {
          ...ProductReview
        }
        page_info {
          current_page
          total_pages
        }
      }
    }
  }
}
    fragment ProductReview on ProductReview {
  id
  product {
    name
    sku
    url_key
  }
  summary
  text
  nickname
  created_at
  average_rating
  is_recommended
  age
  skin_type
  skin_problem
  pros
  cons
  is_external
  source
  source_logo
  source_url
  answer
  answer_product {
    name
    sku
    url_key
    thumbnail {
      url
    }
  }
  images
  ratings_breakdown {
    name
    value
  }
}`, {"hash":"de3fcaec1cd15fb4cef09f4cda48525b4d0d3f2e"}) as unknown as TypedDocumentString<GetReviewsByPageQuery, GetReviewsByPageQueryVariables>;
export const GetRouteDocument = new TypedDocumentString(`
    query getRoute($url: String!) {
  route(url: $url) {
    redirect_code
    relative_url
  }
  seoParams(url: $url) {
    canonical
    meta_description
    meta_title
    h1
  }
}
    `, {"hash":"fd08bf0e01bfd994025850f4b98cca6578630775"}) as unknown as TypedDocumentString<GetRouteQuery, GetRouteQueryVariables>;
export const GetSecureOrderInfoDocument = new TypedDocumentString(`
    query getSecureOrderInfo($orderNumber: String!, $token: String!) {
  secureOrder(orderNumber: $orderNumber, token: $token) {
    ...Order
  }
}
    fragment Banner on BannerEntity {
  id
  slug
  show_from
  show_to
  device_type
  entity_type
  banner_type
  children
  banner_data {
    display_type
    slides_to_display
    slides_to_display_tablet
    slides_to_display_mobile
    slides_to_scroll
    slides_to_scroll_tablet
    slides_to_scroll_mobile
    slide_speed
    lazy_load
    size
    background_color
    title
    show_all_link
    discount_label
    first_link
    first_link_label
    first_link_new_tab
    second_link
    second_link_label
    second_link_new_tab
    disclaimer_text
    erid
    button_display
    button_text
    button_position
    desktop_image
    desktop_image_alt
    tablet_image
    tablet_image_alt
    mobile_image
    mobile_image_alt
    large_text
    small_text
    counter
    banner_link
    erid
    open_in_new_tab
    height
    width
    theme
    text_position
    footnote
    desktop_video
    tablet_video
    mobile_video
    information
    information_second_line
    pdp_position
    highlight_with_color
  }
}
fragment ConfigurableProduct on ConfigurableProduct {
  ... on ConfigurableProduct {
    variants {
      attributes {
        code
        label
      }
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment GroupedProduct on GroupedProduct {
  ... on GroupedProduct {
    groupType: group_type
    items {
      position
      product {
        ...SimpleProduct
      }
    }
  }
}
fragment Order on CustomerOrder {
  id
  number
  order_date
  delivery_date_from
  delivery_date_actual
  delivery_time
  order_status_change_date
  receipt_url
  payment_timeout
  bonus_earned_amount
  customer_comment
  pickup_address {
    city
    nom_code
    point_type
    work_time
    latitude
    longitude
    address
    phone
  }
  status
  status_code
  email
  carrier
  shipping_method
  gateway_url
  qr_code
  token
  can_be_canceled
  is_virtual
  total {
    base_grand_total {
      value
      currency
    }
    grand_total {
      value
      currency
    }
    subtotal {
      value
      currency
    }
    subtotal_excl_tax {
      value
      currency
    }
    subtotal_incl_tax {
      value
      currency
    }
    total_shipping {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
      label
    }
  }
  shipments {
    tracking {
      number
      carrier
      title
      tracking_url
    }
  }
  shipping_address {
    firstname
    lastname
    street
    city
    postcode
    telephone
    country_code
    comment
  }
  payment_methods {
    name
    type
    additional_data {
      name
      value
    }
  }
  items {
    id
    product_name
    status
    quantity_ordered
    prices {
      original_price_including_tax {
        value
        currency
      }
    }
    product {
      ...Product
    }
    ... on CertificateOrderItem {
      certificate {
        send_date
        design_url
      }
    }
  }
}
fragment Product on ProductInterface {
  __typename
  id
  sku
  sku_history
  name
  url_key
  image {
    ...ProductImage
  }
  ...SimpleProduct
  ...ConfigurableProduct
  ...GroupedProduct
}
fragment ProductImage on ProductImage {
  src: url
  alt: label
}
fragment SimpleProduct on ProductInterface {
  __typename
  sku
  mindbox_id
  url_key
  ratingSummary: rating_summary
  detailedRating: detailed_rating {
    rating
    percent
  }
  certificate
  stockStatus: stock_status
  reviewCount: review_count
  meta_description
  meta_title
  special_price
  only_x_left_in_stock
  earned_bonus_percent
  description_html
  ingredients
  price: price_range {
    maximum_price {
      final_price {
        currency
        value
      }
    }
  }
  image {
    ...ProductImage
  }
  thumbnail {
    ...ProductImage
  }
  mediaGallery: media_gallery {
    __typename
    position
    url
    label
    disabled
    ... on ProductImage {
      types
    }
  }
  banners: product_banners {
    position
    entity {
      ...Banner
    }
  }
  attributes: custom_attributesV2(filters: {is_visible_on_front: true}) {
    items {
      ... on AttributeValue {
        code
        value
      }
      ... on AttributeSelectedOptions {
        code
        selected_options {
          label
          value
        }
      }
      ... on AttributeSelectedColorfulOptions {
        code
        selected_options {
          label
          value
          color
          url
        }
      }
    }
  }
}`, {"hash":"aa574fb835870cb957acbbf208c43c53538d214b"}) as unknown as TypedDocumentString<GetSecureOrderInfoQuery, GetSecureOrderInfoQueryVariables>;
export const GetShippingMethodsDocument = new TypedDocumentString(`
    query getShippingMethods($city: String!) {
  getShippingMethods(city: $city) {
    ...ShippingMethod
  }
}
    fragment ShippingMethod on AvailableShippingMethod {
  carrier_code
  carrier_title
  method_code
  method_title
  available
  delivery_date_from
  description
  day_from
  day_to
  available
  amount {
    value
    currency
  }
  price_incl_tax {
    value
    currency
  }
}`, {"hash":"591298fb00bd4c6f182d80da7d519b2875a0c8c8"}) as unknown as TypedDocumentString<GetShippingMethodsQuery, GetShippingMethodsQueryVariables>;
export const StoreConfigDocument = new TypedDocumentString(`
    query storeConfig {
  storeConfig {
    copyright
    default_title
    store_name
    store_ogrn
    store_city
    store_region
    store_schedule
    store_street
    header_logo_src
    recipient_email
    call_center_hours
    store_telephone
    store_vat_number
    store_zip_code
    store_country
    store_code
    payments_company_name
    payments_company_vat_number
    payments_company_street
    payments_company_city
    payments_company_region
    payments_company_ogrn
    payments_company_zip_code
    second_payments_company_name
    second_payments_company_vat_number
    second_payments_company_street
    second_payments_company_city
    second_payments_company_region
    second_payments_company_ogrn
    second_payments_company_zip_code
    free_shipping_sum
    mindbox_customer_id_prefix
    advertising_warning_text
    search_suggestion_limit
    cookie_restriction_enabled
  }
}
    `, {"hash":"ffdfdd0b7c0ea93b87907da3c963607b49557283"}) as unknown as TypedDocumentString<StoreConfigQuery, StoreConfigQueryVariables>;
export const StoresDocument = new TypedDocumentString(`
    query Stores($city: String!) {
  stores(city: {eq: $city}) {
    name
    latitude
    longitude
    street
    brand
    store_id
  }
}
    `, {"hash":"076e7d71adcca72166d7fd3a616a14bdd29c4153"}) as unknown as TypedDocumentString<StoresQuery, StoresQueryVariables>;
export const GetThresholdedRulesDocument = new TypedDocumentString(`
    query getThresholdedRules($cart_id: String!) {
  getThresholdedRules(cart_id: $cart_id) {
    rules {
      rule_id
      description
      minimal_total
      is_reached
      image
    }
  }
}
    `, {"hash":"5a460e3994e5e4dadd5873fdf12bfb052d1bbe42"}) as unknown as TypedDocumentString<GetThresholdedRulesQuery, GetThresholdedRulesQueryVariables>;
export const GetUserChoiceRulesDocument = new TypedDocumentString(`
    query getUserChoiceRules($cart_id: String!) {
  getUserChoiceRules(cart_id: $cart_id) {
    rules {
      rule_id
      selected_gifts_qty
      max_gifts_qty
    }
    products_skus
  }
}
    `, {"hash":"edec0e39b4574d67beda25b91b08a3156f774cc0"}) as unknown as TypedDocumentString<GetUserChoiceRulesQuery, GetUserChoiceRulesQueryVariables>;
export const IsValidCartIdDocument = new TypedDocumentString(`
    query isValidCartId($cartId: String!) {
  isValidQuote(cart_id: $cartId) {
    is_valid
    message
  }
}
    `, {"hash":"74b124fb4800b0b24bc7b6215d1da949656ff047"}) as unknown as TypedDocumentString<IsValidCartIdQuery, IsValidCartIdQueryVariables>;